const v = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, B = globalThis, ft = "10.20.0";
function St() {
  return hr(B), B;
}
function hr(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || ft, t[ft] = t[ft] || {};
}
function Ut(e, t, n = B) {
  const r = n.__SENTRY__ = n.__SENTRY__ || {}, s = r[ft] = r[ft] || {};
  return s[e] || (s[e] = t());
}
const xu = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Mu = "Sentry Logger ", Kn = {};
function Ve(e) {
  if (!("console" in B))
    return e();
  const t = B.console, n = {}, r = Object.keys(Kn);
  r.forEach((s) => {
    const i = Kn[s];
    n[s] = t[s], t[s] = i;
  });
  try {
    return e();
  } finally {
    r.forEach((s) => {
      t[s] = n[s];
    });
  }
}
function Au() {
  ks().enabled = !0;
}
function Ou() {
  ks().enabled = !1;
}
function Qo() {
  return ks().enabled;
}
function Nu(...e) {
  ws("log", ...e);
}
function Du(...e) {
  ws("warn", ...e);
}
function Lu(...e) {
  ws("error", ...e);
}
function ws(e, ...t) {
  v && Qo() && Ve(() => {
    B.console[e](`${Mu}[${e}]:`, ...t);
  });
}
function ks() {
  return v ? Ut("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
const _ = {
  /** Enable logging. */
  enable: Au,
  /** Disable logging. */
  disable: Ou,
  /** Check if logging is enabled. */
  isEnabled: Qo,
  /** Log a message. */
  log: Nu,
  /** Log a warning. */
  warn: Du,
  /** Log an error. */
  error: Lu
}, Zo = 50, gt = "?", yi = /\(error: (.*)\)/, Si = /captureMessage|captureException/;
function ea(...e) {
  const t = e.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0, s = 0) => {
    const i = [], o = n.split(`
`);
    for (let c = r; c < o.length; c++) {
      let a = o[c];
      a.length > 1024 && (a = a.slice(0, 1024));
      const u = yi.test(a) ? a.replace(yi, "$1") : a;
      if (!u.match(/\S*Error: /)) {
        for (const l of t) {
          const d = l(u);
          if (d) {
            i.push(d);
            break;
          }
        }
        if (i.length >= Zo + s)
          break;
      }
    }
    return Fu(i.slice(s));
  };
}
function Pu(e) {
  return Array.isArray(e) ? ea(...e) : e;
}
function Fu(e) {
  if (!e.length)
    return [];
  const t = Array.from(e);
  return /sentryWrapped/.test(Cn(t).function || "") && t.pop(), t.reverse(), Si.test(Cn(t).function || "") && (t.pop(), Si.test(Cn(t).function || "") && t.pop()), t.slice(0, Zo).map((n) => ({
    ...n,
    filename: n.filename || Cn(t).filename,
    function: n.function || gt
  }));
}
function Cn(e) {
  return e[e.length - 1] || {};
}
const Mr = "<anonymous>";
function He(e) {
  try {
    return !e || typeof e != "function" ? Mr : e.name || Mr;
  } catch {
    return Mr;
  }
}
function Ei(e) {
  const t = e.exception;
  if (t) {
    const n = [];
    try {
      return t.values.forEach((r) => {
        r.stacktrace.frames && n.push(...r.stacktrace.frames);
      }), n;
    } catch {
      return;
    }
  }
}
const Un = {}, bi = {};
function nt(e, t) {
  Un[e] = Un[e] || [], Un[e].push(t);
}
function rt(e, t) {
  if (!bi[e]) {
    bi[e] = !0;
    try {
      t();
    } catch (n) {
      v && _.error(`Error while instrumenting ${e}`, n);
    }
  }
}
function Ie(e, t) {
  const n = e && Un[e];
  if (n)
    for (const r of n)
      try {
        r(t);
      } catch (s) {
        v && _.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${He(r)}
Error:`,
          s
        );
      }
}
let Ar = null;
function ta(e) {
  const t = "error";
  nt(t, e), rt(t, $u);
}
function $u() {
  Ar = B.onerror, B.onerror = function(e, t, n, r, s) {
    return Ie("error", {
      column: r,
      error: s,
      line: n,
      msg: e,
      url: t
    }), Ar ? Ar.apply(this, arguments) : !1;
  }, B.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Or = null;
function na(e) {
  const t = "unhandledrejection";
  nt(t, e), rt(t, Bu);
}
function Bu() {
  Or = B.onunhandledrejection, B.onunhandledrejection = function(e) {
    return Ie("unhandledrejection", e), Or ? Or.apply(this, arguments) : !0;
  }, B.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const ra = Object.prototype.toString;
function Rs(e) {
  switch (ra.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return We(e, Error);
  }
}
function Ht(e, t) {
  return ra.call(e) === `[object ${t}]`;
}
function sa(e) {
  return Ht(e, "ErrorEvent");
}
function vi(e) {
  return Ht(e, "DOMError");
}
function Uu(e) {
  return Ht(e, "DOMException");
}
function Fe(e) {
  return Ht(e, "String");
}
function Cs(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function Mt(e) {
  return e === null || Cs(e) || typeof e != "object" && typeof e != "function";
}
function on(e) {
  return Ht(e, "Object");
}
function mr(e) {
  return typeof Event < "u" && We(e, Event);
}
function Hu(e) {
  return typeof Element < "u" && We(e, Element);
}
function Wu(e) {
  return Ht(e, "RegExp");
}
function Wt(e) {
  return !!(e?.then && typeof e.then == "function");
}
function ju(e) {
  return on(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function We(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function ia(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
function oa(e) {
  return typeof Request < "u" && We(e, Request);
}
const xs = B, zu = 80;
function ke(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let n = e;
    const r = 5, s = [];
    let i = 0, o = 0;
    const c = " > ", a = c.length;
    let u;
    const l = Array.isArray(t) ? t : t.keyAttrs, d = !Array.isArray(t) && t.maxStringLength || zu;
    for (; n && i++ < r && (u = qu(n, l), !(u === "html" || i > 1 && o + s.length * a + u.length >= d)); )
      s.push(u), o += u.length, n = n.parentNode;
    return s.reverse().join(c);
  } catch {
    return "<unknown>";
  }
}
function qu(e, t) {
  const n = e, r = [];
  if (!n?.tagName)
    return "";
  if (xs.HTMLElement && n instanceof HTMLElement && n.dataset) {
    if (n.dataset.sentryComponent)
      return n.dataset.sentryComponent;
    if (n.dataset.sentryElement)
      return n.dataset.sentryElement;
  }
  r.push(n.tagName.toLowerCase());
  const s = t?.length ? t.filter((o) => n.getAttribute(o)).map((o) => [o, n.getAttribute(o)]) : null;
  if (s?.length)
    s.forEach((o) => {
      r.push(`[${o[0]}="${o[1]}"]`);
    });
  else {
    n.id && r.push(`#${n.id}`);
    const o = n.className;
    if (o && Fe(o)) {
      const c = o.split(/\s+/);
      for (const a of c)
        r.push(`.${a}`);
    }
  }
  const i = ["aria-label", "type", "name", "title", "alt"];
  for (const o of i) {
    const c = n.getAttribute(o);
    c && r.push(`[${o}="${c}"]`);
  }
  return r.join("");
}
function jt() {
  try {
    return xs.document.location.href;
  } catch {
    return "";
  }
}
function aa(e) {
  if (!xs.HTMLElement)
    return null;
  let t = e;
  const n = 5;
  for (let r = 0; r < n; r++) {
    if (!t)
      return null;
    if (t instanceof HTMLElement) {
      if (t.dataset.sentryComponent)
        return t.dataset.sentryComponent;
      if (t.dataset.sentryElement)
        return t.dataset.sentryElement;
    }
    t = t.parentNode;
  }
  return null;
}
function Xn(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function Ti(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    try {
      ia(s) ? n.push("[VueViewModel]") : n.push(String(s));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function Hn(e, t, n = !1) {
  return Fe(e) ? Wu(t) ? t.test(e) : Fe(t) ? n ? e === t : e.includes(t) : !1 : !1;
}
function $e(e, t = [], n = !1) {
  return t.some((r) => Hn(e, r, n));
}
function ge(e, t, n) {
  if (!(t in e))
    return;
  const r = e[t];
  if (typeof r != "function")
    return;
  const s = n(r);
  typeof s == "function" && ca(s, r);
  try {
    e[t] = s;
  } catch {
    v && _.log(`Failed to replace method "${t}" in object`, e);
  }
}
function be(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    v && _.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function ca(e, t) {
  try {
    const n = t.prototype || {};
    e.prototype = t.prototype = n, be(e, "__sentry_original__", t);
  } catch {
  }
}
function Ms(e) {
  return e.__sentry_original__;
}
function ua(e) {
  if (Rs(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...wi(e)
    };
  if (mr(e)) {
    const t = {
      type: e.type,
      target: Ii(e.target),
      currentTarget: Ii(e.currentTarget),
      ...wi(e)
    };
    return typeof CustomEvent < "u" && We(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function Ii(e) {
  try {
    return Hu(e) ? ke(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function wi(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  } else
    return {};
}
function Vu(e, t = 40) {
  const n = Object.keys(ua(e));
  n.sort();
  const r = n[0];
  if (!r)
    return "[object has no keys]";
  if (r.length >= t)
    return Xn(r, t);
  for (let s = n.length; s > 0; s--) {
    const i = n.slice(0, s).join(", ");
    if (!(i.length > t))
      return s === n.length ? i : Xn(i, t);
  }
  return "";
}
function Gu() {
  const e = B;
  return e.crypto || e.msCrypto;
}
function Ee(e = Gu()) {
  let t = () => Math.random() * 16;
  try {
    if (e?.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e?.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
function da(e) {
  return e.exception?.values?.[0];
}
function ut(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const r = da(e);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function Xr(e, t, n) {
  const r = e.exception = e.exception || {}, s = r.values = r.values || [], i = s[0] = s[0] || {};
  i.value || (i.value = t || ""), i.type || (i.type = "Error");
}
function At(e, t) {
  const n = da(e);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, s = n.mechanism;
  if (n.mechanism = { ...r, ...s, ...t }, t && "data" in t) {
    const i = { ...s?.data, ...t.data };
    n.mechanism.data = i;
  }
}
function ki(e) {
  if (Yu(e))
    return !0;
  try {
    be(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function Yu(e) {
  try {
    return e.__sentry_captured__;
  } catch {
  }
}
const la = 1e3;
function Et() {
  return Date.now() / la;
}
function Ku() {
  const { performance: e } = B;
  if (!e?.now || !e.timeOrigin)
    return Et;
  const t = e.timeOrigin;
  return () => (t + e.now()) / la;
}
let Ri;
function oe() {
  return (Ri ?? (Ri = Ku()))();
}
let Nr;
function Xu() {
  const { performance: e } = B;
  if (!e?.now)
    return [void 0, "none"];
  const t = 3600 * 1e3, n = e.now(), r = Date.now(), s = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, i = s < t, o = e.timing?.navigationStart, a = typeof o == "number" ? Math.abs(o + n - r) : t, u = a < t;
  return i || u ? s <= a ? [e.timeOrigin, "timeOrigin"] : [o, "navigationStart"] : [r, "dateNow"];
}
function ye() {
  return Nr || (Nr = Xu()), Nr[0];
}
function Ju(e) {
  const t = oe(), n = {
    sid: Ee(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => Zu(n)
  };
  return e && Ot(n, e), n;
}
function Ot(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || oe(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Ee()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function Qu(e, t) {
  let n = {};
  e.status === "ok" && (n = { status: "exited" }), Ot(e, n);
}
function Zu(e) {
  return {
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  };
}
function mn(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && Object.keys(t).length === 0)
    return e;
  const r = { ...e };
  for (const s in t)
    Object.prototype.hasOwnProperty.call(t, s) && (r[s] = mn(r[s], t[s], n - 1));
  return r;
}
function je() {
  return Ee();
}
function Be() {
  return Ee().substring(16);
}
const Jr = "_sentrySpan";
function Nt(e, t) {
  t ? be(e, Jr, t) : delete e[Jr];
}
function Jn(e) {
  return e[Jr];
}
const ed = 100;
class Ne {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: je(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const t = new Ne();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, Nt(t, Jn(this)), t;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Ot(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, r = n instanceof Ne ? n.getScopeData() : on(n) ? t : void 0, { tags: s, extra: i, user: o, contexts: c, level: a, fingerprint: u = [], propagationContext: l } = r || {};
    return this._tags = { ...this._tags, ...s }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...c }, o && Object.keys(o).length && (this._user = o), a && (this._level = a), u.length && (this._fingerprint = u), l && (this._propagationContext = l), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, Nt(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: je(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : ed;
    if (r <= 0)
      return this;
    const s = {
      timestamp: Et(),
      ...t,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: t.message ? Xn(t.message, 2048) : t.message
    };
    return this._breadcrumbs.push(s), this._breadcrumbs.length > r && (this._breadcrumbs = this._breadcrumbs.slice(-r), this._client?.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Jn(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = mn(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(t, n) {
    const r = n?.event_id || Ee();
    if (!this._client)
      return v && _.warn("No client configured on scope - will not capture exception!"), r;
    const s = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: s,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(t, n, r) {
    const s = r?.event_id || Ee();
    if (!this._client)
      return v && _.warn("No client configured on scope - will not capture message!"), s;
    const i = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: i,
        ...r,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(t, n) {
    const r = n?.event_id || Ee();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: r }, this), r) : (v && _.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function td() {
  return Ut("defaultCurrentScope", () => new Ne());
}
function nd() {
  return Ut("defaultIsolationScope", () => new Ne());
}
class rd {
  constructor(t, n) {
    let r;
    t ? r = t : r = new Ne();
    let s;
    n ? s = n : s = new Ne(), this._stack = [{ scope: r }], this._isolationScope = s;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let r;
    try {
      r = t(n);
    } catch (s) {
      throw this._popScope(), s;
    }
    return Wt(r) ? r.then(
      (s) => (this._popScope(), s),
      (s) => {
        throw this._popScope(), s;
      }
    ) : (this._popScope(), r);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Dt() {
  const e = St(), t = hr(e);
  return t.stack = t.stack || new rd(td(), nd());
}
function sd(e) {
  return Dt().withScope(e);
}
function id(e, t) {
  const n = Dt();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function Ci(e) {
  return Dt().withScope(() => e(Dt().getIsolationScope()));
}
function od() {
  return {
    withIsolationScope: Ci,
    withScope: sd,
    withSetScope: id,
    withSetIsolationScope: (e, t) => Ci(t),
    getCurrentScope: () => Dt().getScope(),
    getIsolationScope: () => Dt().getIsolationScope()
  };
}
function zt(e) {
  const t = hr(e);
  return t.acs ? t.acs : od();
}
function G() {
  const e = St();
  return zt(e).getCurrentScope();
}
function De() {
  const e = St();
  return zt(e).getIsolationScope();
}
function ad() {
  return Ut("globalScope", () => new Ne());
}
function gr(...e) {
  const t = St(), n = zt(t);
  if (e.length === 2) {
    const [r, s] = e;
    return r ? n.withSetScope(r, s) : n.withScope(s);
  }
  return n.withScope(e[0]);
}
function U() {
  return G().getClient();
}
function cd(e) {
  const t = e.getPropagationContext(), { traceId: n, parentSpanId: r, propagationSpanId: s } = t, i = {
    trace_id: n,
    span_id: s || Be()
  };
  return r && (i.parent_span_id = r), i;
}
const _e = "sentry.source", As = "sentry.sample_rate", fa = "sentry.previous_trace_sample_rate", ze = "sentry.op", ne = "sentry.origin", an = "sentry.idle_span_finish_reason", gn = "sentry.measurement_unit", _n = "sentry.measurement_value", xi = "sentry.custom_span_name", Os = "sentry.profile_id", qt = "sentry.exclusive_time", ud = "sentry.link.type", dd = 0, pa = 1, ce = 2;
function ld(e) {
  if (e < 400 && e >= 100)
    return { code: pa };
  if (e >= 400 && e < 500)
    switch (e) {
      case 401:
        return { code: ce, message: "unauthenticated" };
      case 403:
        return { code: ce, message: "permission_denied" };
      case 404:
        return { code: ce, message: "not_found" };
      case 409:
        return { code: ce, message: "already_exists" };
      case 413:
        return { code: ce, message: "failed_precondition" };
      case 429:
        return { code: ce, message: "resource_exhausted" };
      case 499:
        return { code: ce, message: "cancelled" };
      default:
        return { code: ce, message: "invalid_argument" };
    }
  if (e >= 500 && e < 600)
    switch (e) {
      case 501:
        return { code: ce, message: "unimplemented" };
      case 503:
        return { code: ce, message: "unavailable" };
      case 504:
        return { code: ce, message: "deadline_exceeded" };
      default:
        return { code: ce, message: "internal_error" };
    }
  return { code: ce, message: "unknown_error" };
}
function ha(e, t) {
  e.setAttribute("http.response.status_code", t);
  const n = ld(t);
  n.message !== "unknown_error" && e.setStatus(n);
}
const ma = "_sentryScope", ga = "_sentryIsolationScope";
function fd(e) {
  try {
    const t = B.WeakRef;
    if (typeof t == "function")
      return new t(e);
  } catch {
  }
  return e;
}
function pd(e) {
  if (e) {
    if (typeof e == "object" && "deref" in e && typeof e.deref == "function")
      try {
        return e.deref();
      } catch {
        return;
      }
    return e;
  }
}
function hd(e, t, n) {
  e && (be(e, ga, fd(n)), be(e, ma, t));
}
function Qn(e) {
  const t = e;
  return {
    scope: t[ma],
    isolationScope: pd(t[ga])
  };
}
const Ns = "sentry-", md = /^sentry-/, gd = 8192;
function _a(e) {
  const t = yd(e);
  if (!t)
    return;
  const n = Object.entries(t).reduce((r, [s, i]) => {
    if (s.match(md)) {
      const o = s.slice(Ns.length);
      r[o] = i;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function _d(e) {
  if (!e)
    return;
  const t = Object.entries(e).reduce(
    (n, [r, s]) => (s && (n[`${Ns}${r}`] = s), n),
    {}
  );
  return Sd(t);
}
function yd(e) {
  if (!(!e || !Fe(e) && !Array.isArray(e)))
    return Array.isArray(e) ? e.reduce((t, n) => {
      const r = Mi(n);
      return Object.entries(r).forEach(([s, i]) => {
        t[s] = i;
      }), t;
    }, {}) : Mi(e);
}
function Mi(e) {
  return e.split(",").map((t) => {
    const n = t.indexOf("=");
    if (n === -1)
      return [];
    const r = t.slice(0, n), s = t.slice(n + 1);
    return [r, s].map((i) => {
      try {
        return decodeURIComponent(i.trim());
      } catch {
        return;
      }
    });
  }).reduce((t, [n, r]) => (n && r && (t[n] = r), t), {});
}
function Sd(e) {
  if (Object.keys(e).length !== 0)
    return Object.entries(e).reduce((t, [n, r], s) => {
      const i = `${encodeURIComponent(n)}=${encodeURIComponent(r)}`, o = s === 0 ? i : `${t},${i}`;
      return o.length > gd ? (v && _.warn(
        `Not adding key: ${n} with val: ${r} to baggage header due to exceeding baggage size limits.`
      ), t) : o;
    }, "");
}
const Ed = /^o(\d+)\./, bd = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function vd(e) {
  return e === "http" || e === "https";
}
function Vt(e, t = !1) {
  const { host: n, path: r, pass: s, port: i, projectId: o, protocol: c, publicKey: a } = e;
  return `${c}://${a}${t && s ? `:${s}` : ""}@${n}${i ? `:${i}` : ""}/${r && `${r}/`}${o}`;
}
function Td(e) {
  const t = bd.exec(e);
  if (!t) {
    Ve(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [n, r, s = "", i = "", o = "", c = ""] = t.slice(1);
  let a = "", u = c;
  const l = u.split("/");
  if (l.length > 1 && (a = l.slice(0, -1).join("/"), u = l.pop()), u) {
    const d = u.match(/^\d+/);
    d && (u = d[0]);
  }
  return ya({ host: i, pass: s, path: a, projectId: u, port: o, protocol: n, publicKey: r });
}
function ya(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function Id(e) {
  if (!v)
    return !0;
  const { port: t, projectId: n, protocol: r } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((o) => e[o] ? !1 : (_.error(`Invalid Sentry Dsn: ${o} missing`), !0)) ? !1 : n.match(/^\d+$/) ? vd(r) ? t && isNaN(parseInt(t, 10)) ? (_.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1) : !0 : (_.error(`Invalid Sentry Dsn: Invalid protocol ${r}`), !1) : (_.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function wd(e) {
  return e.match(Ed)?.[1];
}
function kd(e) {
  const t = e.getOptions(), { host: n } = e.getDsn() || {};
  let r;
  return t.orgId ? r = String(t.orgId) : n && (r = wd(n)), r;
}
function Rd(e) {
  const t = typeof e == "string" ? Td(e) : ya(e);
  if (!(!t || !Id(t)))
    return t;
}
function _t(e) {
  if (typeof e == "boolean")
    return Number(e);
  const t = typeof e == "string" ? parseFloat(e) : e;
  if (!(typeof t != "number" || isNaN(t) || t < 0 || t > 1))
    return t;
}
const Sa = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function Cd(e) {
  if (!e)
    return;
  const t = e.match(Sa);
  if (!t)
    return;
  let n;
  return t[3] === "1" ? n = !0 : t[3] === "0" && (n = !1), {
    traceId: t[1],
    parentSampled: n,
    parentSpanId: t[2]
  };
}
function xd(e, t) {
  const n = Cd(e), r = _a(t);
  if (!n?.traceId)
    return {
      traceId: je(),
      sampleRand: Math.random()
    };
  const s = Md(n, r);
  r && (r.sample_rand = s.toString());
  const { traceId: i, parentSpanId: o, parentSampled: c } = n;
  return {
    traceId: i,
    parentSpanId: o,
    sampled: c,
    dsc: r || {},
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    sampleRand: s
  };
}
function Ea(e = je(), t = Be(), n) {
  let r = "";
  return n !== void 0 && (r = n ? "-1" : "-0"), `${e}-${t}${r}`;
}
function ba(e = je(), t = Be(), n) {
  return `00-${e}-${t}-${n ? "01" : "00"}`;
}
function Md(e, t) {
  const n = _t(t?.sample_rand);
  if (n !== void 0)
    return n;
  const r = _t(t?.sample_rate);
  return r && e?.parentSampled !== void 0 ? e.parentSampled ? (
    // Returns a sample rand with positive sampling decision [0, sampleRate)
    Math.random() * r
  ) : (
    // Returns a sample rand with negative sampling decision [sampleRate, 1)
    r + Math.random() * (1 - r)
  ) : Math.random();
}
const va = 0, Ds = 1;
let Ai = !1;
function Ad(e) {
  const { spanId: t, traceId: n } = e.spanContext(), { data: r, op: s, parent_span_id: i, status: o, origin: c, links: a } = $(e);
  return {
    parent_span_id: i,
    span_id: t,
    trace_id: n,
    data: r,
    op: s,
    status: o,
    origin: c,
    links: a
  };
}
function Od(e) {
  const { spanId: t, traceId: n, isRemote: r } = e.spanContext(), s = r ? t : $(e).parent_span_id, i = Qn(e).scope, o = r ? i?.getPropagationContext().propagationSpanId || Be() : t;
  return {
    parent_span_id: s,
    span_id: o,
    trace_id: n
  };
}
function Nd(e) {
  const { traceId: t, spanId: n } = e.spanContext(), r = st(e);
  return Ea(t, n, r);
}
function Dd(e) {
  const { traceId: t, spanId: n } = e.spanContext(), r = st(e);
  return ba(t, n, r);
}
function Ta(e) {
  if (e && e.length > 0)
    return e.map(({ context: { spanId: t, traceId: n, traceFlags: r, ...s }, attributes: i }) => ({
      span_id: t,
      trace_id: n,
      sampled: r === Ds,
      attributes: i,
      ...s
    }));
}
function pt(e) {
  return typeof e == "number" ? Oi(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? Oi(e.getTime()) : oe();
}
function Oi(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function $(e) {
  if (Pd(e))
    return e.getSpanJSON();
  const { spanId: t, traceId: n } = e.spanContext();
  if (Ld(e)) {
    const { attributes: r, startTime: s, name: i, endTime: o, status: c, links: a } = e, u = "parentSpanId" in e ? e.parentSpanId : "parentSpanContext" in e ? e.parentSpanContext?.spanId : void 0;
    return {
      span_id: t,
      trace_id: n,
      data: r,
      description: i,
      parent_span_id: u,
      start_timestamp: pt(s),
      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
      timestamp: pt(o) || void 0,
      status: Ia(c),
      op: r[ze],
      origin: r[ne],
      links: Ta(a)
    };
  }
  return {
    span_id: t,
    trace_id: n,
    start_timestamp: 0,
    data: {}
  };
}
function Ld(e) {
  const t = e;
  return !!t.attributes && !!t.startTime && !!t.name && !!t.endTime && !!t.status;
}
function Pd(e) {
  return typeof e.getSpanJSON == "function";
}
function st(e) {
  const { traceFlags: t } = e.spanContext();
  return t === Ds;
}
function Ia(e) {
  if (!(!e || e.code === dd))
    return e.code === pa ? "ok" : e.message || "unknown_error";
}
const ht = "_sentryChildSpans", Qr = "_sentryRootSpan";
function wa(e, t) {
  const n = e[Qr] || e;
  be(t, Qr, n), e[ht] ? e[ht].add(t) : be(e, ht, /* @__PURE__ */ new Set([t]));
}
function Fd(e, t) {
  e[ht] && e[ht].delete(t);
}
function Wn(e) {
  const t = /* @__PURE__ */ new Set();
  function n(r) {
    if (!t.has(r) && st(r)) {
      t.add(r);
      const s = r[ht] ? Array.from(r[ht]) : [];
      for (const i of s)
        n(i);
    }
  }
  return n(e), Array.from(t);
}
function de(e) {
  return e[Qr] || e;
}
function le() {
  const e = St(), t = zt(e);
  return t.getActiveSpan ? t.getActiveSpan() : Jn(G());
}
function Zr() {
  Ai || (Ve(() => {
    console.warn(
      "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`."
    );
  }), Ai = !0);
}
let Ni = !1;
function $d() {
  if (Ni)
    return;
  function e() {
    const t = le(), n = t && de(t);
    if (n) {
      const r = "internal_error";
      v && _.log(`[Tracing] Root span: ${r} -> Global error occurred`), n.setStatus({ code: ce, message: r });
    }
  }
  e.tag = "sentry_tracingErrorCallback", Ni = !0, ta(e), na(e);
}
function we(e) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = e || U()?.getOptions();
  return !!t && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
  (t.tracesSampleRate != null || !!t.tracesSampler);
}
function Di(e) {
  _.log(`Ignoring span ${e.op} - ${e.description} because it matches \`ignoreSpans\`.`);
}
function Zn(e, t) {
  if (!t?.length || !e.description)
    return !1;
  for (const n of t) {
    if (Ud(n)) {
      if (Hn(e.description, n))
        return v && Di(e), !0;
      continue;
    }
    if (!n.name && !n.op)
      continue;
    const r = n.name ? Hn(e.description, n.name) : !0, s = n.op ? e.op && Hn(e.op, n.op) : !0;
    if (r && s)
      return v && Di(e), !0;
  }
  return !1;
}
function Bd(e, t) {
  const n = t.parent_span_id, r = t.span_id;
  if (n)
    for (const s of e)
      s.parent_span_id === r && (s.parent_span_id = n);
}
function Ud(e) {
  return typeof e == "string" || e instanceof RegExp;
}
const Ls = "production", ka = "_frozenDsc";
function jn(e, t) {
  be(e, ka, t);
}
function Ra(e, t) {
  const n = t.getOptions(), { publicKey: r } = t.getDsn() || {}, s = {
    environment: n.environment || Ls,
    release: n.release,
    public_key: r,
    trace_id: e,
    org_id: kd(t)
  };
  return t.emit("createDsc", s), s;
}
function Ca(e, t) {
  const n = t.getPropagationContext();
  return n.dsc || Ra(n.traceId, e);
}
function qe(e) {
  const t = U();
  if (!t)
    return {};
  const n = de(e), r = $(n), s = r.data, i = n.spanContext().traceState, o = i?.get("sentry.sample_rate") ?? s[As] ?? s[fa];
  function c(h) {
    return (typeof o == "number" || typeof o == "string") && (h.sample_rate = `${o}`), h;
  }
  const a = n[ka];
  if (a)
    return c(a);
  const u = i?.get("sentry.dsc"), l = u && _a(u);
  if (l)
    return c(l);
  const d = Ra(e.spanContext().traceId, t), p = s[_e], f = r.description;
  return p !== "url" && f && (d.transaction = f), we() && (d.sampled = String(st(n)), d.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
  // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
  i?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
  Qn(n).scope?.getPropagationContext().sampleRand.toString()), c(d), t.emit("createDsc", d, n), d;
}
class Qe {
  constructor(t = {}) {
    this._traceId = t.traceId || je(), this._spanId = t.spanId || Be();
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: va
    };
  }
  /** @inheritdoc */
  end(t) {
  }
  /** @inheritdoc */
  setAttribute(t, n) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return this;
  }
  /** @inheritdoc */
  setStatus(t) {
    return this;
  }
  /** @inheritdoc */
  updateName(t) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return !1;
  }
  /** @inheritdoc */
  addEvent(t, n, r) {
    return this;
  }
  /** @inheritDoc */
  addLink(t) {
    return this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, n) {
  }
}
function Me(e, t = 100, n = 1 / 0) {
  try {
    return es("", e, t, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function xa(e, t = 3, n = 100 * 1024) {
  const r = Me(e, t);
  return zd(r) > n ? xa(e, t - 1, n) : r;
}
function es(e, t, n = 1 / 0, r = 1 / 0, s = qd()) {
  const [i, o] = s;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof t) || typeof t == "number" && Number.isFinite(t))
    return t;
  const c = Hd(e, t);
  if (!c.startsWith("[object "))
    return c;
  if (t.__sentry_skip_normalization__)
    return t;
  const a = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : n;
  if (a === 0)
    return c.replace("object ", "");
  if (i(t))
    return "[Circular ~]";
  const u = t;
  if (u && typeof u.toJSON == "function")
    try {
      const f = u.toJSON();
      return es("", f, a - 1, r, s);
    } catch {
    }
  const l = Array.isArray(t) ? [] : {};
  let d = 0;
  const p = ua(t);
  for (const f in p) {
    if (!Object.prototype.hasOwnProperty.call(p, f))
      continue;
    if (d >= r) {
      l[f] = "[MaxProperties ~]";
      break;
    }
    const h = p[f];
    l[f] = es(f, h, a - 1, r, s), d++;
  }
  return o(t), l;
}
function Hd(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if (ia(t))
      return "[VueViewModel]";
    if (ju(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && !Number.isFinite(t))
      return `[${t}]`;
    if (typeof t == "function")
      return `[Function: ${He(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const n = Wd(t);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function Wd(e) {
  const t = Object.getPrototypeOf(e);
  return t?.constructor ? t.constructor.name : "null prototype";
}
function jd(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function zd(e) {
  return jd(JSON.stringify(e));
}
function qd() {
  const e = /* @__PURE__ */ new WeakSet();
  function t(r) {
    return e.has(r) ? !0 : (e.add(r), !1);
  }
  function n(r) {
    e.delete(r);
  }
  return [t, n];
}
function it(e, t = []) {
  return [e, t];
}
function Vd(e, t) {
  const [n, r] = e;
  return [n, [...r, t]];
}
function Li(e, t) {
  const n = e[1];
  for (const r of n) {
    const s = r[0].type;
    if (t(r, s))
      return !0;
  }
  return !1;
}
function ts(e) {
  const t = hr(B);
  return t.encodePolyfill ? t.encodePolyfill(e) : new TextEncoder().encode(e);
}
function Gd(e) {
  const [t, n] = e;
  let r = JSON.stringify(t);
  function s(i) {
    typeof r == "string" ? r = typeof i == "string" ? r + i : [ts(r), i] : r.push(typeof i == "string" ? ts(i) : i);
  }
  for (const i of n) {
    const [o, c] = i;
    if (s(`
${JSON.stringify(o)}
`), typeof c == "string" || c instanceof Uint8Array)
      s(c);
    else {
      let a;
      try {
        a = JSON.stringify(c);
      } catch {
        a = JSON.stringify(Me(c));
      }
      s(a);
    }
  }
  return typeof r == "string" ? r : Yd(r);
}
function Yd(e) {
  const t = e.reduce((s, i) => s + i.length, 0), n = new Uint8Array(t);
  let r = 0;
  for (const s of e)
    n.set(s, r), r += s.length;
  return n;
}
function Kd(e) {
  return [{
    type: "span"
  }, e];
}
function Xd(e) {
  const t = typeof e.data == "string" ? ts(e.data) : e.data;
  return [
    {
      type: "attachment",
      length: t.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    },
    t
  ];
}
const Jd = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  raw_security: "security",
  log: "log_item",
  metric: "metric",
  trace_metric: "metric"
};
function Pi(e) {
  return Jd[e];
}
function Ps(e) {
  if (!e?.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function Ma(e, t, n, r) {
  const s = e.sdkProcessingMetadata?.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!n && r && { dsn: Vt(r) },
    ...s && {
      trace: s
    }
  };
}
function Qd(e, t) {
  if (!t)
    return e;
  const n = e.sdk || {};
  return e.sdk = {
    ...n,
    name: n.name || t.name,
    version: n.version || t.version,
    integrations: [...e.sdk?.integrations || [], ...t.integrations || []],
    packages: [...e.sdk?.packages || [], ...t.packages || []],
    settings: e.sdk?.settings || t.settings ? {
      ...e.sdk?.settings,
      ...t.settings
    } : void 0
  }, e;
}
function Zd(e, t, n, r) {
  const s = Ps(n), i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...s && { sdk: s },
    ...!!r && t && { dsn: Vt(t) }
  }, o = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return it(i, [o]);
}
function el(e, t, n, r) {
  const s = Ps(n), i = e.type && e.type !== "replay_event" ? e.type : "event";
  Qd(e, n?.sdk);
  const o = Ma(e, s, r, t);
  return delete e.sdkProcessingMetadata, it(o, [[{ type: i }, e]]);
}
function tl(e, t) {
  function n(f) {
    return !!f.trace_id && !!f.public_key;
  }
  const r = qe(e[0]), s = t?.getDsn(), i = t?.getOptions().tunnel, o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...n(r) && { trace: r },
    ...!!i && s && { dsn: Vt(s) }
  }, { beforeSendSpan: c, ignoreSpans: a } = t?.getOptions() || {}, u = a?.length ? e.filter((f) => !Zn($(f), a)) : e, l = e.length - u.length;
  l && t?.recordDroppedEvent("before_send", "span", l);
  const d = c ? (f) => {
    const h = $(f), m = c(h);
    return m || (Zr(), h);
  } : $, p = [];
  for (const f of u) {
    const h = d(f);
    h && p.push(Kd(h));
  }
  return it(o, p);
}
function nl(e) {
  if (!v) return;
  const { description: t = "< unknown name >", op: n = "< unknown op >", parent_span_id: r } = $(e), { spanId: s } = e.spanContext(), i = st(e), o = de(e), c = o === e, a = `[Tracing] Starting ${i ? "sampled" : "unsampled"} ${c ? "root " : ""}span`, u = [`op: ${n}`, `name: ${t}`, `ID: ${s}`];
  if (r && u.push(`parent ID: ${r}`), !c) {
    const { op: l, description: d } = $(o);
    u.push(`root ID: ${o.spanContext().spanId}`), l && u.push(`root op: ${l}`), d && u.push(`root description: ${d}`);
  }
  _.log(`${a}
  ${u.join(`
  `)}`);
}
function rl(e) {
  if (!v) return;
  const { description: t = "< unknown name >", op: n = "< unknown op >" } = $(e), { spanId: r } = e.spanContext(), i = de(e) === e, o = `[Tracing] Finishing "${n}" ${i ? "root " : ""}span "${t}" with ID ${r}`;
  _.log(o);
}
function sl(e, t, n, r = le()) {
  const s = r && de(r);
  s && (v && _.log(`[Measurement] Setting measurement on root span: ${e} = ${t} ${n}`), s.addEvent(e, {
    [_n]: t,
    [gn]: n
  }));
}
function Fi(e) {
  if (!e || e.length === 0)
    return;
  const t = {};
  return e.forEach((n) => {
    const r = n.attributes || {}, s = r[gn], i = r[_n];
    typeof s == "string" && typeof i == "number" && (t[n.name] = { value: i, unit: s });
  }), t;
}
const $i = 1e3;
class _r {
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /** The timed events added to this span. */
  /** if true, treat span as a standalone span (not part of a transaction) */
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t = {}) {
    this._traceId = t.traceId || je(), this._spanId = t.spanId || Be(), this._startTime = t.startTimestamp || oe(), this._links = t.links, this._attributes = {}, this.setAttributes({
      [ne]: "manual",
      [ze]: t.op,
      ...t.attributes
    }), this._name = t.name, t.parentSpanId && (this._parentSpanId = t.parentSpanId), "sampled" in t && (this._sampled = t.sampled), t.endTimestamp && (this._endTime = t.endTimestamp), this._events = [], this._isStandaloneSpan = t.isStandalone, this._endTime && this._onSpanEnded();
  }
  /** @inheritDoc */
  addLink(t) {
    return this._links ? this._links.push(t) : this._links = [t], this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this._links ? this._links.push(...t) : this._links = t, this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, n) {
  }
  /** @inheritdoc */
  spanContext() {
    const { _spanId: t, _traceId: n, _sampled: r } = this;
    return {
      spanId: t,
      traceId: n,
      traceFlags: r ? Ds : va
    };
  }
  /** @inheritdoc */
  setAttribute(t, n) {
    return n === void 0 ? delete this._attributes[t] : this._attributes[t] = n, this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return Object.keys(t).forEach((n) => this.setAttribute(n, t[n])), this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(t) {
    this._startTime = pt(t);
  }
  /**
   * @inheritDoc
   */
  setStatus(t) {
    return this._status = t, this;
  }
  /**
   * @inheritDoc
   */
  updateName(t) {
    return this._name = t, this.setAttribute(_e, "custom"), this;
  }
  /** @inheritdoc */
  end(t) {
    this._endTime || (this._endTime = pt(t), rl(this), this._onSpanEnded());
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return {
      data: this._attributes,
      description: this._name,
      op: this._attributes[ze],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: Ia(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[ne],
      profile_id: this._attributes[Os],
      exclusive_time: this._attributes[qt],
      measurements: Fi(this._events),
      is_segment: this._isStandaloneSpan && de(this) === this || void 0,
      segment_id: this._isStandaloneSpan ? de(this).spanContext().spanId : void 0,
      links: Ta(this._links)
    };
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(t, n, r) {
    v && _.log("[Tracing] Adding an event to span:", t);
    const s = Bi(n) ? n : r || oe(), i = Bi(n) ? {} : n || {}, o = {
      name: t,
      time: pt(s),
      attributes: i
    };
    return this._events.push(o), this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const t = U();
    if (t && t.emit("spanEnd", this), !(this._isStandaloneSpan || this === de(this)))
      return;
    if (this._isStandaloneSpan) {
      this._sampled ? ol(tl([this], t)) : (v && _.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled."), t && t.recordDroppedEvent("sample_rate", "span"));
      return;
    }
    const r = this._convertSpanToTransaction();
    r && (Qn(this).scope || G()).captureEvent(r);
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    if (!Ui($(this)))
      return;
    this._name || (v && _.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>");
    const { scope: t, isolationScope: n } = Qn(this), r = t?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
    if (this._sampled !== !0)
      return;
    const i = Wn(this).filter((l) => l !== this && !il(l)).map((l) => $(l)).filter(Ui), o = this._attributes[_e];
    delete this._attributes[xi], i.forEach((l) => {
      delete l.data[xi];
    });
    const c = {
      contexts: {
        trace: Ad(this)
      },
      spans: (
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        i.length > $i ? i.sort((l, d) => l.start_timestamp - d.start_timestamp).slice(0, $i) : i
      ),
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        capturedSpanScope: t,
        capturedSpanIsolationScope: n,
        dynamicSamplingContext: qe(this)
      },
      request: r,
      ...o && {
        transaction_info: {
          source: o
        }
      }
    }, a = Fi(this._events);
    return a && Object.keys(a).length && (v && _.log(
      "[Measurements] Adding measurements to transaction event",
      JSON.stringify(a, void 0, 2)
    ), c.measurements = a), c;
  }
}
function Bi(e) {
  return e && typeof e == "number" || e instanceof Date || Array.isArray(e);
}
function Ui(e) {
  return !!e.start_timestamp && !!e.timestamp && !!e.span_id && !!e.trace_id;
}
function il(e) {
  return e instanceof _r && e.isStandaloneSpan();
}
function ol(e) {
  const t = U();
  if (!t)
    return;
  const n = e[1];
  if (!n || n.length === 0) {
    t.recordDroppedEvent("before_send", "span");
    return;
  }
  t.sendEnvelope(e);
}
function al(e, t, n = () => {
}, r = () => {
}) {
  let s;
  try {
    s = e();
  } catch (i) {
    throw t(i), n(), i;
  }
  return cl(s, t, n, r);
}
function cl(e, t, n, r) {
  return Wt(e) ? e.then(
    (s) => (n(), r(s), s),
    (s) => {
      throw t(s), n(), s;
    }
  ) : (n(), r(e), e);
}
function ul(e, t, n) {
  if (!we(e))
    return [!1];
  let r, s;
  typeof e.tracesSampler == "function" ? (s = e.tracesSampler({
    ...t,
    inheritOrSampleWith: (c) => typeof t.parentSampleRate == "number" ? t.parentSampleRate : typeof t.parentSampled == "boolean" ? Number(t.parentSampled) : c
  }), r = !0) : t.parentSampled !== void 0 ? s = t.parentSampled : typeof e.tracesSampleRate < "u" && (s = e.tracesSampleRate, r = !0);
  const i = _t(s);
  if (i === void 0)
    return v && _.warn(
      `[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        s
      )} of type ${JSON.stringify(typeof s)}.`
    ), [!1];
  if (!i)
    return v && _.log(
      `[Tracing] Discarding transaction because ${typeof e.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
    ), [!1, i, r];
  const o = n < i;
  return o || v && _.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      s
    )})`
  ), [o, i, r];
}
const Aa = "__SENTRY_SUPPRESS_TRACING__";
function dl(e, t) {
  const n = $s();
  if (n.startSpan)
    return n.startSpan(e, t);
  const r = Na(e), { forceTransaction: s, parentSpan: i, scope: o } = e, c = o?.clone();
  return gr(c, () => fl(i)(() => {
    const u = G(), l = Da(u, i), p = e.onlyIfParent && !l ? new Qe() : Oa({
      parentSpan: l,
      spanArguments: r,
      forceTransaction: s,
      scope: u
    });
    return Nt(u, p), al(
      () => t(p),
      () => {
        const { status: f } = $(p);
        p.isRecording() && (!f || f === "ok") && p.setStatus({ code: ce, message: "internal_error" });
      },
      () => {
        p.end();
      }
    );
  }));
}
function Ze(e) {
  const t = $s();
  if (t.startInactiveSpan)
    return t.startInactiveSpan(e);
  const n = Na(e), { forceTransaction: r, parentSpan: s } = e;
  return (e.scope ? (o) => gr(e.scope, o) : s !== void 0 ? (o) => Fs(s, o) : (o) => o())(() => {
    const o = G(), c = Da(o, s);
    return e.onlyIfParent && !c ? new Qe() : Oa({
      parentSpan: c,
      spanArguments: n,
      forceTransaction: r,
      scope: o
    });
  });
}
function Fs(e, t) {
  const n = $s();
  return n.withActiveSpan ? n.withActiveSpan(e, t) : gr((r) => (Nt(r, e || void 0), t(r)));
}
function Oa({
  parentSpan: e,
  spanArguments: t,
  forceTransaction: n,
  scope: r
}) {
  if (!we()) {
    const o = new Qe();
    if (n || !e) {
      const c = {
        sampled: "false",
        sample_rate: "0",
        transaction: t.name,
        ...qe(o)
      };
      jn(o, c);
    }
    return o;
  }
  const s = De();
  let i;
  if (e && !n)
    i = ll(e, r, t), wa(e, i);
  else if (e) {
    const o = qe(e), { traceId: c, spanId: a } = e.spanContext(), u = st(e);
    i = Hi(
      {
        traceId: c,
        parentSpanId: a,
        ...t
      },
      r,
      u
    ), jn(i, o);
  } else {
    const {
      traceId: o,
      dsc: c,
      parentSpanId: a,
      sampled: u
    } = {
      ...s.getPropagationContext(),
      ...r.getPropagationContext()
    };
    i = Hi(
      {
        traceId: o,
        parentSpanId: a,
        ...t
      },
      r,
      u
    ), c && jn(i, c);
  }
  return nl(i), hd(i, r, s), i;
}
function Na(e) {
  const n = {
    isStandalone: (e.experimental || {}).standalone,
    ...e
  };
  if (e.startTime) {
    const r = { ...n };
    return r.startTimestamp = pt(e.startTime), delete r.startTime, r;
  }
  return n;
}
function $s() {
  const e = St();
  return zt(e);
}
function Hi(e, t, n) {
  const r = U(), s = r?.getOptions() || {}, { name: i = "" } = e, o = { spanAttributes: { ...e.attributes }, spanName: i, parentSampled: n };
  r?.emit("beforeSampling", o, { decision: !1 });
  const c = o.parentSampled ?? n, a = o.spanAttributes, u = t.getPropagationContext(), [l, d, p] = t.getScopeData().sdkProcessingMetadata[Aa] ? [!1] : ul(
    s,
    {
      name: i,
      parentSampled: c,
      attributes: a,
      parentSampleRate: _t(u.dsc?.sample_rate)
    },
    u.sampleRand
  ), f = new _r({
    ...e,
    attributes: {
      [_e]: "custom",
      [As]: d !== void 0 && p ? d : void 0,
      ...a
    },
    sampled: l
  });
  return !l && r && (v && _.log("[Tracing] Discarding root span because its trace was not chosen to be sampled."), r.recordDroppedEvent("sample_rate", "transaction")), r && r.emit("spanStart", f), f;
}
function ll(e, t, n) {
  const { spanId: r, traceId: s } = e.spanContext(), i = t.getScopeData().sdkProcessingMetadata[Aa] ? !1 : st(e), o = i ? new _r({
    ...n,
    parentSpanId: r,
    traceId: s,
    sampled: i
  }) : new Qe({ traceId: s });
  wa(e, o);
  const c = U();
  return c && (c.emit("spanStart", o), n.endTimestamp && c.emit("spanEnd", o)), o;
}
function Da(e, t) {
  if (t)
    return t;
  if (t === null)
    return;
  const n = Jn(e);
  if (!n)
    return;
  const r = U();
  return (r ? r.getOptions() : {}).parentSpanIsAlwaysRootSpan ? de(n) : n;
}
function fl(e) {
  return e !== void 0 ? (t) => Fs(e, t) : (t) => t();
}
const zn = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  childSpanTimeout: 15e3
}, pl = "heartbeatFailed", hl = "idleTimeout", ml = "finalTimeout", gl = "externalFinish";
function La(e, t = {}) {
  const n = /* @__PURE__ */ new Map();
  let r = !1, s, i = gl, o = !t.disableAutoFinish;
  const c = [], {
    idleTimeout: a = zn.idleTimeout,
    finalTimeout: u = zn.finalTimeout,
    childSpanTimeout: l = zn.childSpanTimeout,
    beforeSpanEnd: d,
    trimIdleSpanEndTimestamp: p = !0
  } = t, f = U();
  if (!f || !we()) {
    const y = new Qe(), T = {
      sample_rate: "0",
      sampled: "false",
      ...qe(y)
    };
    return jn(y, T), y;
  }
  const h = G(), m = le(), g = _l(e);
  g.end = new Proxy(g.end, {
    apply(y, T, b) {
      if (d && d(g), T instanceof Qe)
        return;
      const [k, ...L] = b, H = k || oe(), P = pt(H), Z = Wn(g).filter((V) => V !== g), te = $(g);
      if (!Z.length || !p)
        return w(P), Reflect.apply(y, T, [P, ...L]);
      const X = f.getOptions().ignoreSpans, S = Z?.reduce((V, re) => {
        const ee = $(re);
        return !ee.timestamp || X && Zn(ee, X) ? V : V ? Math.max(V, ee.timestamp) : ee.timestamp;
      }, void 0), q = te.start_timestamp, I = Math.min(
        q ? q + u / 1e3 : 1 / 0,
        Math.max(q || -1 / 0, Math.min(P, S || 1 / 0))
      );
      return w(I), Reflect.apply(y, T, [I, ...L]);
    }
  });
  function E() {
    s && (clearTimeout(s), s = void 0);
  }
  function R(y) {
    E(), s = setTimeout(() => {
      !r && n.size === 0 && o && (i = hl, g.end(y));
    }, a);
  }
  function j(y) {
    s = setTimeout(() => {
      !r && o && (i = pl, g.end(y));
    }, l);
  }
  function D(y) {
    E(), n.set(y, !0);
    const T = oe();
    j(T + l / 1e3);
  }
  function A(y) {
    if (n.has(y) && n.delete(y), n.size === 0) {
      const T = oe();
      R(T + a / 1e3);
    }
  }
  function w(y) {
    r = !0, n.clear(), c.forEach((P) => P()), Nt(h, m);
    const T = $(g), { start_timestamp: b } = T;
    if (!b)
      return;
    T.data[an] || g.setAttribute(an, i), _.log(`[Tracing] Idle span "${T.op}" finished`);
    const L = Wn(g).filter((P) => P !== g);
    let H = 0;
    L.forEach((P) => {
      P.isRecording() && (P.setStatus({ code: ce, message: "cancelled" }), P.end(y), v && _.log("[Tracing] Cancelling span since span ended early", JSON.stringify(P, void 0, 2)));
      const Z = $(P), { timestamp: te = 0, start_timestamp: X = 0 } = Z, S = X <= y, q = (u + a) / 1e3, I = te - X <= q;
      if (v) {
        const V = JSON.stringify(P, void 0, 2);
        S ? I || _.log("[Tracing] Discarding span since it finished after idle span final timeout", V) : _.log("[Tracing] Discarding span since it happened after idle span was finished", V);
      }
      (!I || !S) && (Fd(g, P), H++);
    }), H > 0 && g.setAttribute("sentry.idle_span_discarded_spans", H);
  }
  return c.push(
    f.on("spanStart", (y) => {
      if (r || y === g || $(y).timestamp || y instanceof _r && y.isStandaloneSpan())
        return;
      Wn(g).includes(y) && D(y.spanContext().spanId);
    })
  ), c.push(
    f.on("spanEnd", (y) => {
      r || A(y.spanContext().spanId);
    })
  ), c.push(
    f.on("idleSpanEnableAutoFinish", (y) => {
      y === g && (o = !0, R(), n.size && j());
    })
  ), t.disableAutoFinish || R(), setTimeout(() => {
    r || (g.setStatus({ code: ce, message: "deadline_exceeded" }), i = ml, g.end());
  }, u), g;
}
function _l(e) {
  const t = Ze(e);
  return Nt(G(), t), v && _.log("[Tracing] Started span is an idle span"), t;
}
const Dr = 0, Wi = 1, ji = 2;
function yr(e) {
  return new cn((t) => {
    t(e);
  });
}
function Bs(e) {
  return new cn((t, n) => {
    n(e);
  });
}
class cn {
  constructor(t) {
    this._state = Dr, this._handlers = [], this._runExecutor(t);
  }
  /** @inheritdoc */
  then(t, n) {
    return new cn((r, s) => {
      this._handlers.push([
        !1,
        (i) => {
          if (!t)
            r(i);
          else
            try {
              r(t(i));
            } catch (o) {
              s(o);
            }
        },
        (i) => {
          if (!n)
            s(i);
          else
            try {
              r(n(i));
            } catch (o) {
              s(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** @inheritdoc */
  catch(t) {
    return this.then((n) => n, t);
  }
  /** @inheritdoc */
  finally(t) {
    return new cn((n, r) => {
      let s, i;
      return this.then(
        (o) => {
          i = !1, s = o, t && t();
        },
        (o) => {
          i = !0, s = o, t && t();
        }
      ).then(() => {
        if (i) {
          r(s);
          return;
        }
        n(s);
      });
    });
  }
  /** Excute the resolve/reject handlers. */
  _executeHandlers() {
    if (this._state === Dr)
      return;
    const t = this._handlers.slice();
    this._handlers = [], t.forEach((n) => {
      n[0] || (this._state === Wi && n[1](this._value), this._state === ji && n[2](this._value), n[0] = !0);
    });
  }
  /** Run the executor for the SyncPromise. */
  _runExecutor(t) {
    const n = (i, o) => {
      if (this._state === Dr) {
        if (Wt(o)) {
          o.then(r, s);
          return;
        }
        this._state = i, this._value = o, this._executeHandlers();
      }
    }, r = (i) => {
      n(Wi, i);
    }, s = (i) => {
      n(ji, i);
    };
    try {
      t(r, s);
    } catch (i) {
      s(i);
    }
  }
}
function yl(e, t, n, r = 0) {
  try {
    const s = ns(t, n, e, r);
    return Wt(s) ? s : yr(s);
  } catch (s) {
    return Bs(s);
  }
}
function ns(e, t, n, r) {
  const s = n[r];
  if (!e || !s)
    return e;
  const i = s({ ...e }, t);
  return v && i === null && _.log(`Event processor "${s.id || "?"}" dropped event`), Wt(i) ? i.then((o) => ns(o, t, n, r + 1)) : ns(i, t, n, r + 1);
}
function Sl(e, t) {
  const { fingerprint: n, span: r, breadcrumbs: s, sdkProcessingMetadata: i } = t;
  El(e, t), r && Tl(e, r), Il(e, n), bl(e, s), vl(e, i);
}
function zi(e, t) {
  const {
    extra: n,
    tags: r,
    user: s,
    contexts: i,
    level: o,
    sdkProcessingMetadata: c,
    breadcrumbs: a,
    fingerprint: u,
    eventProcessors: l,
    attachments: d,
    propagationContext: p,
    transactionName: f,
    span: h
  } = t;
  xn(e, "extra", n), xn(e, "tags", r), xn(e, "user", s), xn(e, "contexts", i), e.sdkProcessingMetadata = mn(e.sdkProcessingMetadata, c, 2), o && (e.level = o), f && (e.transactionName = f), h && (e.span = h), a.length && (e.breadcrumbs = [...e.breadcrumbs, ...a]), u.length && (e.fingerprint = [...e.fingerprint, ...u]), l.length && (e.eventProcessors = [...e.eventProcessors, ...l]), d.length && (e.attachments = [...e.attachments, ...d]), e.propagationContext = { ...e.propagationContext, ...p };
}
function xn(e, t, n) {
  e[t] = mn(e[t], n, 1);
}
function El(e, t) {
  const { extra: n, tags: r, user: s, contexts: i, level: o, transactionName: c } = t;
  Object.keys(n).length && (e.extra = { ...n, ...e.extra }), Object.keys(r).length && (e.tags = { ...r, ...e.tags }), Object.keys(s).length && (e.user = { ...s, ...e.user }), Object.keys(i).length && (e.contexts = { ...i, ...e.contexts }), o && (e.level = o), c && e.type !== "transaction" && (e.transaction = c);
}
function bl(e, t) {
  const n = [...e.breadcrumbs || [], ...t];
  e.breadcrumbs = n.length ? n : void 0;
}
function vl(e, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...t
  };
}
function Tl(e, t) {
  e.contexts = {
    trace: Od(t),
    ...e.contexts
  }, e.sdkProcessingMetadata = {
    dynamicSamplingContext: qe(t),
    ...e.sdkProcessingMetadata
  };
  const n = de(t), r = $(n).description;
  r && !e.transaction && e.type === "transaction" && (e.transaction = r);
}
function Il(e, t) {
  e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], t && (e.fingerprint = e.fingerprint.concat(t)), e.fingerprint.length || delete e.fingerprint;
}
let ct, qi, Vi, Ge;
function wl(e) {
  const t = B._sentryDebugIds, n = B._debugIds;
  if (!t && !n)
    return {};
  const r = t ? Object.keys(t) : [], s = n ? Object.keys(n) : [];
  if (Ge && r.length === qi && s.length === Vi)
    return Ge;
  qi = r.length, Vi = s.length, Ge = {}, ct || (ct = {});
  const i = (o, c) => {
    for (const a of o) {
      const u = c[a], l = ct?.[a];
      if (l && Ge && u)
        Ge[l[0]] = u, ct && (ct[a] = [l[0], u]);
      else if (u) {
        const d = e(a);
        for (let p = d.length - 1; p >= 0; p--) {
          const h = d[p]?.filename;
          if (h && Ge && ct) {
            Ge[h] = u, ct[a] = [h, u];
            break;
          }
        }
      }
    }
  };
  return t && i(r, t), n && i(s, n), Ge;
}
function Pa(e, t, n, r, s, i) {
  const { normalizeDepth: o = 3, normalizeMaxBreadth: c = 1e3 } = e, a = {
    ...t,
    event_id: t.event_id || n.event_id || Ee(),
    timestamp: t.timestamp || Et()
  }, u = n.integrations || e.integrations.map((g) => g.name);
  kl(a, e), xl(a, u), s && s.emit("applyFrameMetadata", t), t.type === void 0 && Rl(a, e.stackParser);
  const l = Al(r, n.captureContext);
  n.mechanism && At(a, n.mechanism);
  const d = s ? s.getEventProcessors() : [], p = ad().getScopeData();
  if (i) {
    const g = i.getScopeData();
    zi(p, g);
  }
  if (l) {
    const g = l.getScopeData();
    zi(p, g);
  }
  const f = [...n.attachments || [], ...p.attachments];
  f.length && (n.attachments = f), Sl(a, p);
  const h = [
    ...d,
    // Run scope event processors _after_ all other processors
    ...p.eventProcessors
  ];
  return yl(h, a, n).then((g) => (g && Cl(g), typeof o == "number" && o > 0 ? Ml(g, o, c) : g));
}
function kl(e, t) {
  const { environment: n, release: r, dist: s, maxValueLength: i = 250 } = t;
  e.environment = e.environment || n || Ls, !e.release && r && (e.release = r), !e.dist && s && (e.dist = s);
  const o = e.request;
  o?.url && (o.url = Xn(o.url, i));
}
function Rl(e, t) {
  const n = wl(t);
  e.exception?.values?.forEach((r) => {
    r.stacktrace?.frames?.forEach((s) => {
      s.filename && (s.debug_id = n[s.filename]);
    });
  });
}
function Cl(e) {
  const t = {};
  if (e.exception?.values?.forEach((r) => {
    r.stacktrace?.frames?.forEach((s) => {
      s.debug_id && (s.abs_path ? t[s.abs_path] = s.debug_id : s.filename && (t[s.filename] = s.debug_id), delete s.debug_id);
    });
  }), Object.keys(t).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const n = e.debug_meta.images;
  Object.entries(t).forEach(([r, s]) => {
    n.push({
      type: "sourcemap",
      code_file: r,
      debug_id: s
    });
  });
}
function xl(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function Ml(e, t, n) {
  if (!e)
    return null;
  const r = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((s) => ({
        ...s,
        ...s.data && {
          data: Me(s.data, t, n)
        }
      }))
    },
    ...e.user && {
      user: Me(e.user, t, n)
    },
    ...e.contexts && {
      contexts: Me(e.contexts, t, n)
    },
    ...e.extra && {
      extra: Me(e.extra, t, n)
    }
  };
  return e.contexts?.trace && r.contexts && (r.contexts.trace = e.contexts.trace, e.contexts.trace.data && (r.contexts.trace.data = Me(e.contexts.trace.data, t, n))), e.spans && (r.spans = e.spans.map((s) => ({
    ...s,
    ...s.data && {
      data: Me(s.data, t, n)
    }
  }))), e.contexts?.flags && r.contexts && (r.contexts.flags = Me(e.contexts.flags, 3, n)), r;
}
function Al(e, t) {
  if (!t)
    return e;
  const n = e ? e.clone() : new Ne();
  return n.update(t), n;
}
function Ol(e) {
  if (e)
    return Nl(e) ? { captureContext: e } : Ll(e) ? {
      captureContext: e
    } : e;
}
function Nl(e) {
  return e instanceof Ne || typeof e == "function";
}
const Dl = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function Ll(e) {
  return Object.keys(e).some((t) => Dl.includes(t));
}
function yn(e, t) {
  return G().captureException(e, Ol(t));
}
function Fa(e, t) {
  return G().captureEvent(e, t);
}
function Pl(e, t) {
  De().setContext(e, t);
}
function Fl() {
  const e = U();
  return e?.getOptions().enabled !== !1 && !!e?.getTransport();
}
function $l(e) {
  De().addEventProcessor(e);
}
function Gi(e) {
  const t = De(), n = G(), { userAgent: r } = B.navigator || {}, s = Ju({
    user: n.getUser() || t.getUser(),
    ...r && { userAgent: r },
    ...e
  }), i = t.getSession();
  return i?.status === "ok" && Ot(i, { status: "exited" }), $a(), t.setSession(s), s;
}
function $a() {
  const e = De(), n = G().getSession() || e.getSession();
  n && Qu(n), Ba(), e.setSession();
}
function Ba() {
  const e = De(), t = U(), n = e.getSession();
  n && t && t.captureSession(n);
}
function Yi(e = !1) {
  if (e) {
    $a();
    return;
  }
  Ba();
}
const Bl = "7";
function Ul(e) {
  const t = e.protocol ? `${e.protocol}:` : "", n = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${n}${e.path ? `/${e.path}` : ""}/api/`;
}
function Hl(e) {
  return `${Ul(e)}${e.projectId}/envelope/`;
}
function Wl(e, t) {
  const n = {
    sentry_version: Bl
  };
  return e.publicKey && (n.sentry_key = e.publicKey), t && (n.sentry_client = `${t.name}/${t.version}`), new URLSearchParams(n).toString();
}
function jl(e, t, n) {
  return t || `${Hl(e)}?${Wl(e, n)}`;
}
const Ki = [];
function zl(e) {
  const t = {};
  return e.forEach((n) => {
    const { name: r } = n, s = t[r];
    s && !s.isDefaultInstance && n.isDefaultInstance || (t[r] = n);
  }), Object.values(t);
}
function ql(e) {
  const t = e.defaultIntegrations || [], n = e.integrations;
  t.forEach((s) => {
    s.isDefaultInstance = !0;
  });
  let r;
  if (Array.isArray(n))
    r = [...t, ...n];
  else if (typeof n == "function") {
    const s = n(t);
    r = Array.isArray(s) ? s : [s];
  } else
    r = t;
  return zl(r);
}
function Vl(e, t) {
  const n = {};
  return t.forEach((r) => {
    r && Ua(e, r, n);
  }), n;
}
function Xi(e, t) {
  for (const n of t)
    n?.afterAllSetup && n.afterAllSetup(e);
}
function Ua(e, t, n) {
  if (n[t.name]) {
    v && _.log(`Integration skipped because it was already installed: ${t.name}`);
    return;
  }
  if (n[t.name] = t, Ki.indexOf(t.name) === -1 && typeof t.setupOnce == "function" && (t.setupOnce(), Ki.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), typeof t.preprocessEvent == "function") {
    const r = t.preprocessEvent.bind(t);
    e.on("preprocessEvent", (s, i) => r(s, i, e));
  }
  if (typeof t.processEvent == "function") {
    const r = t.processEvent.bind(t), s = Object.assign((i, o) => r(i, o, e), {
      id: t.name
    });
    e.addEventProcessor(s);
  }
  v && _.log(`Integration installed: ${t.name}`);
}
function Gl(e) {
  return [
    {
      type: "log",
      item_count: e.length,
      content_type: "application/vnd.sentry.items.log+json"
    },
    {
      items: e
    }
  ];
}
function Yl(e, t, n, r) {
  const s = {};
  return t?.sdk && (s.sdk = {
    name: t.sdk.name,
    version: t.sdk.version
  }), n && r && (s.dsn = Vt(r)), it(s, [Gl(e)]);
}
function Ha(e, t) {
  const n = t ?? Kl(e) ?? [];
  if (n.length === 0)
    return;
  const r = e.getOptions(), s = Yl(n, r._metadata, r.tunnel, e.getDsn());
  Wa().set(e, []), e.emit("flushLogs"), e.sendEnvelope(s);
}
function Kl(e) {
  return Wa().get(e);
}
function Wa() {
  return Ut("clientToLogBufferMap", () => /* @__PURE__ */ new WeakMap());
}
function Xl(e) {
  return [
    {
      type: "trace_metric",
      item_count: e.length,
      content_type: "application/vnd.sentry.items.trace-metric+json"
    },
    {
      items: e
    }
  ];
}
function Jl(e, t, n, r) {
  const s = {};
  return t?.sdk && (s.sdk = {
    name: t.sdk.name,
    version: t.sdk.version
  }), n && r && (s.dsn = Vt(r)), it(s, [Xl(e)]);
}
function ja(e, t) {
  const n = t ?? Ql(e) ?? [];
  if (n.length === 0)
    return;
  const r = e.getOptions(), s = Jl(n, r._metadata, r.tunnel, e.getDsn());
  za().set(e, []), e.emit("flushMetrics"), e.sendEnvelope(s);
}
function Ql(e) {
  return za().get(e);
}
function za() {
  return Ut("clientToMetricBufferMap", () => /* @__PURE__ */ new WeakMap());
}
function Zl(e, t, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: Et(),
      discarded_events: e
    }
  ];
  return it(t ? { dsn: t } : {}, [r]);
}
function qa(e) {
  const t = [];
  e.message && t.push(e.message);
  try {
    const n = e.exception.values[e.exception.values.length - 1];
    n?.value && (t.push(n.value), n.type && t.push(`${n.type}: ${n.value}`));
  } catch {
  }
  return t;
}
function ef(e) {
  const { trace_id: t, parent_span_id: n, span_id: r, status: s, origin: i, data: o, op: c } = e.contexts?.trace ?? {};
  return {
    data: o ?? {},
    description: e.transaction,
    op: c,
    parent_span_id: n,
    span_id: r ?? "",
    start_timestamp: e.start_timestamp ?? 0,
    status: s,
    timestamp: e.timestamp,
    trace_id: t ?? "",
    origin: i,
    profile_id: o?.[Os],
    exclusive_time: o?.[qt],
    measurements: e.measurements,
    is_segment: !0
  };
}
function tf(e) {
  return {
    type: "transaction",
    timestamp: e.timestamp,
    start_timestamp: e.start_timestamp,
    transaction: e.description,
    contexts: {
      trace: {
        trace_id: e.trace_id,
        span_id: e.span_id,
        parent_span_id: e.parent_span_id,
        op: e.op,
        status: e.status,
        origin: e.origin,
        data: {
          ...e.data,
          ...e.profile_id && { [Os]: e.profile_id },
          ...e.exclusive_time && { [qt]: e.exclusive_time }
        }
      }
    },
    measurements: e.measurements
  };
}
const Ji = "Not capturing exception because it's already been captured.", Qi = "Discarded session because of missing or non-string release", Va = Symbol.for("SentryInternalError"), Ga = Symbol.for("SentryDoNotSendEventError"), nf = 5e3;
function qn(e) {
  return {
    message: e,
    [Va]: !0
  };
}
function Lr(e) {
  return {
    message: e,
    [Ga]: !0
  };
}
function Zi(e) {
  return !!e && typeof e == "object" && Va in e;
}
function eo(e) {
  return !!e && typeof e == "object" && Ga in e;
}
function to(e, t, n, r, s) {
  let i = 0, o;
  e.on(n, () => {
    i = 0, clearTimeout(o);
  }), e.on(t, (c) => {
    i += r(c), i >= 8e5 ? s(e) : (clearTimeout(o), o = setTimeout(() => {
      s(e);
    }, nf));
  }), e.on("flush", () => {
    s(e);
  });
}
class rf {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = Rd(t.dsn) : v && _.warn("No DSN provided, client will not send events."), this._dsn) {
      const n = jl(
        this._dsn,
        t.tunnel,
        t._metadata ? t._metadata.sdk : void 0
      );
      this._transport = t.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: n
      });
    }
    this._options.enableLogs && to(this, "afterCaptureLog", "flushLogs", cf, Ha), this._options._experiments?.enableMetrics && to(
      this,
      "afterCaptureMetric",
      "flushMetrics",
      af,
      ja
    );
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureException(t, n, r) {
    const s = Ee();
    if (ki(t))
      return v && _.log(Ji), s;
    const i = {
      event_id: s,
      ...n
    };
    return this._process(
      this.eventFromException(t, i).then(
        (o) => this._captureEvent(o, i, r)
      )
    ), i.event_id;
  }
  /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureMessage(t, n, r, s) {
    const i = {
      event_id: Ee(),
      ...r
    }, o = Cs(t) ? t : String(t), c = Mt(t) ? this.eventFromMessage(o, n, i) : this.eventFromException(t, i);
    return this._process(c.then((a) => this._captureEvent(a, i, s))), i.event_id;
  }
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureEvent(t, n, r) {
    const s = Ee();
    if (n?.originalException && ki(n.originalException))
      return v && _.log(Ji), s;
    const i = {
      event_id: s,
      ...n
    }, o = t.sdkProcessingMetadata || {}, c = o.capturedSpanScope, a = o.capturedSpanIsolationScope;
    return this._process(
      this._captureEvent(t, i, c || r, a)
    ), i.event_id;
  }
  /**
   * Captures a session.
   */
  captureSession(t) {
    this.sendSession(t), Ot(t, { init: !1 });
  }
  /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */
  /**
   * Get the current Dsn.
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * Get the current options.
   */
  getOptions() {
    return this._options;
  }
  /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */
  getTransport() {
    return this._transport;
  }
  /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async flush(t) {
    const n = this._transport;
    if (!n)
      return !0;
    this.emit("flush");
    const r = await this._isClientDoneProcessing(t), s = await n.flush(t);
    return r && s;
  }
  /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async close(t) {
    const n = await this.flush(t);
    return this.getOptions().enabled = !1, this.emit("close"), n;
  }
  /**
   * Get all installed event processors.
   */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /**
   * Adds an event processor that applies to any event processed by this client.
   */
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: t }) => t.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */
  addIntegration(t) {
    const n = this._integrations[t.name];
    Ua(this, t, this._integrations), n || Xi(this, [t]);
  }
  /**
   * Send a fully prepared event to Sentry.
   */
  sendEvent(t, n = {}) {
    this.emit("beforeSendEvent", t, n);
    let r = el(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const s of n.attachments || [])
      r = Vd(r, Xd(s));
    this.sendEnvelope(r).then((s) => this.emit("afterSendEvent", t, s));
  }
  /**
   * Send a session or session aggregrates to Sentry.
   */
  sendSession(t) {
    const { release: n, environment: r = Ls } = this._options;
    if ("aggregates" in t) {
      const i = t.attrs || {};
      if (!i.release && !n) {
        v && _.warn(Qi);
        return;
      }
      i.release = i.release || n, i.environment = i.environment || r, t.attrs = i;
    } else {
      if (!t.release && !n) {
        v && _.warn(Qi);
        return;
      }
      t.release = t.release || n, t.environment = t.environment || r;
    }
    this.emit("beforeSendSession", t);
    const s = Zd(t, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(s);
  }
  /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */
  recordDroppedEvent(t, n, r = 1) {
    if (this._options.sendClientReports) {
      const s = `${t}:${n}`;
      v && _.log(`Recording outcome: "${s}"${r > 1 ? ` (${r} times)` : ""}`), this._outcomes[s] = (this._outcomes[s] || 0) + r;
    }
  }
  /* eslint-disable @typescript-eslint/unified-signatures */
  /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */
  /**
   * Register a hook on this client.
   */
  on(t, n) {
    const r = this._hooks[t] = this._hooks[t] || /* @__PURE__ */ new Set(), s = (...i) => n(...i);
    return r.add(s), () => {
      r.delete(s);
    };
  }
  /** Fire a hook whenever a span starts. */
  /**
   * Emit a hook that was previously registered via `on()`.
   */
  emit(t, ...n) {
    const r = this._hooks[t];
    r && r.forEach((s) => s(...n));
  }
  /**
   * Send an envelope to Sentry.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async sendEnvelope(t) {
    if (this.emit("beforeEnvelope", t), this._isEnabled() && this._transport)
      try {
        return await this._transport.send(t);
      } catch (n) {
        return v && _.error("Error while sending envelope:", n), {};
      }
    return v && _.error("Transport disabled"), {};
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = Vl(this, t), Xi(this, t);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, n) {
    let r = n.level === "fatal", s = !1;
    const i = n.exception?.values;
    if (i) {
      s = !0;
      for (const a of i)
        if (a.mechanism?.handled === !1) {
          r = !0;
          break;
        }
    }
    const o = t.status === "ok";
    (o && t.errors === 0 || o && r) && (Ot(t, {
      ...r && { status: "crashed" },
      errors: t.errors || Number(s || r)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  async _isClientDoneProcessing(t) {
    let n = 0;
    for (; !t || n < t; ) {
      if (await new Promise((r) => setTimeout(r, 1)), !this._numProcessing)
        return !0;
      n++;
    }
    return !1;
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, n, r, s) {
    const i = this.getOptions(), o = Object.keys(this._integrations);
    return !n.integrations && o?.length && (n.integrations = o), this.emit("preprocessEvent", t, n), t.type || s.setLastEventId(t.event_id || n.event_id), Pa(i, t, n, r, this, s).then((c) => {
      if (c === null)
        return c;
      this.emit("postprocessEvent", c, n), c.contexts = {
        trace: cd(r),
        ...c.contexts
      };
      const a = Ca(this, r);
      return c.sdkProcessingMetadata = {
        dynamicSamplingContext: a,
        ...c.sdkProcessingMetadata
      }, c;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, n = {}, r = G(), s = De()) {
    return v && rs(t) && _.log(`Captured error event \`${qa(t)[0] || "<unknown>"}\``), this._processEvent(t, n, r, s).then(
      (i) => i.event_id,
      (i) => {
        v && (eo(i) ? _.log(i.message) : Zi(i) ? _.warn(i.message) : _.warn(i));
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, n, r, s) {
    const i = this.getOptions(), { sampleRate: o } = i, c = Ya(t), a = rs(t), u = t.type || "error", l = `before send for type \`${u}\``, d = typeof o > "u" ? void 0 : _t(o);
    if (a && typeof d == "number" && Math.random() > d)
      return this.recordDroppedEvent("sample_rate", "error"), Bs(
        Lr(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`
        )
      );
    const p = u === "replay_event" ? "replay" : u;
    return this._prepareEvent(t, n, r, s).then((f) => {
      if (f === null)
        throw this.recordDroppedEvent("event_processor", p), Lr("An event processor returned `null`, will not send event.");
      if (n.data && n.data.__sentry__ === !0)
        return f;
      const m = of(this, i, f, n);
      return sf(m, l);
    }).then((f) => {
      if (f === null) {
        if (this.recordDroppedEvent("before_send", p), c) {
          const E = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", E);
        }
        throw Lr(`${l} returned \`null\`, will not send event.`);
      }
      const h = r.getSession() || s.getSession();
      if (a && h && this._updateSessionFromEvent(h, f), c) {
        const g = f.sdkProcessingMetadata?.spanCountBeforeProcessing || 0, E = f.spans ? f.spans.length : 0, R = g - E;
        R > 0 && this.recordDroppedEvent("before_send", "span", R);
      }
      const m = f.transaction_info;
      if (c && m && f.transaction !== t.transaction) {
        const g = "custom";
        f.transaction_info = {
          ...m,
          source: g
        };
      }
      return this.sendEvent(f, n), f;
    }).then(null, (f) => {
      throw eo(f) || Zi(f) ? f : (this.captureException(f, {
        mechanism: {
          handled: !1,
          type: "internal"
        },
        data: {
          __sentry__: !0
        },
        originalException: f
      }), qn(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${f}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.entries(t).map(([n, r]) => {
      const [s, i] = n.split(":");
      return {
        reason: s,
        category: i,
        quantity: r
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    v && _.log("Flushing outcomes...");
    const t = this._clearOutcomes();
    if (t.length === 0) {
      v && _.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      v && _.log("No dsn provided, will not send outcomes");
      return;
    }
    v && _.log("Sending outcomes:", t);
    const n = Zl(t, this._options.tunnel && Vt(this._dsn));
    this.sendEnvelope(n);
  }
  /**
   * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
   */
}
function sf(e, t) {
  const n = `${t} must return \`null\` or a valid event.`;
  if (Wt(e))
    return e.then(
      (r) => {
        if (!on(r) && r !== null)
          throw qn(n);
        return r;
      },
      (r) => {
        throw qn(`${t} rejected with ${r}`);
      }
    );
  if (!on(e) && e !== null)
    throw qn(n);
  return e;
}
function of(e, t, n, r) {
  const { beforeSend: s, beforeSendTransaction: i, beforeSendSpan: o, ignoreSpans: c } = t;
  let a = n;
  if (rs(a) && s)
    return s(a, r);
  if (Ya(a)) {
    if (o || c) {
      const u = ef(a);
      if (c?.length && Zn(u, c))
        return null;
      if (o) {
        const l = o(u);
        l ? a = mn(n, tf(l)) : Zr();
      }
      if (a.spans) {
        const l = [], d = a.spans;
        for (const f of d) {
          if (c?.length && Zn(f, c)) {
            Bd(d, f);
            continue;
          }
          if (o) {
            const h = o(f);
            h ? l.push(h) : (Zr(), l.push(f));
          } else
            l.push(f);
        }
        const p = a.spans.length - l.length;
        p && e.recordDroppedEvent("before_send", "span", p), a.spans = l;
      }
    }
    if (i) {
      if (a.spans) {
        const u = a.spans.length;
        a.sdkProcessingMetadata = {
          ...n.sdkProcessingMetadata,
          spanCountBeforeProcessing: u
        };
      }
      return i(a, r);
    }
  }
  return a;
}
function rs(e) {
  return e.type === void 0;
}
function Ya(e) {
  return e.type === "transaction";
}
function af(e) {
  let t = 0;
  return e.name && (t += e.name.length * 2), typeof e.value == "string" ? t += e.value.length * 2 : t += 8, t + Ka(e.attributes);
}
function cf(e) {
  let t = 0;
  return e.message && (t += e.message.length * 2), t + Ka(e.attributes);
}
function Ka(e) {
  if (!e)
    return 0;
  let t = 0;
  return Object.values(e).forEach((n) => {
    Array.isArray(n) ? t += n.length * no(n[0]) : Mt(n) ? t += no(n) : t += 100;
  }), t;
}
function no(e) {
  return typeof e == "string" ? e.length * 2 : typeof e == "number" ? 8 : typeof e == "boolean" ? 4 : 0;
}
function uf(e, t) {
  t.debug === !0 && (v ? _.enable() : Ve(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), G().update(t.initialScope);
  const r = new e(t);
  return df(r), r.init(), r;
}
function df(e) {
  G().setClient(e);
}
const Xa = Symbol.for("SentryBufferFullError");
function lf(e = 100) {
  const t = /* @__PURE__ */ new Set();
  function n() {
    return t.size < e;
  }
  function r(o) {
    t.delete(o);
  }
  function s(o) {
    if (!n())
      return Bs(Xa);
    const c = o();
    return t.add(c), c.then(
      () => r(c),
      () => r(c)
    ), c;
  }
  function i(o) {
    if (!t.size)
      return yr(!0);
    const c = Promise.allSettled(Array.from(t)).then(() => !0);
    if (!o)
      return c;
    const a = [c, new Promise((u) => setTimeout(() => u(!1), o))];
    return Promise.race(a);
  }
  return {
    get $() {
      return Array.from(t);
    },
    add: s,
    drain: i
  };
}
const ff = 60 * 1e3;
function pf(e, t = Date.now()) {
  const n = parseInt(`${e}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${e}`);
  return isNaN(r) ? ff : r - t;
}
function hf(e, t) {
  return e[t] || e.all || 0;
}
function Ja(e, t, n = Date.now()) {
  return hf(e, t) > n;
}
function Qa(e, { statusCode: t, headers: n }, r = Date.now()) {
  const s = {
    ...e
  }, i = n?.["x-sentry-rate-limits"], o = n?.["retry-after"];
  if (i)
    for (const c of i.trim().split(",")) {
      const [a, u, , , l] = c.split(":", 5), d = parseInt(a, 10), p = (isNaN(d) ? 60 : d) * 1e3;
      if (!u)
        s.all = r + p;
      else
        for (const f of u.split(";"))
          f === "metric_bucket" ? (!l || l.split(";").includes("custom")) && (s[f] = r + p) : s[f] = r + p;
    }
  else o ? s.all = r + pf(o, r) : t === 429 && (s.all = r + 60 * 1e3);
  return s;
}
const mf = 64;
function gf(e, t, n = lf(
  e.bufferSize || mf
)) {
  let r = {};
  const s = (o) => n.drain(o);
  function i(o) {
    const c = [];
    if (Li(o, (d, p) => {
      const f = Pi(p);
      Ja(r, f) ? e.recordDroppedEvent("ratelimit_backoff", f) : c.push(d);
    }), c.length === 0)
      return Promise.resolve({});
    const a = it(o[0], c), u = (d) => {
      Li(a, (p, f) => {
        e.recordDroppedEvent(d, Pi(f));
      });
    }, l = () => t({ body: Gd(a) }).then(
      (d) => (d.statusCode !== void 0 && (d.statusCode < 200 || d.statusCode >= 300) && v && _.warn(`Sentry responded with status code ${d.statusCode} to sent event.`), r = Qa(r, d), d),
      (d) => {
        throw u("network_error"), v && _.error("Encountered error running transport request:", d), d;
      }
    );
    return n.add(l).then(
      (d) => d,
      (d) => {
        if (d === Xa)
          return v && _.error("Skipped sending event because buffer is full."), u("queue_overflow"), Promise.resolve({});
        throw d;
      }
    );
  }
  return {
    send: i,
    flush: s
  };
}
const _f = "thismessage:/";
function Us(e) {
  return "isRelative" in e;
}
function Hs(e, t) {
  const n = e.indexOf("://") <= 0 && e.indexOf("//") !== 0, r = n ? _f : void 0;
  try {
    if ("canParse" in URL && !URL.canParse(e, r))
      return;
    const s = new URL(e, r);
    return n ? {
      isRelative: n,
      pathname: s.pathname,
      search: s.search,
      hash: s.hash
    } : s;
  } catch {
  }
}
function yf(e) {
  if (Us(e))
    return e.pathname;
  const t = new URL(e);
  return t.search = "", t.hash = "", ["80", "443"].includes(t.port) && (t.port = ""), t.password && (t.password = "%filtered%"), t.username && (t.username = "%filtered%"), t.toString();
}
function mt(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: n,
    hash: r,
    relative: t[5] + n + r
    // everything minus origin
  };
}
function Sf(e) {
  return e.split(/[?#]/, 1)[0];
}
function Ef(e, t) {
  const n = t?.getDsn(), r = t?.getOptions().tunnel;
  return vf(e, n) || bf(e, r);
}
function bf(e, t) {
  return t ? ro(e) === ro(t) : !1;
}
function vf(e, t) {
  const n = Hs(e);
  return !n || Us(n) ? !1 : t ? n.host.includes(t.host) && /(^|&|\?)sentry_key=/.test(n.search) : !1;
}
function ro(e) {
  return e[e.length - 1] === "/" ? e.slice(0, -1) : e;
}
function Tf(e) {
  "aggregates" in e ? e.attrs?.ip_address === void 0 && (e.attrs = {
    ...e.attrs,
    ip_address: "{{auto}}"
  }) : e.ipAddress === void 0 && (e.ipAddress = "{{auto}}");
}
function Za(e, t, n = [t], r = "npm") {
  const s = e._metadata || {};
  s.sdk || (s.sdk = {
    name: `sentry.javascript.${t}`,
    packages: n.map((i) => ({
      name: `${r}:@sentry/${i}`,
      version: ft
    })),
    version: ft
  }), e._metadata = s;
}
function ec(e = {}) {
  const t = e.client || U();
  if (!Fl() || !t)
    return {};
  const n = St(), r = zt(n);
  if (r.getTraceData)
    return r.getTraceData(e);
  const s = e.scope || G(), i = e.span || le(), o = i ? Nd(i) : If(s), c = i ? qe(i) : Ca(t, s), a = _d(c);
  if (!Sa.test(o))
    return _.warn("Invalid sentry-trace data. Cannot generate trace data"), {};
  const l = {
    "sentry-trace": o,
    baggage: a
  };
  if (e.propagateTraceparent) {
    const d = i ? Dd(i) : wf(s);
    d && (l.traceparent = d);
  }
  return l;
}
function If(e) {
  const { traceId: t, sampled: n, propagationSpanId: r } = e.getPropagationContext();
  return Ea(t, r, n);
}
function wf(e) {
  const { traceId: t, sampled: n, propagationSpanId: r } = e.getPropagationContext();
  return ba(t, r, n);
}
function kf(e, t, n) {
  let r, s, i;
  const o = n?.maxWait ? Math.max(n.maxWait, t) : 0, c = n?.setTimeoutImpl || setTimeout;
  function a() {
    return u(), r = e(), r;
  }
  function u() {
    s !== void 0 && clearTimeout(s), i !== void 0 && clearTimeout(i), s = i = void 0;
  }
  function l() {
    return s !== void 0 || i !== void 0 ? a() : r;
  }
  function d() {
    return s && clearTimeout(s), s = c(a, t), o && i === void 0 && (i = c(a, o)), r;
  }
  return d.cancel = u, d.flush = l, d;
}
const Rf = 100;
function et(e, t) {
  const n = U(), r = De();
  if (!n) return;
  const { beforeBreadcrumb: s = null, maxBreadcrumbs: i = Rf } = n.getOptions();
  if (i <= 0) return;
  const c = { timestamp: Et(), ...e }, a = s ? Ve(() => s(c, t)) : c;
  a !== null && (n.emit && n.emit("beforeAddBreadcrumb", a, t), r.addBreadcrumb(a, i));
}
let so;
const Cf = "FunctionToString", io = /* @__PURE__ */ new WeakMap(), xf = () => ({
  name: Cf,
  setupOnce() {
    so = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const t = Ms(this), n = io.has(U()) && t !== void 0 ? t : this;
        return so.apply(n, e);
      };
    } catch {
    }
  },
  setup(e) {
    io.set(e, !0);
  }
}), Mf = xf, Af = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  /^Can't find variable: gmo$/,
  // Error from Google Search App https://issuetracker.google.com/issues/396043331
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler",
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
  /^Java exception was raised during method invocation$/
  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
], Of = "EventFilters", Nf = (e = {}) => {
  let t;
  return {
    name: Of,
    setup(n) {
      const r = n.getOptions();
      t = oo(e, r);
    },
    processEvent(n, r, s) {
      if (!t) {
        const i = s.getOptions();
        t = oo(e, i);
      }
      return Lf(n, t) ? null : n;
    }
  };
}, Df = (e = {}) => ({
  ...Nf(e),
  name: "InboundFilters"
});
function oo(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : Af
    ],
    ignoreTransactions: [...e.ignoreTransactions || [], ...t.ignoreTransactions || []]
  };
}
function Lf(e, t) {
  if (e.type) {
    if (e.type === "transaction" && Ff(e, t.ignoreTransactions))
      return v && _.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${ut(e)}`
      ), !0;
  } else {
    if (Pf(e, t.ignoreErrors))
      return v && _.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${ut(e)}`
      ), !0;
    if (Hf(e))
      return v && _.warn(
        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${ut(
          e
        )}`
      ), !0;
    if ($f(e, t.denyUrls))
      return v && _.warn(
        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${ut(
          e
        )}.
Url: ${er(e)}`
      ), !0;
    if (!Bf(e, t.allowUrls))
      return v && _.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${ut(
          e
        )}.
Url: ${er(e)}`
      ), !0;
  }
  return !1;
}
function Pf(e, t) {
  return t?.length ? qa(e).some((n) => $e(n, t)) : !1;
}
function Ff(e, t) {
  if (!t?.length)
    return !1;
  const n = e.transaction;
  return n ? $e(n, t) : !1;
}
function $f(e, t) {
  if (!t?.length)
    return !1;
  const n = er(e);
  return n ? $e(n, t) : !1;
}
function Bf(e, t) {
  if (!t?.length)
    return !0;
  const n = er(e);
  return n ? $e(n, t) : !0;
}
function Uf(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function er(e) {
  try {
    const n = [...e.exception?.values ?? []].reverse().find((r) => r.mechanism?.parent_id === void 0 && r.stacktrace?.frames?.length)?.stacktrace?.frames;
    return n ? Uf(n) : null;
  } catch {
    return v && _.error(`Cannot extract url for event ${ut(e)}`), null;
  }
}
function Hf(e) {
  return e.exception?.values?.length ? (
    // No top-level message
    !e.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !e.exception.values.some((t) => t.stacktrace || t.type && t.type !== "Error" || t.value)
  ) : !1;
}
function Wf(e, t, n, r, s, i) {
  if (!s.exception?.values || !i || !We(i.originalException, Error))
    return;
  const o = s.exception.values.length > 0 ? s.exception.values[s.exception.values.length - 1] : void 0;
  o && (s.exception.values = ss(
    e,
    t,
    r,
    i.originalException,
    n,
    s.exception.values,
    o,
    0
  ));
}
function ss(e, t, n, r, s, i, o, c) {
  if (i.length >= n + 1)
    return i;
  let a = [...i];
  if (We(r[s], Error)) {
    ao(o, c);
    const u = e(t, r[s]), l = a.length;
    co(u, s, l, c), a = ss(
      e,
      t,
      n,
      r[s],
      s,
      [u, ...a],
      u,
      l
    );
  }
  return Array.isArray(r.errors) && r.errors.forEach((u, l) => {
    if (We(u, Error)) {
      ao(o, c);
      const d = e(t, u), p = a.length;
      co(d, `errors[${l}]`, p, c), a = ss(
        e,
        t,
        n,
        u,
        s,
        [d, ...a],
        d,
        p
      );
    }
  }), a;
}
function ao(e, t) {
  e.mechanism = {
    handled: !0,
    type: "auto.core.linked_errors",
    ...e.mechanism,
    ...e.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: t
  };
}
function co(e, t, n, r) {
  e.mechanism = {
    handled: !0,
    ...e.mechanism,
    type: "chained",
    source: t,
    exception_id: n,
    parent_id: r
  };
}
function jf(e) {
  const t = "console";
  nt(t, e), rt(t, zf);
}
function zf() {
  "console" in B && xu.forEach(function(e) {
    e in B.console && ge(B.console, e, function(t) {
      return Kn[e] = t, function(...n) {
        Ie("console", { args: n, level: e }), Kn[e]?.apply(B.console, n);
      };
    });
  });
}
function tc(e) {
  return e === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(e) ? e : "log";
}
const qf = "Dedupe", Vf = () => {
  let e;
  return {
    name: qf,
    processEvent(t) {
      if (t.type)
        return t;
      try {
        if (Yf(t, e))
          return v && _.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = t;
    }
  };
}, Gf = Vf;
function Yf(e, t) {
  return t ? !!(Kf(e, t) || Xf(e, t)) : !1;
}
function Kf(e, t) {
  const n = e.message, r = t.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !rc(e, t) || !nc(e, t));
}
function Xf(e, t) {
  const n = uo(t), r = uo(e);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !rc(e, t) || !nc(e, t));
}
function nc(e, t) {
  let n = Ei(e), r = Ei(t);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let s = 0; s < r.length; s++) {
    const i = r[s], o = n[s];
    if (i.filename !== o.filename || i.lineno !== o.lineno || i.colno !== o.colno || i.function !== o.function)
      return !1;
  }
  return !0;
}
function rc(e, t) {
  let n = e.fingerprint, r = t.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function uo(e) {
  return e.exception?.values?.[0];
}
function Jf(e, t, n, r, s) {
  if (!e.fetchData)
    return;
  const { method: i, url: o } = e.fetchData, c = we() && t(o);
  if (e.endTimestamp && c) {
    const f = e.fetchData.__span;
    if (!f) return;
    const h = r[f];
    h && (Zf(h, e), delete r[f]);
    return;
  }
  const { spanOrigin: a = "auto.http.browser", propagateTraceparent: u = !1 } = typeof s == "object" ? s : { spanOrigin: s }, l = !!le(), d = c && l ? Ze(tp(o, i, a)) : new Qe();
  if (e.fetchData.__span = d.spanContext().spanId, r[d.spanContext().spanId] = d, n(e.fetchData.url)) {
    const f = e.args[0], h = e.args[1] || {}, m = Qf(
      f,
      h,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      we() && l ? d : void 0,
      u
    );
    m && (e.args[1] = h, h.headers = m);
  }
  const p = U();
  if (p) {
    const f = {
      input: e.args,
      response: e.response,
      startTimestamp: e.startTimestamp,
      endTimestamp: e.endTimestamp
    };
    p.emit("beforeOutgoingRequestSpan", d, f);
  }
  return d;
}
function Qf(e, t, n, r) {
  const s = ec({ span: n, propagateTraceparent: r }), i = s["sentry-trace"], o = s.baggage, c = s.traceparent;
  if (!i)
    return;
  const a = t.headers || (oa(e) ? e.headers : void 0);
  if (a)
    if (ep(a)) {
      const u = new Headers(a);
      if (u.get("sentry-trace") || u.set("sentry-trace", i), r && c && !u.get("traceparent") && u.set("traceparent", c), o) {
        const l = u.get("baggage");
        l ? Mn(l) || u.set("baggage", `${l},${o}`) : u.set("baggage", o);
      }
      return u;
    } else if (Array.isArray(a)) {
      const u = [...a];
      a.find((d) => d[0] === "sentry-trace") || u.push(["sentry-trace", i]), r && c && !a.find((d) => d[0] === "traceparent") && u.push(["traceparent", c]);
      const l = a.find(
        (d) => d[0] === "baggage" && Mn(d[1])
      );
      return o && !l && u.push(["baggage", o]), u;
    } else {
      const u = "sentry-trace" in a ? a["sentry-trace"] : void 0, l = "traceparent" in a ? a.traceparent : void 0, d = "baggage" in a ? a.baggage : void 0, p = d ? Array.isArray(d) ? [...d] : [d] : [], f = d && (Array.isArray(d) ? d.find((m) => Mn(m)) : Mn(d));
      o && !f && p.push(o);
      const h = {
        ...a,
        "sentry-trace": u ?? i,
        baggage: p.length > 0 ? p.join(",") : void 0
      };
      return r && c && !l && (h.traceparent = c), h;
    }
  else return { ...s };
}
function Zf(e, t) {
  if (t.response) {
    ha(e, t.response.status);
    const n = t.response?.headers?.get("content-length");
    if (n) {
      const r = parseInt(n);
      r > 0 && e.setAttribute("http.response_content_length", r);
    }
  } else t.error && e.setStatus({ code: ce, message: "internal_error" });
  e.end();
}
function Mn(e) {
  return e.split(",").some((t) => t.trim().startsWith(Ns));
}
function ep(e) {
  return typeof Headers < "u" && We(e, Headers);
}
function tp(e, t, n) {
  const r = Hs(e);
  return {
    name: r ? `${t} ${yf(r)}` : t,
    attributes: np(e, r, t, n)
  };
}
function np(e, t, n, r) {
  const s = {
    url: e,
    type: "fetch",
    "http.method": n,
    [ne]: r,
    [ze]: "http.client"
  };
  return t && (Us(t) || (s["http.url"] = t.href, s["server.address"] = t.host), t.search && (s["http.query"] = t.search), t.hash && (s["http.fragment"] = t.hash)), s;
}
function sc(e) {
  if (e !== void 0)
    return e >= 400 && e < 500 ? "warning" : e >= 500 ? "error" : void 0;
}
const un = B;
function rp() {
  return "history" in un && !!un.history;
}
function sp() {
  if (!("fetch" in un))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function is(e) {
  return e && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function ip() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!sp())
    return !1;
  if (is(un.fetch))
    return !0;
  let e = !1;
  const t = un.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow?.fetch && (e = is(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      v && _.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function ic(e, t) {
  const n = "fetch";
  nt(n, e), rt(n, () => oc(void 0, t));
}
function op(e) {
  const t = "fetch-body-resolved";
  nt(t, e), rt(t, () => oc(cp));
}
function oc(e, t = !1) {
  t && !ip() || ge(B, "fetch", function(n) {
    return function(...r) {
      const s = new Error(), { method: i, url: o } = up(r), c = {
        args: r,
        fetchData: {
          method: i,
          url: o
        },
        startTimestamp: oe() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError: s,
        headers: dp(r)
      };
      return e || Ie("fetch", {
        ...c
      }), n.apply(B, r).then(
        async (a) => (e ? e(a) : Ie("fetch", {
          ...c,
          endTimestamp: oe() * 1e3,
          response: a
        }), a),
        (a) => {
          if (Ie("fetch", {
            ...c,
            endTimestamp: oe() * 1e3,
            error: a
          }), Rs(a) && a.stack === void 0 && (a.stack = s.stack, be(a, "framesToPop", 1)), a instanceof TypeError && (a.message === "Failed to fetch" || a.message === "Load failed" || a.message === "NetworkError when attempting to fetch resource."))
            try {
              const u = new URL(c.fetchData.url);
              a.message = `${a.message} (${u.host})`;
            } catch {
            }
          throw a;
        }
      );
    };
  });
}
async function ap(e, t) {
  if (e?.body) {
    const n = e.body, r = n.getReader(), s = setTimeout(
      () => {
        n.cancel().then(null, () => {
        });
      },
      90 * 1e3
      // 90s
    );
    let i = !0;
    for (; i; ) {
      let o;
      try {
        o = setTimeout(() => {
          n.cancel().then(null, () => {
          });
        }, 5e3);
        const { done: c } = await r.read();
        clearTimeout(o), c && (t(), i = !1);
      } catch {
        i = !1;
      } finally {
        clearTimeout(o);
      }
    }
    clearTimeout(s), r.releaseLock(), n.cancel().then(null, () => {
    });
  }
}
function cp(e) {
  let t;
  try {
    t = e.clone();
  } catch {
    return;
  }
  ap(t, () => {
    Ie("fetch-body-resolved", {
      endTimestamp: oe() * 1e3,
      response: e
    });
  });
}
function os(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function lo(e) {
  return typeof e == "string" ? e : e ? os(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function up(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [n, r] = e;
    return {
      url: lo(n),
      method: os(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: lo(t),
    method: os(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
function dp(e) {
  const [t, n] = e;
  try {
    if (typeof n == "object" && n !== null && "headers" in n && n.headers)
      return new Headers(n.headers);
    if (oa(t))
      return new Headers(t.headers);
  } catch {
  }
}
function lp() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function fp() {
  return "npm";
}
function pp() {
  return !lp() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function fo() {
  return typeof window < "u" && (!pp() || hp());
}
function hp() {
  return B.process?.type === "renderer";
}
const z = B;
let as = 0;
function ac() {
  return as > 0;
}
function mp() {
  as++, setTimeout(() => {
    as--;
  });
}
function Lt(e, t = {}) {
  function n(s) {
    return typeof s == "function";
  }
  if (!n(e))
    return e;
  try {
    const s = e.__sentry_wrapped__;
    if (s)
      return typeof s == "function" ? s : e;
    if (Ms(e))
      return e;
  } catch {
    return e;
  }
  const r = function(...s) {
    try {
      const i = s.map((o) => Lt(o, t));
      return e.apply(this, i);
    } catch (i) {
      throw mp(), gr((o) => {
        o.addEventProcessor((c) => (t.mechanism && (Xr(c, void 0), At(c, t.mechanism)), c.extra = {
          ...c.extra,
          arguments: s
        }, c)), yn(i);
      }), i;
    }
  };
  try {
    for (const s in e)
      Object.prototype.hasOwnProperty.call(e, s) && (r[s] = e[s]);
  } catch {
  }
  ca(r, e), be(e, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return r;
}
function Ws() {
  const e = jt(), { referrer: t } = z.document || {}, { userAgent: n } = z.navigator || {}, r = {
    ...t && { Referer: t },
    ...n && { "User-Agent": n }
  };
  return {
    url: e,
    headers: r
  };
}
function js(e, t) {
  const n = zs(e, t), r = {
    type: Ep(t),
    value: bp(t)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function gp(e, t, n, r) {
  const i = U()?.getOptions().normalizeDepth, o = kp(t), c = {
    __serialized__: xa(t, i)
  };
  if (o)
    return {
      exception: {
        values: [js(e, o)]
      },
      extra: c
    };
  const a = {
    exception: {
      values: [
        {
          type: mr(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error",
          value: Ip(t, { isUnhandledRejection: r })
        }
      ]
    },
    extra: c
  };
  if (n) {
    const u = zs(e, n);
    u.length && (a.exception.values[0].stacktrace = { frames: u });
  }
  return a;
}
function Pr(e, t) {
  return {
    exception: {
      values: [js(e, t)]
    }
  };
}
function zs(e, t) {
  const n = t.stacktrace || t.stack || "", r = yp(t), s = Sp(t);
  try {
    return e(n, r, s);
  } catch {
  }
  return [];
}
const _p = /Minified React error #\d+;/i;
function yp(e) {
  return e && _p.test(e.message) ? 1 : 0;
}
function Sp(e) {
  return typeof e.framesToPop == "number" ? e.framesToPop : 0;
}
function cc(e) {
  return typeof WebAssembly < "u" && typeof WebAssembly.Exception < "u" ? e instanceof WebAssembly.Exception : !1;
}
function Ep(e) {
  const t = e?.name;
  return !t && cc(e) ? e.message && Array.isArray(e.message) && e.message.length == 2 ? e.message[0] : "WebAssembly.Exception" : t;
}
function bp(e) {
  const t = e?.message;
  return cc(e) ? Array.isArray(e.message) && e.message.length == 2 ? e.message[1] : "wasm exception" : t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function vp(e, t, n, r) {
  const s = n?.syntheticException || void 0, i = qs(e, t, s, r);
  return At(i), i.level = "error", n?.event_id && (i.event_id = n.event_id), yr(i);
}
function Tp(e, t, n = "info", r, s) {
  const i = r?.syntheticException || void 0, o = cs(e, t, i, s);
  return o.level = n, r?.event_id && (o.event_id = r.event_id), yr(o);
}
function qs(e, t, n, r, s) {
  let i;
  if (sa(t) && t.error)
    return Pr(e, t.error);
  if (vi(t) || Uu(t)) {
    const o = t;
    if ("stack" in t)
      i = Pr(e, t);
    else {
      const c = o.name || (vi(o) ? "DOMError" : "DOMException"), a = o.message ? `${c}: ${o.message}` : c;
      i = cs(e, a, n, r), Xr(i, a);
    }
    return "code" in o && (i.tags = { ...i.tags, "DOMException.code": `${o.code}` }), i;
  }
  return Rs(t) ? Pr(e, t) : on(t) || mr(t) ? (i = gp(e, t, n, s), At(i, {
    synthetic: !0
  }), i) : (i = cs(e, t, n, r), Xr(i, `${t}`), At(i, {
    synthetic: !0
  }), i);
}
function cs(e, t, n, r) {
  const s = {};
  if (r && n) {
    const i = zs(e, n);
    i.length && (s.exception = {
      values: [{ value: t, stacktrace: { frames: i } }]
    }), At(s, { synthetic: !0 });
  }
  if (Cs(t)) {
    const { __sentry_template_string__: i, __sentry_template_values__: o } = t;
    return s.logentry = {
      message: i,
      params: o
    }, s;
  }
  return s.message = t, s;
}
function Ip(e, { isUnhandledRejection: t }) {
  const n = Vu(e), r = t ? "promise rejection" : "exception";
  return sa(e) ? `Event \`ErrorEvent\` captured as ${r} with message \`${e.message}\`` : mr(e) ? `Event \`${wp(e)}\` (type=${e.type}) captured as ${r}` : `Object captured as ${r} with keys: ${n}`;
}
function wp(e) {
  try {
    const t = Object.getPrototypeOf(e);
    return t ? t.constructor.name : void 0;
  } catch {
  }
}
function kp(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const n = e[t];
      if (n instanceof Error)
        return n;
    }
}
class Rp extends rf {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const n = Cp(t), r = z.SENTRY_SDK_SOURCE || fp();
    Za(n, "browser", ["browser"], r), n._metadata?.sdk && (n._metadata.sdk.settings = {
      infer_ip: n.sendDefaultPii ? "auto" : "never",
      // purposefully allowing already passed settings to override the default
      ...n._metadata.sdk.settings
    }), super(n);
    const { sendDefaultPii: s, sendClientReports: i, enableLogs: o, _experiments: c } = this._options;
    z.document && (i || o || c?.enableMetrics) && z.document.addEventListener("visibilitychange", () => {
      z.document.visibilityState === "hidden" && (i && this._flushOutcomes(), o && Ha(this), c?.enableMetrics && ja(this));
    }), s && this.on("beforeSendSession", Tf);
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, n) {
    return vp(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, n = "info", r) {
    return Tp(this._options.stackParser, t, n, r, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, n, r, s) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, r, s);
  }
}
function Cp(e) {
  return {
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : z.SENTRY_RELEASE?.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: !0,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: !0,
    ...e
  };
}
const Pt = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, O = B, xp = (e, t) => e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good", Sn = (e, t, n, r) => {
  let s, i;
  return (o) => {
    t.value >= 0 && (o || r) && (i = t.value - (s ?? 0), (i || s === void 0) && (s = t.value, t.delta = i, t.rating = xp(t.value, n), e(t)));
  };
}, Mp = () => `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, En = (e = !0) => {
  const t = O.performance?.getEntriesByType?.("navigation")[0];
  if (
    // sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !e || t && t.responseStart > 0 && t.responseStart < performance.now()
  )
    return t;
}, Gt = () => En()?.activationStart ?? 0, bn = (e, t = -1) => {
  const n = En();
  let r = "navigate";
  return n && (O.document?.prerendering || Gt() > 0 ? r = "prerender" : O.document?.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), {
    name: e,
    value: t,
    rating: "good",
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries: [],
    id: Mp(),
    navigationType: r
  };
}, Fr = /* @__PURE__ */ new WeakMap();
function Vs(e, t) {
  return Fr.get(e) || Fr.set(e, new t()), Fr.get(e);
}
class tr {
  constructor() {
    tr.prototype.__init.call(this), tr.prototype.__init2.call(this);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._sessionValue = 0;
  }
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._sessionEntries = [];
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    if (t.hadRecentInput) return;
    const n = this._sessionEntries[0], r = this._sessionEntries[this._sessionEntries.length - 1];
    this._sessionValue && n && r && t.startTime - r.startTime < 1e3 && t.startTime - n.startTime < 5e3 ? (this._sessionValue += t.value, this._sessionEntries.push(t)) : (this._sessionValue = t.value, this._sessionEntries = [t]), this._onAfterProcessingUnexpectedShift?.(t);
  }
}
const Yt = (e, t, n = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const r = new PerformanceObserver((s) => {
        Promise.resolve().then(() => {
          t(s.getEntries());
        });
      });
      return r.observe({ type: e, buffered: !0, ...n }), r;
    }
  } catch {
  }
}, Gs = (e) => {
  let t = !1;
  return () => {
    t || (e(), t = !0);
  };
};
let Zt = -1;
const Ap = () => O.document?.visibilityState === "hidden" && !O.document?.prerendering ? 0 : 1 / 0, nr = (e) => {
  O.document.visibilityState === "hidden" && Zt > -1 && (Zt = e.type === "visibilitychange" ? e.timeStamp : 0, Np());
}, Op = () => {
  addEventListener("visibilitychange", nr, !0), addEventListener("prerenderingchange", nr, !0);
}, Np = () => {
  removeEventListener("visibilitychange", nr, !0), removeEventListener("prerenderingchange", nr, !0);
}, Ys = () => {
  if (O.document && Zt < 0) {
    const e = Gt();
    Zt = (O.document.prerendering ? void 0 : globalThis.performance.getEntriesByType("visibility-state").filter((n) => n.name === "hidden" && n.startTime > e)[0]?.startTime) ?? Ap(), Op();
  }
  return {
    get firstHiddenTime() {
      return Zt;
    }
  };
}, Sr = (e) => {
  O.document?.prerendering ? addEventListener("prerenderingchange", () => e(), !0) : e();
}, Dp = [1800, 3e3], Lp = (e, t = {}) => {
  Sr(() => {
    const n = Ys(), r = bn("FCP");
    let s;
    const o = Yt("paint", (c) => {
      for (const a of c)
        a.name === "first-contentful-paint" && (o.disconnect(), a.startTime < n.firstHiddenTime && (r.value = Math.max(a.startTime - Gt(), 0), r.entries.push(a), s(!0)));
    });
    o && (s = Sn(e, r, Dp, t.reportAllChanges));
  });
}, Pp = [0.1, 0.25], Fp = (e, t = {}) => {
  Lp(
    Gs(() => {
      const n = bn("CLS", 0);
      let r;
      const s = Vs(t, tr), i = (c) => {
        for (const a of c)
          s._processEntry(a);
        s._sessionValue > n.value && (n.value = s._sessionValue, n.entries = s._sessionEntries, r());
      }, o = Yt("layout-shift", i);
      o && (r = Sn(e, n, Pp, t.reportAllChanges), O.document?.addEventListener("visibilitychange", () => {
        O.document?.visibilityState === "hidden" && (i(o.takeRecords()), r(!0));
      }), O?.setTimeout?.(r));
    })
  );
};
let uc = 0, $r = 1 / 0, An = 0;
const $p = (e) => {
  e.forEach((t) => {
    t.interactionId && ($r = Math.min($r, t.interactionId), An = Math.max(An, t.interactionId), uc = An ? (An - $r) / 7 + 1 : 0);
  });
};
let us;
const dc = () => us ? uc : performance.interactionCount || 0, Bp = () => {
  "interactionCount" in performance || us || (us = Yt("event", $p, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, Br = 10;
let lc = 0;
const Up = () => dc() - lc;
class rr {
  constructor() {
    rr.prototype.__init.call(this), rr.prototype.__init2.call(this);
  }
  /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._longestInteractionList = [];
  }
  /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._longestInteractionMap = /* @__PURE__ */ new Map();
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _resetInteractions() {
    lc = dc(), this._longestInteractionList.length = 0, this._longestInteractionMap.clear();
  }
  /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _estimateP98LongestInteraction() {
    const t = Math.min(
      this._longestInteractionList.length - 1,
      Math.floor(Up() / 50)
    );
    return this._longestInteractionList[t];
  }
  /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    if (this._onBeforeProcessingEntry?.(t), !(t.interactionId || t.entryType === "first-input")) return;
    const n = this._longestInteractionList.at(-1);
    let r = this._longestInteractionMap.get(t.interactionId);
    if (r || this._longestInteractionList.length < Br || // If the above conditions are false, `minLongestInteraction` will be set.
    t.duration > n._latency) {
      if (r ? t.duration > r._latency ? (r.entries = [t], r._latency = t.duration) : t.duration === r._latency && t.startTime === r.entries[0].startTime && r.entries.push(t) : (r = {
        id: t.interactionId,
        entries: [t],
        _latency: t.duration
      }, this._longestInteractionMap.set(r.id, r), this._longestInteractionList.push(r)), this._longestInteractionList.sort((s, i) => i._latency - s._latency), this._longestInteractionList.length > Br) {
        const s = this._longestInteractionList.splice(Br);
        for (const i of s)
          this._longestInteractionMap.delete(i.id);
      }
      this._onAfterProcessingINPCandidate?.(r);
    }
  }
}
const Ks = (e) => {
  const t = (n) => {
    (n.type === "pagehide" || O.document?.visibilityState === "hidden") && e(n);
  };
  O.document && (addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0));
}, fc = (e) => {
  const t = O.requestIdleCallback || O.setTimeout;
  O.document?.visibilityState === "hidden" ? e() : (e = Gs(e), t(e), Ks(e));
}, Hp = [200, 500], Wp = 40, jp = (e, t = {}) => {
  globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype && Sr(() => {
    Bp();
    const n = bn("INP");
    let r;
    const s = Vs(t, rr), i = (c) => {
      fc(() => {
        for (const u of c)
          s._processEntry(u);
        const a = s._estimateP98LongestInteraction();
        a && a._latency !== n.value && (n.value = a._latency, n.entries = a.entries, r());
      });
    }, o = Yt("event", i, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: t.durationThreshold ?? Wp
    });
    r = Sn(e, n, Hp, t.reportAllChanges), o && (o.observe({ type: "first-input", buffered: !0 }), Ks(() => {
      i(o.takeRecords()), r(!0);
    }));
  });
};
class zp {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _processEntry(t) {
    this._onBeforeProcessingEntry?.(t);
  }
}
const qp = [2500, 4e3], Vp = (e, t = {}) => {
  Sr(() => {
    const n = Ys(), r = bn("LCP");
    let s;
    const i = Vs(t, zp), o = (a) => {
      t.reportAllChanges || (a = a.slice(-1));
      for (const u of a)
        i._processEntry(u), u.startTime < n.firstHiddenTime && (r.value = Math.max(u.startTime - Gt(), 0), r.entries = [u], s());
    }, c = Yt("largest-contentful-paint", o);
    if (c) {
      s = Sn(e, r, qp, t.reportAllChanges);
      const a = Gs(() => {
        o(c.takeRecords()), c.disconnect(), s(!0);
      });
      for (const u of ["keydown", "click", "visibilitychange"])
        O.document && addEventListener(u, () => fc(a), {
          capture: !0,
          once: !0
        });
    }
  });
}, Gp = [800, 1800], ds = (e) => {
  O.document?.prerendering ? Sr(() => ds(e)) : O.document?.readyState !== "complete" ? addEventListener("load", () => ds(e), !0) : setTimeout(e);
}, Yp = (e, t = {}) => {
  const n = bn("TTFB"), r = Sn(e, n, Gp, t.reportAllChanges);
  ds(() => {
    const s = En();
    s && (n.value = Math.max(s.responseStart - Gt(), 0), n.entries = [s], r(!0));
  });
}, en = {}, sr = {};
let pc, hc, mc, gc;
function Xs(e, t = !1) {
  return Er("cls", e, Xp, pc, t);
}
function Js(e, t = !1) {
  return Er("lcp", e, Jp, hc, t);
}
function Kp(e) {
  return Er("ttfb", e, Qp, mc);
}
function _c(e) {
  return Er("inp", e, Zp, gc);
}
function yt(e, t) {
  return yc(e, t), sr[e] || (eh(e), sr[e] = !0), Sc(e, t);
}
function vn(e, t) {
  const n = en[e];
  if (n?.length)
    for (const r of n)
      try {
        r(t);
      } catch (s) {
        Pt && _.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${He(r)}
Error:`,
          s
        );
      }
}
function Xp() {
  return Fp(
    (e) => {
      vn("cls", {
        metric: e
      }), pc = e;
    },
    // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function Jp() {
  return Vp(
    (e) => {
      vn("lcp", {
        metric: e
      }), hc = e;
    },
    // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function Qp() {
  return Yp((e) => {
    vn("ttfb", {
      metric: e
    }), mc = e;
  });
}
function Zp() {
  return jp((e) => {
    vn("inp", {
      metric: e
    }), gc = e;
  });
}
function Er(e, t, n, r, s = !1) {
  yc(e, t);
  let i;
  return sr[e] || (i = n(), sr[e] = !0), r && t({ metric: r }), Sc(e, t, s ? i : void 0);
}
function eh(e) {
  const t = {};
  e === "event" && (t.durationThreshold = 0), Yt(
    e,
    (n) => {
      vn(e, { entries: n });
    },
    t
  );
}
function yc(e, t) {
  en[e] = en[e] || [], en[e].push(t);
}
function Sc(e, t, n) {
  return () => {
    n && n();
    const r = en[e];
    if (!r)
      return;
    const s = r.indexOf(t);
    s !== -1 && r.splice(s, 1);
  };
}
function th(e) {
  return "duration" in e;
}
function Ur(e) {
  return typeof e == "number" && isFinite(e);
}
function tt(e, t, n, { ...r }) {
  const s = $(e).start_timestamp;
  return s && s > t && typeof e.updateStartTime == "function" && e.updateStartTime(t), Fs(e, () => {
    const i = Ze({
      startTime: t,
      ...r
    });
    return i && i.end(n), i;
  });
}
function Qs(e) {
  const t = U();
  if (!t)
    return;
  const { name: n, transaction: r, attributes: s, startTime: i } = e, { release: o, environment: c, sendDefaultPii: a } = t.getOptions(), l = t.getIntegrationByName("Replay")?.getReplayId(), d = G(), p = d.getUser(), f = p !== void 0 ? p.email || p.id || p.ip_address : void 0;
  let h;
  try {
    h = d.getScopeData().contexts.profile.profile_id;
  } catch {
  }
  const m = {
    release: o,
    environment: c,
    user: f || void 0,
    profile_id: h || void 0,
    replay_id: l || void 0,
    transaction: r,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    "user_agent.original": O.navigator?.userAgent,
    // This tells Sentry to infer the IP address from the request
    "client.address": a ? "{{auto}}" : void 0,
    ...s
  };
  return Ze({
    name: n,
    attributes: m,
    startTime: i,
    experimental: {
      standalone: !0
    }
  });
}
function Tn() {
  return O.addEventListener && O.performance;
}
function ie(e) {
  return e / 1e3;
}
function nh(e) {
  let t = "unknown", n = "unknown", r = "";
  for (const s of e) {
    if (s === "/") {
      [t, n] = e.split("/");
      break;
    }
    if (!isNaN(Number(s))) {
      t = r === "h" ? "http" : r, n = e.split(r)[1];
      break;
    }
    r += s;
  }
  return r === e && (t = r), { name: t, version: n };
}
function Ec(e) {
  try {
    return PerformanceObserver.supportedEntryTypes.includes(e);
  } catch {
    return !1;
  }
}
function bc(e, t) {
  let n, r = !1;
  function s(c) {
    !r && n && t(c, n), r = !0;
  }
  Ks(() => {
    s("pagehide");
  });
  const i = e.on("beforeStartNavigationSpan", (c, a) => {
    a?.isRedirect || (s("navigation"), i(), o());
  }), o = e.on("afterStartPageLoadSpan", (c) => {
    n = c.spanContext().spanId, o();
  });
}
function rh(e) {
  let t = 0, n;
  if (!Ec("layout-shift"))
    return;
  const r = Xs(({ metric: s }) => {
    const i = s.entries[s.entries.length - 1];
    i && (t = s.value, n = i);
  }, !0);
  bc(e, (s, i) => {
    sh(t, n, i, s), r();
  });
}
function sh(e, t, n, r) {
  Pt && _.log(`Sending CLS span (${e})`);
  const s = t ? ie((ye() || 0) + t.startTime) : oe(), i = G().getScopeData().transactionName, o = t ? ke(t.sources[0]?.node) : "Layout shift", c = {
    [ne]: "auto.http.browser.cls",
    [ze]: "ui.webvital.cls",
    [qt]: 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    "sentry.pageload.span_id": n,
    // describes what triggered the web vital to be reported
    "sentry.report_event": r
  };
  t?.sources && t.sources.forEach((u, l) => {
    c[`cls.source.${l + 1}`] = ke(u.node);
  });
  const a = Qs({
    name: o,
    transaction: i,
    attributes: c,
    startTime: s
  });
  a && (a.addEvent("cls", {
    [gn]: "",
    [_n]: e
  }), a.end(s));
}
function ih(e) {
  let t = 0, n;
  if (!Ec("largest-contentful-paint"))
    return;
  const r = Js(({ metric: s }) => {
    const i = s.entries[s.entries.length - 1];
    i && (t = s.value, n = i);
  }, !0);
  bc(e, (s, i) => {
    oh(t, n, i, s), r();
  });
}
function oh(e, t, n, r) {
  Pt && _.log(`Sending LCP span (${e})`);
  const s = ie((ye() || 0) + (t?.startTime || 0)), i = G().getScopeData().transactionName, o = t ? ke(t.element) : "Largest contentful paint", c = {
    [ne]: "auto.http.browser.lcp",
    [ze]: "ui.webvital.lcp",
    [qt]: 0,
    // LCP is a point-in-time metric
    // attach the pageload span id to the LCP span so that we can link them in the UI
    "sentry.pageload.span_id": n,
    // describes what triggered the web vital to be reported
    "sentry.report_event": r
  };
  t && (t.element && (c["lcp.element"] = ke(t.element)), t.id && (c["lcp.id"] = t.id), t.url && (c["lcp.url"] = t.url.trim().slice(0, 200)), t.loadTime != null && (c["lcp.loadTime"] = t.loadTime), t.renderTime != null && (c["lcp.renderTime"] = t.renderTime), t.size != null && (c["lcp.size"] = t.size));
  const a = Qs({
    name: o,
    transaction: i,
    attributes: c,
    startTime: s
  });
  a && (a.addEvent("lcp", {
    [gn]: "millisecond",
    [_n]: e
  }), a.end(s));
}
function Te(e) {
  return e && ((ye() || performance.timeOrigin) + e) / 1e3;
}
function vc(e) {
  const t = {};
  if (e.nextHopProtocol != null) {
    const { name: n, version: r } = nh(e.nextHopProtocol);
    t["network.protocol.version"] = r, t["network.protocol.name"] = n;
  }
  return ye() || Tn()?.timeOrigin ? ah({
    ...t,
    "http.request.redirect_start": Te(e.redirectStart),
    "http.request.redirect_end": Te(e.redirectEnd),
    "http.request.worker_start": Te(e.workerStart),
    "http.request.fetch_start": Te(e.fetchStart),
    "http.request.domain_lookup_start": Te(e.domainLookupStart),
    "http.request.domain_lookup_end": Te(e.domainLookupEnd),
    "http.request.connect_start": Te(e.connectStart),
    "http.request.secure_connection_start": Te(e.secureConnectionStart),
    "http.request.connection_end": Te(e.connectEnd),
    "http.request.request_start": Te(e.requestStart),
    "http.request.response_start": Te(e.responseStart),
    "http.request.response_end": Te(e.responseEnd),
    // For TTFB we actually want the relative time from timeOrigin to responseStart
    // This way, TTFB always measures the "first page load" experience.
    // see: https://web.dev/articles/ttfb#measure-resource-requests
    "http.request.time_to_first_byte": e.responseStart != null ? e.responseStart / 1e3 : void 0
  }) : t;
}
function ah(e) {
  return Object.fromEntries(Object.entries(e).filter(([, t]) => t != null));
}
const ch = 2147483647;
let po = 0, Ae = {}, me, ir;
function uh({
  recordClsStandaloneSpans: e,
  recordLcpStandaloneSpans: t,
  client: n
}) {
  const r = Tn();
  if (r && ye()) {
    r.mark && O.performance.mark("sentry-tracing-init");
    const s = t ? ih(n) : hh(), i = mh(), o = e ? rh(n) : ph();
    return () => {
      s?.(), i(), o?.();
    };
  }
  return () => {
  };
}
function dh() {
  yt("longtask", ({ entries: e }) => {
    const t = le();
    if (!t)
      return;
    const { op: n, start_timestamp: r } = $(t);
    for (const s of e) {
      const i = ie(ye() + s.startTime), o = ie(s.duration);
      n === "navigation" && r && i < r || tt(t, i, i + o, {
        name: "Main UI thread blocked",
        op: "ui.long-task",
        attributes: {
          [ne]: "auto.ui.browser.metrics"
        }
      });
    }
  });
}
function lh() {
  new PerformanceObserver((t) => {
    const n = le();
    if (n)
      for (const r of t.getEntries()) {
        if (!r.scripts[0])
          continue;
        const s = ie(ye() + r.startTime), { start_timestamp: i, op: o } = $(n);
        if (o === "navigation" && i && s < i)
          continue;
        const c = ie(r.duration), a = {
          [ne]: "auto.ui.browser.metrics"
        }, u = r.scripts[0], { invoker: l, invokerType: d, sourceURL: p, sourceFunctionName: f, sourceCharPosition: h } = u;
        a["browser.script.invoker"] = l, a["browser.script.invoker_type"] = d, p && (a["code.filepath"] = p), f && (a["code.function"] = f), h !== -1 && (a["browser.script.source_char_position"] = h), tt(n, s, s + c, {
          name: "Main UI thread blocked",
          op: "ui.long-animation-frame",
          attributes: a
        });
      }
  }).observe({ type: "long-animation-frame", buffered: !0 });
}
function fh() {
  yt("event", ({ entries: e }) => {
    const t = le();
    if (t) {
      for (const n of e)
        if (n.name === "click") {
          const r = ie(ye() + n.startTime), s = ie(n.duration), i = {
            name: ke(n.target),
            op: `ui.interaction.${n.name}`,
            startTime: r,
            attributes: {
              [ne]: "auto.ui.browser.metrics"
            }
          }, o = aa(n.target);
          o && (i.attributes["ui.component_name"] = o), tt(t, r, r + s, i);
        }
    }
  });
}
function ph() {
  return Xs(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (Ae.cls = { value: e.value, unit: "" }, ir = t);
  }, !0);
}
function hh() {
  return Js(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (Ae.lcp = { value: e.value, unit: "millisecond" }, me = t);
  }, !0);
}
function mh() {
  return Kp(({ metric: e }) => {
    e.entries[e.entries.length - 1] && (Ae.ttfb = { value: e.value, unit: "millisecond" });
  });
}
function gh(e, t) {
  const n = Tn(), r = ye();
  if (!n?.getEntries || !r)
    return;
  const s = ie(r), i = n.getEntries(), { op: o, start_timestamp: c } = $(e);
  i.slice(po).forEach((a) => {
    const u = ie(a.startTime), l = ie(
      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
      Math.max(0, a.duration)
    );
    if (!(o === "navigation" && c && s + u < c))
      switch (a.entryType) {
        case "navigation": {
          Eh(e, a, s);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          yh(e, a, u, l, s, t.ignorePerformanceApiSpans);
          const d = Ys(), p = a.startTime < d.firstHiddenTime;
          a.name === "first-paint" && p && (Ae.fp = { value: a.startTime, unit: "millisecond" }), a.name === "first-contentful-paint" && p && (Ae.fcp = { value: a.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          Th(
            e,
            a,
            a.name,
            u,
            l,
            s,
            t.ignoreResourceSpans
          );
          break;
        }
      }
  }), po = Math.max(i.length - 1, 0), Ih(e), o === "pageload" && (Rh(Ae), t.recordClsOnPageloadSpan || delete Ae.cls, t.recordLcpOnPageloadSpan || delete Ae.lcp, Object.entries(Ae).forEach(([a, u]) => {
    sl(a, u.value, u.unit);
  }), e.setAttribute("performance.timeOrigin", s), e.setAttribute("performance.activationStart", Gt()), wh(e, t)), me = void 0, ir = void 0, Ae = {};
}
function _h(e) {
  if (e?.entryType === "measure")
    try {
      return e.detail.devtools.track === "Components ⚛";
    } catch {
      return;
    }
}
function yh(e, t, n, r, s, i) {
  if (_h(t) || ["mark", "measure"].includes(t.entryType) && $e(t.name, i))
    return;
  const o = En(!1), c = ie(o ? o.requestStart : 0), a = s + Math.max(n, c), u = s + n, l = u + r, d = {
    [ne]: "auto.resource.browser.metrics"
  };
  a !== u && (d["sentry.browser.measure_happened_before_request"] = !0, d["sentry.browser.measure_start_time"] = a), Sh(d, t), a <= l && tt(e, a, l, {
    name: t.name,
    op: t.entryType,
    attributes: d
  });
}
function Sh(e, t) {
  try {
    const n = t.detail;
    if (!n)
      return;
    if (typeof n == "object") {
      for (const [r, s] of Object.entries(n))
        if (s && Mt(s))
          e[`sentry.browser.measure.detail.${r}`] = s;
        else if (s !== void 0)
          try {
            e[`sentry.browser.measure.detail.${r}`] = JSON.stringify(s);
          } catch {
          }
      return;
    }
    if (Mt(n)) {
      e["sentry.browser.measure.detail"] = n;
      return;
    }
    try {
      e["sentry.browser.measure.detail"] = JSON.stringify(n);
    } catch {
    }
  } catch {
  }
}
function Eh(e, t, n) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((r) => {
    On(e, t, r, n);
  }), On(e, t, "secureConnection", n, "TLS/SSL"), On(e, t, "fetch", n, "cache"), On(e, t, "domainLookup", n, "DNS"), vh(e, t, n);
}
function On(e, t, n, r, s = n) {
  const i = bh(n), o = t[i], c = t[`${n}Start`];
  !c || !o || tt(e, r + ie(c), r + ie(o), {
    op: `browser.${s}`,
    name: t.name,
    attributes: {
      [ne]: "auto.ui.browser.metrics",
      ...n === "redirect" && t.redirectCount != null ? { "http.redirect_count": t.redirectCount } : {}
    }
  });
}
function bh(e) {
  return e === "secureConnection" ? "connectEnd" : e === "fetch" ? "domainLookupStart" : `${e}End`;
}
function vh(e, t, n) {
  const r = n + ie(t.requestStart), s = n + ie(t.responseEnd), i = n + ie(t.responseStart);
  t.responseEnd && (tt(e, r, s, {
    op: "browser.request",
    name: t.name,
    attributes: {
      [ne]: "auto.ui.browser.metrics"
    }
  }), tt(e, i, s, {
    op: "browser.response",
    name: t.name,
    attributes: {
      [ne]: "auto.ui.browser.metrics"
    }
  }));
}
function Th(e, t, n, r, s, i, o) {
  if (t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch")
    return;
  const c = t.initiatorType ? `resource.${t.initiatorType}` : "resource.other";
  if (o?.includes(c))
    return;
  const a = {
    [ne]: "auto.resource.browser.metrics"
  }, u = mt(n);
  u.protocol && (a["url.scheme"] = u.protocol.split(":").pop()), u.host && (a["server.address"] = u.host), a["url.same_origin"] = n.includes(O.location.origin), kh(t, a, [
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
    ["responseStatus", "http.response.status_code"],
    ["transferSize", "http.response_transfer_size"],
    ["encodedBodySize", "http.response_content_length"],
    ["decodedBodySize", "http.decoded_response_content_length"],
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
    ["renderBlockingStatus", "resource.render_blocking_status"],
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
    ["deliveryType", "http.response_delivery_type"]
  ]);
  const l = { ...a, ...vc(t) }, d = i + r, p = d + s;
  tt(e, d, p, {
    name: n.replace(O.location.origin, ""),
    op: c,
    attributes: l
  });
}
function Ih(e) {
  const t = O.navigator;
  if (!t)
    return;
  const n = t.connection;
  n && (n.effectiveType && e.setAttribute("effectiveConnectionType", n.effectiveType), n.type && e.setAttribute("connectionType", n.type), Ur(n.rtt) && (Ae["connection.rtt"] = { value: n.rtt, unit: "millisecond" })), Ur(t.deviceMemory) && e.setAttribute("deviceMemory", `${t.deviceMemory} GB`), Ur(t.hardwareConcurrency) && e.setAttribute("hardwareConcurrency", String(t.hardwareConcurrency));
}
function wh(e, t) {
  me && t.recordLcpOnPageloadSpan && (me.element && e.setAttribute("lcp.element", ke(me.element)), me.id && e.setAttribute("lcp.id", me.id), me.url && e.setAttribute("lcp.url", me.url.trim().slice(0, 200)), me.loadTime != null && e.setAttribute("lcp.loadTime", me.loadTime), me.renderTime != null && e.setAttribute("lcp.renderTime", me.renderTime), e.setAttribute("lcp.size", me.size)), ir?.sources && t.recordClsOnPageloadSpan && ir.sources.forEach(
    (n, r) => e.setAttribute(`cls.source.${r + 1}`, ke(n.node))
  );
}
function kh(e, t, n) {
  n.forEach(([r, s]) => {
    const i = e[r];
    i != null && (typeof i == "number" && i < ch || typeof i == "string") && (t[s] = i);
  });
}
function Rh(e) {
  const t = En(!1);
  if (!t)
    return;
  const { responseStart: n, requestStart: r } = t;
  r <= n && (e["ttfb.requestTime"] = {
    value: n - r,
    unit: "millisecond"
  });
}
function Ch() {
  return Tn() && ye() ? yt("element", xh) : () => {
  };
}
const xh = ({ entries: e }) => {
  const t = le(), n = t ? de(t) : void 0, r = n ? $(n).description : G().getScopeData().transactionName;
  e.forEach((s) => {
    const i = s;
    if (!i.identifier)
      return;
    const o = i.name, c = i.renderTime, a = i.loadTime, [u, l] = a ? [ie(a), "load-time"] : c ? [ie(c), "render-time"] : [oe(), "entry-emission"], d = o === "image-paint" ? (
      // for image paints, we can acually get a duration because image-paint entries also have a `loadTime`
      // and `renderTime`. `loadTime` is the time when the image finished loading and `renderTime` is the
      // time when the image finished rendering.
      ie(Math.max(0, (c ?? 0) - (a ?? 0)))
    ) : (
      // for `'text-paint'` entries, we can't get a duration because the `loadTime` is always zero.
      0
    ), p = {
      [ne]: "auto.ui.browser.elementtiming",
      [ze]: "ui.elementtiming",
      // name must be user-entered, so we can assume low cardinality
      [_e]: "component",
      // recording the source of the span start time, as it varies depending on available data
      "sentry.span_start_time_source": l,
      "sentry.transaction_name": r,
      "element.id": i.id,
      "element.type": i.element?.tagName?.toLowerCase() || "unknown",
      "element.size": i.naturalWidth && i.naturalHeight ? `${i.naturalWidth}x${i.naturalHeight}` : void 0,
      "element.render_time": c,
      "element.load_time": a,
      // `url` is `0`(number) for text paints (hence we fall back to undefined)
      "element.url": i.url || void 0,
      "element.identifier": i.identifier,
      "element.paint_type": o
    };
    dl(
      {
        name: `element[${i.identifier}]`,
        attributes: p,
        startTime: u,
        onlyIfParent: !0
      },
      (f) => {
        f.end(u + d);
      }
    );
  });
}, Mh = 1e3;
let ho, ls, fs;
function Tc(e) {
  nt("dom", e), rt("dom", Ah);
}
function Ah() {
  if (!O.document)
    return;
  const e = Ie.bind(null, "dom"), t = mo(e, !0);
  O.document.addEventListener("click", t, !1), O.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const s = O[n]?.prototype;
    s?.hasOwnProperty?.("addEventListener") && (ge(s, "addEventListener", function(i) {
      return function(o, c, a) {
        if (o === "click" || o == "keypress")
          try {
            const u = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {}, l = u[o] = u[o] || { refCount: 0 };
            if (!l.handler) {
              const d = mo(e);
              l.handler = d, i.call(this, o, d, a);
            }
            l.refCount++;
          } catch {
          }
        return i.call(this, o, c, a);
      };
    }), ge(
      s,
      "removeEventListener",
      function(i) {
        return function(o, c, a) {
          if (o === "click" || o == "keypress")
            try {
              const u = this.__sentry_instrumentation_handlers__ || {}, l = u[o];
              l && (l.refCount--, l.refCount <= 0 && (i.call(this, o, l.handler, a), l.handler = void 0, delete u[o]), Object.keys(u).length === 0 && delete this.__sentry_instrumentation_handlers__);
            } catch {
            }
          return i.call(this, o, c, a);
        };
      }
    ));
  });
}
function Oh(e) {
  if (e.type !== ls)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== fs)
      return !1;
  } catch {
  }
  return !0;
}
function Nh(e, t) {
  return e !== "keypress" ? !1 : t?.tagName ? !(t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable) : !0;
}
function mo(e, t = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const r = Dh(n);
    if (Nh(n.type, r))
      return;
    be(n, "_sentryCaptured", !0), r && !r._sentryId && be(r, "_sentryId", Ee());
    const s = n.type === "keypress" ? "input" : n.type;
    Oh(n) || (e({ event: n, name: s, global: t }), ls = n.type, fs = r ? r._sentryId : void 0), clearTimeout(ho), ho = O.setTimeout(() => {
      fs = void 0, ls = void 0;
    }, Mh);
  };
}
function Dh(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
let Nn;
function br(e) {
  const t = "history";
  nt(t, e), rt(t, Lh);
}
function Lh() {
  if (O.addEventListener("popstate", () => {
    const t = O.location.href, n = Nn;
    if (Nn = t, n === t)
      return;
    Ie("history", { from: n, to: t });
  }), !rp())
    return;
  function e(t) {
    return function(...n) {
      const r = n.length > 2 ? n[2] : void 0;
      if (r) {
        const s = Nn, i = Ph(String(r));
        if (Nn = i, s === i)
          return t.apply(this, n);
        Ie("history", { from: s, to: i });
      }
      return t.apply(this, n);
    };
  }
  ge(O.history, "pushState", e), ge(O.history, "replaceState", e);
}
function Ph(e) {
  try {
    return new URL(e, O.location.origin).toString();
  } catch {
    return e;
  }
}
const Vn = {};
function Ic(e) {
  const t = Vn[e];
  if (t)
    return t;
  let n = O[e];
  if (is(n))
    return Vn[e] = n.bind(O);
  const r = O.document;
  if (r && typeof r.createElement == "function")
    try {
      const s = r.createElement("iframe");
      s.hidden = !0, r.head.appendChild(s);
      const i = s.contentWindow;
      i?.[e] && (n = i[e]), r.head.removeChild(s);
    } catch (s) {
      Pt && _.warn(`Could not create sandbox iframe for ${e} check, bailing to window.${e}: `, s);
    }
  return n && (Vn[e] = n.bind(O));
}
function Fh(e) {
  Vn[e] = void 0;
}
function In(...e) {
  return Ic("setTimeout")(...e);
}
const dt = "__sentry_xhr_v3__";
function wc(e) {
  nt("xhr", e), rt("xhr", $h);
}
function $h() {
  if (!O.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  e.open = new Proxy(e.open, {
    apply(t, n, r) {
      const s = new Error(), i = oe() * 1e3, o = Fe(r[0]) ? r[0].toUpperCase() : void 0, c = Bh(r[1]);
      if (!o || !c)
        return t.apply(n, r);
      n[dt] = {
        method: o,
        url: c,
        request_headers: {}
      }, o === "POST" && c.match(/sentry_key/) && (n.__sentry_own_request__ = !0);
      const a = () => {
        const u = n[dt];
        if (u && n.readyState === 4) {
          try {
            u.status_code = n.status;
          } catch {
          }
          const l = {
            endTimestamp: oe() * 1e3,
            startTimestamp: i,
            xhr: n,
            virtualError: s
          };
          Ie("xhr", l);
        }
      };
      return "onreadystatechange" in n && typeof n.onreadystatechange == "function" ? n.onreadystatechange = new Proxy(n.onreadystatechange, {
        apply(u, l, d) {
          return a(), u.apply(l, d);
        }
      }) : n.addEventListener("readystatechange", a), n.setRequestHeader = new Proxy(n.setRequestHeader, {
        apply(u, l, d) {
          const [p, f] = d, h = l[dt];
          return h && Fe(p) && Fe(f) && (h.request_headers[p.toLowerCase()] = f), u.apply(l, d);
        }
      }), t.apply(n, r);
    }
  }), e.send = new Proxy(e.send, {
    apply(t, n, r) {
      const s = n[dt];
      if (!s)
        return t.apply(n, r);
      r[0] !== void 0 && (s.body = r[0]);
      const i = {
        startTimestamp: oe() * 1e3,
        xhr: n
      };
      return Ie("xhr", i), t.apply(n, r);
    }
  });
}
function Bh(e) {
  if (Fe(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
function kc(e) {
  return new URLSearchParams(e).toString();
}
function Rc(e, t = _) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof URLSearchParams)
      return [e.toString()];
    if (e instanceof FormData)
      return [kc(e)];
    if (!e)
      return [void 0];
  } catch (n) {
    return Pt && t.error(n, "Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return Pt && t.log("Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function Cc(e = []) {
  if (!(e.length !== 2 || typeof e[1] != "object"))
    return e[1].body;
}
const Hr = [], Gn = /* @__PURE__ */ new Map(), Uh = 60;
function Hh() {
  if (Tn() && ye()) {
    const t = Wh();
    return () => {
      t();
    };
  }
  return () => {
  };
}
const go = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function Wh() {
  return _c(jh);
}
const jh = ({ metric: e }) => {
  if (e.value == null)
    return;
  const t = ie(e.value);
  if (t > Uh)
    return;
  const n = e.entries.find((h) => h.duration === e.value && go[h.name]);
  if (!n)
    return;
  const { interactionId: r } = n, s = go[n.name], i = ie(ye() + n.startTime), o = le(), c = o ? de(o) : void 0, u = (r != null ? Gn.get(r) : void 0) || c, l = u ? $(u).description : G().getScopeData().transactionName, d = ke(n.target), p = {
    [ne]: "auto.http.browser.inp",
    [ze]: `ui.interaction.${s}`,
    [qt]: n.duration
  }, f = Qs({
    name: d,
    transaction: l,
    attributes: p,
    startTime: i
  });
  f && (f.addEvent("inp", {
    [gn]: "millisecond",
    [_n]: e.value
  }), f.end(i + t));
};
function zh() {
  const e = ({ entries: t }) => {
    const n = le(), r = n && de(n);
    t.forEach((s) => {
      if (!th(s) || !r)
        return;
      const i = s.interactionId;
      if (i != null && !Gn.has(i)) {
        if (Hr.length > 10) {
          const o = Hr.shift();
          Gn.delete(o);
        }
        Hr.push(i), Gn.set(i, r);
      }
    });
  };
  yt("event", e), yt("first-input", e);
}
function qh(e, t = Ic("fetch")) {
  let n = 0, r = 0;
  async function s(i) {
    const o = i.body.length;
    n += o, r++;
    const c = {
      body: i.body,
      method: "POST",
      referrerPolicy: "strict-origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...e.fetchOptions
    };
    try {
      const a = await t(e.url, c);
      return {
        statusCode: a.status,
        headers: {
          "x-sentry-rate-limits": a.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": a.headers.get("Retry-After")
        }
      };
    } catch (a) {
      throw Fh("fetch"), a;
    } finally {
      n -= o, r--;
    }
  }
  return gf(e, s);
}
const Vh = 30, Gh = 50;
function ps(e, t, n, r) {
  const s = {
    filename: e,
    function: t === "<anonymous>" ? gt : t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (s.lineno = n), r !== void 0 && (s.colno = r), s;
}
const Yh = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, Kh = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Xh = /\((\S*)(?::(\d+))(?::(\d+))\)/, Jh = /at (.+?) ?\(data:(.+?),/, Qh = (e) => {
  const t = e.match(Jh);
  if (t)
    return {
      filename: `<data:${t[2]}>`,
      function: t[1]
    };
  const n = Yh.exec(e);
  if (n) {
    const [, s, i, o] = n;
    return ps(s, gt, +i, +o);
  }
  const r = Kh.exec(e);
  if (r) {
    if (r[2] && r[2].indexOf("eval") === 0) {
      const c = Xh.exec(r[2]);
      c && (r[2] = c[1], r[3] = c[2], r[4] = c[3]);
    }
    const [i, o] = xc(r[1] || gt, r[2]);
    return ps(o, i, r[3] ? +r[3] : void 0, r[4] ? +r[4] : void 0);
  }
}, Zh = [Vh, Qh], em = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, tm = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, nm = (e) => {
  const t = em.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const i = tm.exec(t[3]);
      i && (t[1] = t[1] || "eval", t[3] = i[1], t[4] = i[2], t[5] = "");
    }
    let r = t[3], s = t[1] || gt;
    return [s, r] = xc(s, r), ps(r, s, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, rm = [Gh, nm], sm = [Zh, rm], im = ea(...sm), xc = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, r = e.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : gt,
    n ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
}, Re = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Dn = 1024, om = "Breadcrumbs", am = (e = {}) => {
  const t = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: om,
    setup(n) {
      t.console && jf(lm(n)), t.dom && Tc(dm(n, t.dom)), t.xhr && wc(fm(n)), t.fetch && ic(pm(n)), t.history && br(hm(n)), t.sentry && n.on("beforeSendEvent", um(n));
    }
  };
}, cm = am;
function um(e) {
  return function(n) {
    U() === e && et(
      {
        category: `sentry.${n.type === "transaction" ? "transaction" : "event"}`,
        event_id: n.event_id,
        level: n.level,
        message: ut(n)
      },
      {
        event: n
      }
    );
  };
}
function dm(e, t) {
  return function(r) {
    if (U() !== e)
      return;
    let s, i, o = typeof t == "object" ? t.serializeAttribute : void 0, c = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    c && c > Dn && (Re && _.warn(
      `\`dom.maxStringLength\` cannot exceed ${Dn}, but a value of ${c} was configured. Sentry will use ${Dn} instead.`
    ), c = Dn), typeof o == "string" && (o = [o]);
    try {
      const u = r.event, l = mm(u) ? u.target : u;
      s = ke(l, { keyAttrs: o, maxStringLength: c }), i = aa(l);
    } catch {
      s = "<unknown>";
    }
    if (s.length === 0)
      return;
    const a = {
      category: `ui.${r.name}`,
      message: s
    };
    i && (a.data = { "ui.component_name": i }), et(a, {
      event: r.event,
      name: r.name,
      global: r.global
    });
  };
}
function lm(e) {
  return function(n) {
    if (U() !== e)
      return;
    const r = {
      category: "console",
      data: {
        arguments: n.args,
        logger: "console"
      },
      level: tc(n.level),
      message: Ti(n.args, " ")
    };
    if (n.level === "assert")
      if (n.args[0] === !1)
        r.message = `Assertion failed: ${Ti(n.args.slice(1), " ") || "console.assert"}`, r.data.arguments = n.args.slice(1);
      else
        return;
    et(r, {
      input: n.args,
      level: n.level
    });
  };
}
function fm(e) {
  return function(n) {
    if (U() !== e)
      return;
    const { startTimestamp: r, endTimestamp: s } = n, i = n.xhr[dt];
    if (!r || !s || !i)
      return;
    const { method: o, url: c, status_code: a, body: u } = i, l = {
      method: o,
      url: c,
      status_code: a
    }, d = {
      xhr: n.xhr,
      input: u,
      startTimestamp: r,
      endTimestamp: s
    }, p = {
      category: "xhr",
      data: l,
      type: "http",
      level: sc(a)
    };
    e.emit("beforeOutgoingRequestBreadcrumb", p, d), et(p, d);
  };
}
function pm(e) {
  return function(n) {
    if (U() !== e)
      return;
    const { startTimestamp: r, endTimestamp: s } = n;
    if (s && !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === "POST"))
      if (n.fetchData.method, n.fetchData.url, n.error) {
        const i = n.fetchData, o = {
          data: n.error,
          input: n.args,
          startTimestamp: r,
          endTimestamp: s
        }, c = {
          category: "fetch",
          data: i,
          level: "error",
          type: "http"
        };
        e.emit("beforeOutgoingRequestBreadcrumb", c, o), et(c, o);
      } else {
        const i = n.response, o = {
          ...n.fetchData,
          status_code: i?.status
        };
        n.fetchData.request_body_size, n.fetchData.response_body_size, i?.status;
        const c = {
          input: n.args,
          response: i,
          startTimestamp: r,
          endTimestamp: s
        }, a = {
          category: "fetch",
          data: o,
          type: "http",
          level: sc(o.status_code)
        };
        e.emit("beforeOutgoingRequestBreadcrumb", a, c), et(a, c);
      }
  };
}
function hm(e) {
  return function(n) {
    if (U() !== e)
      return;
    let r = n.from, s = n.to;
    const i = mt(z.location.href);
    let o = r ? mt(r) : void 0;
    const c = mt(s);
    o?.path || (o = i), i.protocol === c.protocol && i.host === c.host && (s = c.relative), i.protocol === o.protocol && i.host === o.host && (r = o.relative), et({
      category: "navigation",
      data: {
        from: r,
        to: s
      }
    });
  };
}
function mm(e) {
  return !!e && !!e.target;
}
const gm = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], _m = "BrowserApiErrors", ym = (e = {}) => {
  const t = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    unregisterOriginalCallbacks: !1,
    ...e
  };
  return {
    name: _m,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      t.setTimeout && ge(z, "setTimeout", _o), t.setInterval && ge(z, "setInterval", _o), t.requestAnimationFrame && ge(z, "requestAnimationFrame", Em), t.XMLHttpRequest && "XMLHttpRequest" in z && ge(XMLHttpRequest.prototype, "send", bm);
      const n = t.eventTarget;
      n && (Array.isArray(n) ? n : gm).forEach((s) => vm(s, t));
    }
  };
}, Sm = ym;
function _o(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = Lt(n, {
      mechanism: {
        handled: !1,
        type: `auto.browser.browserapierrors.${He(e)}`
      }
    }), e.apply(this, t);
  };
}
function Em(e) {
  return function(t) {
    return e.apply(this, [
      Lt(t, {
        mechanism: {
          data: {
            handler: He(e)
          },
          handled: !1,
          type: "auto.browser.browserapierrors.requestAnimationFrame"
        }
      })
    ]);
  };
}
function bm(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((s) => {
      s in n && typeof n[s] == "function" && ge(n, s, function(i) {
        const o = {
          mechanism: {
            data: {
              handler: He(i)
            },
            handled: !1,
            type: `auto.browser.browserapierrors.xhr.${s}`
          }
        }, c = Ms(i);
        return c && (o.mechanism.data.handler = He(c)), Lt(i, o);
      });
    }), e.apply(this, t);
  };
}
function vm(e, t) {
  const r = z[e]?.prototype;
  r?.hasOwnProperty?.("addEventListener") && (ge(r, "addEventListener", function(s) {
    return function(i, o, c) {
      try {
        Tm(o) && (o.handleEvent = Lt(o.handleEvent, {
          mechanism: {
            data: {
              handler: He(o),
              target: e
            },
            handled: !1,
            type: "auto.browser.browserapierrors.handleEvent"
          }
        }));
      } catch {
      }
      return t.unregisterOriginalCallbacks && Im(this, i, o), s.apply(this, [
        i,
        Lt(o, {
          mechanism: {
            data: {
              handler: He(o),
              target: e
            },
            handled: !1,
            type: "auto.browser.browserapierrors.addEventListener"
          }
        }),
        c
      ]);
    };
  }), ge(r, "removeEventListener", function(s) {
    return function(i, o, c) {
      try {
        const a = o.__sentry_wrapped__;
        a && s.call(this, i, a, c);
      } catch {
      }
      return s.call(this, i, o, c);
    };
  }));
}
function Tm(e) {
  return typeof e.handleEvent == "function";
}
function Im(e, t, n) {
  e && typeof e == "object" && "removeEventListener" in e && typeof e.removeEventListener == "function" && e.removeEventListener(t, n);
}
const wm = () => ({
  name: "BrowserSession",
  setupOnce() {
    if (typeof z.document > "u") {
      Re && _.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
      return;
    }
    Gi({ ignoreDuration: !0 }), Yi(), br(({ from: e, to: t }) => {
      e !== void 0 && e !== t && (Gi({ ignoreDuration: !0 }), Yi());
    });
  }
}), km = "GlobalHandlers", Rm = (e = {}) => {
  const t = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: km,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(n) {
      t.onerror && (xm(n), yo("onerror")), t.onunhandledrejection && (Mm(n), yo("onunhandledrejection"));
    }
  };
}, Cm = Rm;
function xm(e) {
  ta((t) => {
    const { stackParser: n, attachStacktrace: r } = Mc();
    if (U() !== e || ac())
      return;
    const { msg: s, url: i, line: o, column: c, error: a } = t, u = Nm(
      qs(n, a || s, void 0, r, !1),
      i,
      o,
      c
    );
    u.level = "error", Fa(u, {
      originalException: a,
      mechanism: {
        handled: !1,
        type: "auto.browser.global_handlers.onerror"
      }
    });
  });
}
function Mm(e) {
  na((t) => {
    const { stackParser: n, attachStacktrace: r } = Mc();
    if (U() !== e || ac())
      return;
    const s = Am(t), i = Mt(s) ? Om(s) : qs(n, s, void 0, r, !0);
    i.level = "error", Fa(i, {
      originalException: s,
      mechanism: {
        handled: !1,
        type: "auto.browser.global_handlers.onunhandledrejection"
      }
    });
  });
}
function Am(e) {
  if (Mt(e))
    return e;
  try {
    if ("reason" in e)
      return e.reason;
    if ("detail" in e && "reason" in e.detail)
      return e.detail.reason;
  } catch {
  }
  return e;
}
function Om(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function Nm(e, t, n, r) {
  const s = e.exception = e.exception || {}, i = s.values = s.values || [], o = i[0] = i[0] || {}, c = o.stacktrace = o.stacktrace || {}, a = c.frames = c.frames || [], u = r, l = n, d = Dm(t) ?? jt();
  return a.length === 0 && a.push({
    colno: u,
    filename: d,
    function: gt,
    in_app: !0,
    lineno: l
  }), e;
}
function yo(e) {
  Re && _.log(`Global Handler attached: ${e}`);
}
function Mc() {
  return U()?.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
function Dm(e) {
  if (!(!Fe(e) || e.length === 0)) {
    if (e.startsWith("data:")) {
      const t = e.match(/^data:([^;]+)/), n = t ? t[1] : "text/javascript", r = e.includes("base64,");
      return `<data:${n}${r ? ",base64" : ""}>`;
    }
    return e.slice(0, 1024);
  }
}
const Lm = () => ({
  name: "HttpContext",
  preprocessEvent(e) {
    if (!z.navigator && !z.location && !z.document)
      return;
    const t = Ws(), n = {
      ...t.headers,
      ...e.request?.headers
    };
    e.request = {
      ...t,
      ...e.request,
      headers: n
    };
  }
}), Pm = "cause", Fm = 5, $m = "LinkedErrors", Bm = (e = {}) => {
  const t = e.limit || Fm, n = e.key || Pm;
  return {
    name: $m,
    preprocessEvent(r, s, i) {
      const o = i.getOptions();
      Wf(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        js,
        o.stackParser,
        n,
        t,
        r,
        s
      );
    }
  };
}, Um = Bm;
function Hm() {
  return Wm() ? (Re && Ve(() => {
    console.error(
      "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
    );
  }), !0) : !1;
}
function Wm() {
  if (typeof z.window > "u")
    return !1;
  const e = z;
  if (e.nw || !(e.chrome || e.browser)?.runtime?.id)
    return !1;
  const n = jt(), r = ["chrome-extension", "moz-extension", "ms-browser-extension", "safari-web-extension"];
  return !(z === z.top && r.some((i) => n.startsWith(`${i}://`)));
}
function Ac(e) {
  return [
    // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
    // eslint-disable-next-line deprecation/deprecation
    Df(),
    Mf(),
    Sm(),
    cm(),
    Cm(),
    Um(),
    Gf(),
    Lm(),
    wm()
  ];
}
function jm(e = {}) {
  const t = !e.skipBrowserExtensionCheck && Hm(), n = {
    ...e,
    enabled: t ? !1 : e.enabled,
    stackParser: Pu(e.stackParser || im),
    integrations: ql({
      integrations: e.integrations,
      defaultIntegrations: e.defaultIntegrations == null ? Ac() : e.defaultIntegrations
    }),
    transport: e.transport || qh
  };
  return uf(Rp, n);
}
const Q = B, Zs = "sentryReplaySession", zm = "replay_event", ei = "Unable to send Replay", qm = 3e5, Vm = 9e5, Gm = 5e3, Ym = 5500, Km = 6e4, Xm = 5e3, Jm = 3, So = 15e4, Ln = 5e3, Qm = 3e3, Zm = 300, ti = 2e7, eg = 4999, tg = 15e3, Eo = 36e5;
var ng = Object.defineProperty, rg = (e, t, n) => t in e ? ng(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, bo = (e, t, n) => rg(e, typeof t != "symbol" ? t + "" : t, n), ae = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(ae || {});
function sg(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function tn(e) {
  return e?.host?.shadowRoot === e;
}
function nn(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function ig(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), e;
}
function og(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3) return t;
  const n = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? n.push("layer") : e.layerName && n.push(`layer(${e.layerName})`), e.supportsText && n.push(`supports(${e.supportsText})`), e.media.length && n.push(e.media.mediaText), n.join(" ") + ";";
}
function or(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? ig(
      Array.from(t, Oc).join("")
    ) : null;
  } catch {
    return null;
  }
}
function ag(e) {
  let t = "";
  for (let n = 0; n < e.style.length; n++) {
    const r = e.style, s = r[n], i = r.getPropertyPriority(s);
    t += `${s}:${r.getPropertyValue(s)}${i ? " !important" : ""};`;
  }
  return `${e.selectorText} { ${t} }`;
}
function Oc(e) {
  let t;
  if (ug(e))
    try {
      t = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      or(e.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      og(e);
    } catch {
    }
  else if (dg(e)) {
    let n = e.cssText;
    const r = e.selectorText.includes(":"), s = typeof e.style.all == "string" && e.style.all;
    if (s && (n = ag(e)), r && (n = cg(n)), r || s)
      return n;
  }
  return t || e.cssText;
}
function cg(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function ug(e) {
  return "styleSheet" in e;
}
function dg(e) {
  return "selectorText" in e;
}
class Nc {
  constructor() {
    bo(this, "idNodeMap", /* @__PURE__ */ new Map()), bo(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    return t ? this.getMeta(t)?.id ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const n = this.getId(t);
    this.idNodeMap.delete(n), t.childNodes && t.childNodes.forEach(
      (r) => this.removeNodeFromMap(r)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, n) {
    const r = n.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, n);
  }
  replace(t, n) {
    const r = this.getNode(t);
    if (r) {
      const s = this.nodeMetaMap.get(r);
      s && this.nodeMetaMap.set(n, s);
    }
    this.idNodeMap.set(t, n);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function lg() {
  return new Nc();
}
function vr({
  maskInputOptions: e,
  tagName: t,
  type: n
}) {
  return t === "OPTION" && (t = "SELECT"), !!(e[t.toLowerCase()] || n && e[n] || n === "password" || // Default to "text" option for inputs without a "type" attribute defined
  t === "INPUT" && !n && e.text);
}
function dn({
  isMasked: e,
  element: t,
  value: n,
  maskInputFn: r
}) {
  let s = n || "";
  return e ? (r && (s = r(s, t)), "*".repeat(s.length)) : s;
}
function Ft(e) {
  return e.toLowerCase();
}
function hs(e) {
  return e.toUpperCase();
}
const vo = "__rrweb_original__";
function fg(e) {
  const t = e.getContext("2d");
  if (!t) return !0;
  const n = 50;
  for (let r = 0; r < e.width; r += n)
    for (let s = 0; s < e.height; s += n) {
      const i = t.getImageData, o = vo in i ? i[vo] : i;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        o.call(
          t,
          r,
          s,
          Math.min(n, e.width - r),
          Math.min(n, e.height - s)
        ).data.buffer
      ).some((a) => a !== 0)) return !1;
    }
  return !0;
}
function ni(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Ft(t)
  ) : null;
}
function ar(e, t, n) {
  return t === "INPUT" && (n === "radio" || n === "checkbox") ? e.getAttribute("value") || "" : e.value;
}
function Dc(e, t) {
  let n;
  try {
    n = new URL(e, t ?? window.location.href);
  } catch {
    return null;
  }
  const r = /\.([0-9a-z]+)(?:$)/i;
  return n.pathname.match(r)?.[1] ?? null;
}
const To = {};
function Lc(e) {
  const t = To[e];
  if (t)
    return t;
  const n = window.document;
  let r = window[e];
  if (n && typeof n.createElement == "function")
    try {
      const s = n.createElement("iframe");
      s.hidden = !0, n.head.appendChild(s);
      const i = s.contentWindow;
      i && i[e] && (r = // eslint-disable-next-line @typescript-eslint/unbound-method
      i[e]), n.head.removeChild(s);
    } catch {
    }
  return To[e] = r.bind(
    window
  );
}
function ms(...e) {
  return Lc("setTimeout")(...e);
}
function Pc(...e) {
  return Lc("clearTimeout")(...e);
}
function Fc(e) {
  try {
    return e.contentDocument;
  } catch {
  }
}
let pg = 1;
const hg = new RegExp("[^a-z0-9-_:]"), ln = -2;
function ri() {
  return pg++;
}
function mg(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = Ft(e.tagName);
  return hg.test(t) ? "div" : t;
}
function gg(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let Tt, Io;
const _g = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, yg = /^(?:[a-z+]+:)?\/\//i, Sg = /^www\..*/i, Eg = /^(data:)([^,]*),(.*)/i;
function cr(e, t) {
  return (e || "").replace(
    _g,
    (n, r, s, i, o, c) => {
      const a = s || o || c, u = r || i || "";
      if (!a)
        return n;
      if (yg.test(a) || Sg.test(a))
        return `url(${u}${a}${u})`;
      if (Eg.test(a))
        return `url(${u}${a}${u})`;
      if (a[0] === "/")
        return `url(${u}${gg(t) + a}${u})`;
      const l = t.split("/"), d = a.split("/");
      l.pop();
      for (const p of d)
        p !== "." && (p === ".." ? l.pop() : l.push(p));
      return `url(${u}${l.join("/")}${u})`;
    }
  );
}
const bg = /^[^ \t\n\r\u000c]+/, vg = /^[, \t\n\r\u000c]+/;
function Tg(e, t) {
  if (t.trim() === "")
    return t;
  let n = 0;
  function r(i) {
    let o;
    const c = i.exec(t.substring(n));
    return c ? (o = c[0], n += o.length, o) : "";
  }
  const s = [];
  for (; r(vg), !(n >= t.length); ) {
    let i = r(bg);
    if (i.slice(-1) === ",")
      i = kt(e, i.substring(0, i.length - 1)), s.push(i);
    else {
      let o = "";
      i = kt(e, i);
      let c = !1;
      for (; ; ) {
        const a = t.charAt(n);
        if (a === "") {
          s.push((i + o).trim());
          break;
        } else if (c)
          a === ")" && (c = !1);
        else if (a === ",") {
          n += 1, s.push((i + o).trim());
          break;
        } else a === "(" && (c = !0);
        o += a, n += 1;
      }
    }
  }
  return s.join(", ");
}
const wo = /* @__PURE__ */ new WeakMap();
function kt(e, t) {
  return !t || t.trim() === "" ? t : Tr(e, t);
}
function Ig(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function Tr(e, t) {
  let n = wo.get(e);
  if (n || (n = e.createElement("a"), wo.set(e, n)), !t)
    t = "";
  else if (t.startsWith("blob:") || t.startsWith("data:"))
    return t;
  return n.setAttribute("href", t), n.href;
}
function $c(e, t, n, r, s, i) {
  return r && (n === "src" || n === "href" && !(t === "use" && r[0] === "#") || n === "xlink:href" && r[0] !== "#" || n === "background" && (t === "table" || t === "td" || t === "th") ? kt(e, r) : n === "srcset" ? Tg(e, r) : n === "style" ? cr(r, Tr(e)) : t === "object" && n === "data" ? kt(e, r) : typeof i == "function" ? i(n, r, s) : r);
}
function Bc(e, t, n) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function wg(e, t, n, r) {
  try {
    if (r && e.matches(r))
      return !1;
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let s = e.classList.length; s--; ) {
        const i = e.classList[s];
        if (t.test(i))
          return !0;
      }
    if (n)
      return e.matches(n);
  } catch {
  }
  return !1;
}
function kg(e, t) {
  for (let n = e.classList.length; n--; ) {
    const r = e.classList[n];
    if (t.test(r))
      return !0;
  }
  return !1;
}
function lt(e, t, n = 1 / 0, r = 0) {
  return !e || e.nodeType !== e.ELEMENT_NODE || r > n ? -1 : t(e) ? r : lt(e.parentNode, t, n, r + 1);
}
function Rt(e, t) {
  return (n) => {
    const r = n;
    if (r === null) return !1;
    try {
      if (e) {
        if (typeof e == "string") {
          if (r.matches(`.${e}`)) return !0;
        } else if (kg(r, e))
          return !0;
      }
      return !!(t && r.matches(t));
    } catch {
      return !1;
    }
  };
}
function $t(e, t, n, r, s, i) {
  try {
    const o = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (o === null) return !1;
    if (o.tagName === "INPUT") {
      const u = o.getAttribute("autocomplete");
      if ([
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ].includes(u))
        return !0;
    }
    let c = -1, a = -1;
    if (i) {
      if (a = lt(
        o,
        Rt(r, s)
      ), a < 0)
        return !0;
      c = lt(
        o,
        Rt(t, n),
        a >= 0 ? a : 1 / 0
      );
    } else {
      if (c = lt(
        o,
        Rt(t, n)
      ), c < 0)
        return !1;
      a = lt(
        o,
        Rt(r, s),
        c >= 0 ? c : 1 / 0
      );
    }
    return c >= 0 ? a >= 0 ? c <= a : !0 : a >= 0 ? !1 : !!i;
  } catch {
  }
  return !!i;
}
function Rg(e, t, n) {
  const r = e.contentWindow;
  if (!r)
    return;
  let s = !1, i;
  try {
    i = r.document.readyState;
  } catch {
    return;
  }
  if (i !== "complete") {
    const c = ms(() => {
      s || (t(), s = !0);
    }, n);
    e.addEventListener("load", () => {
      Pc(c), s = !0, t();
    });
    return;
  }
  const o = "about:blank";
  if (r.location.href !== o || e.src === o || e.src === "")
    return ms(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function Cg(e, t, n) {
  let r = !1, s;
  try {
    s = e.sheet;
  } catch {
    return;
  }
  if (s) return;
  const i = ms(() => {
    r || (t(), r = !0);
  }, n);
  e.addEventListener("load", () => {
    Pc(i), r = !0, t();
  });
}
function xg(e, t) {
  const {
    doc: n,
    mirror: r,
    blockClass: s,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: c,
    maskAttributeFn: a,
    maskTextClass: u,
    unmaskTextClass: l,
    maskTextSelector: d,
    unmaskTextSelector: p,
    inlineStylesheet: f,
    maskInputOptions: h = {},
    maskTextFn: m,
    maskInputFn: g,
    dataURLOptions: E = {},
    inlineImages: R,
    recordCanvas: j,
    keepIframeSrcFn: D,
    newlyAddedElement: A = !1
  } = t, w = Mg(n, r);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: ae.Document,
        childNodes: [],
        compatMode: e.compatMode
        // probably "BackCompat"
      } : {
        type: ae.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: ae.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: w
      };
    case e.ELEMENT_NODE:
      return Og(e, {
        doc: n,
        blockClass: s,
        blockSelector: i,
        unblockSelector: o,
        inlineStylesheet: f,
        maskAttributeFn: a,
        maskInputOptions: h,
        maskInputFn: g,
        dataURLOptions: E,
        inlineImages: R,
        recordCanvas: j,
        keepIframeSrcFn: D,
        newlyAddedElement: A,
        rootId: w,
        maskTextClass: u,
        unmaskTextClass: l,
        maskTextSelector: d,
        unmaskTextSelector: p
      });
    case e.TEXT_NODE:
      return Ag(e, {
        doc: n,
        maskAllText: c,
        maskTextClass: u,
        unmaskTextClass: l,
        maskTextSelector: d,
        unmaskTextSelector: p,
        maskTextFn: m,
        maskInputOptions: h,
        maskInputFn: g,
        rootId: w
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: ae.CDATA,
        textContent: "",
        rootId: w
      };
    case e.COMMENT_NODE:
      return {
        type: ae.Comment,
        textContent: e.textContent || "",
        rootId: w
      };
    default:
      return !1;
  }
}
function Mg(e, t) {
  if (!t.hasNode(e)) return;
  const n = t.getId(e);
  return n === 1 ? void 0 : n;
}
function Ag(e, t) {
  const {
    maskAllText: n,
    maskTextClass: r,
    unmaskTextClass: s,
    maskTextSelector: i,
    unmaskTextSelector: o,
    maskTextFn: c,
    maskInputOptions: a,
    maskInputFn: u,
    rootId: l
  } = t, d = e.parentNode && e.parentNode.tagName;
  let p = e.textContent;
  const f = d === "STYLE" ? !0 : void 0, h = d === "SCRIPT" ? !0 : void 0, m = d === "TEXTAREA" ? !0 : void 0;
  if (f && p) {
    try {
      e.nextSibling || e.previousSibling || e.parentNode.sheet?.cssRules && (p = or(
        e.parentNode.sheet
      ));
    } catch (E) {
      console.warn(
        `Cannot get CSS styles from text's parentNode. Error: ${E}`,
        e
      );
    }
    p = cr(p, Tr(t.doc));
  }
  h && (p = "SCRIPT_PLACEHOLDER");
  const g = $t(
    e,
    r,
    i,
    s,
    o,
    n
  );
  if (!f && !h && !m && p && g && (p = c ? c(p, e.parentElement) : p.replace(/[\S]/g, "*")), m && p && (a.textarea || g) && (p = u ? u(p, e.parentNode) : p.replace(/[\S]/g, "*")), d === "OPTION" && p) {
    const E = vr({
      type: null,
      tagName: d,
      maskInputOptions: a
    });
    p = dn({
      isMasked: $t(
        e,
        r,
        i,
        s,
        o,
        E
      ),
      element: e,
      value: p,
      maskInputFn: u
    });
  }
  return {
    type: ae.Text,
    textContent: p || "",
    isStyle: f,
    rootId: l
  };
}
function Og(e, t) {
  const {
    doc: n,
    blockClass: r,
    blockSelector: s,
    unblockSelector: i,
    inlineStylesheet: o,
    maskInputOptions: c = {},
    maskAttributeFn: a,
    maskInputFn: u,
    dataURLOptions: l = {},
    inlineImages: d,
    recordCanvas: p,
    keepIframeSrcFn: f,
    newlyAddedElement: h = !1,
    rootId: m,
    maskTextClass: g,
    unmaskTextClass: E,
    maskTextSelector: R,
    unmaskTextSelector: j
  } = t, D = wg(
    e,
    r,
    s,
    i
  ), A = mg(e);
  let w = {};
  const y = e.attributes.length;
  for (let b = 0; b < y; b++) {
    const k = e.attributes[b];
    k.name && !Bc(A, k.name, k.value) && (w[k.name] = $c(
      n,
      A,
      Ft(k.name),
      k.value,
      e,
      a
    ));
  }
  if (A === "link" && o) {
    const b = Array.from(n.styleSheets).find((L) => L.href === e.href);
    let k = null;
    b && (k = or(b)), k && (w.rel = null, w.href = null, w.crossorigin = null, w._cssText = cr(k, b.href));
  }
  if (A === "style" && e.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
  !(e.innerText || e.textContent || "").trim().length) {
    const b = or(
      e.sheet
    );
    b && (w._cssText = cr(b, Tr(n)));
  }
  if (A === "input" || A === "textarea" || A === "select" || A === "option") {
    const b = e, k = ni(b), L = ar(b, hs(A), k), H = b.checked;
    if (k !== "submit" && k !== "button" && L) {
      const P = $t(
        b,
        g,
        R,
        E,
        j,
        vr({
          type: k,
          tagName: hs(A),
          maskInputOptions: c
        })
      );
      w.value = dn({
        isMasked: P,
        element: b,
        value: L,
        maskInputFn: u
      });
    }
    H && (w.checked = H);
  }
  if (A === "option" && (e.selected && !c.select ? w.selected = !0 : delete w.selected), A === "canvas" && p) {
    if (e.__context === "2d")
      fg(e) || (w.rr_dataURL = e.toDataURL(
        l.type,
        l.quality
      ));
    else if (!("__context" in e)) {
      const b = e.toDataURL(
        l.type,
        l.quality
      ), k = n.createElement("canvas");
      k.width = e.width, k.height = e.height;
      const L = k.toDataURL(
        l.type,
        l.quality
      );
      b !== L && (w.rr_dataURL = b);
    }
  }
  if (A === "img" && d) {
    Tt || (Tt = n.createElement("canvas"), Io = Tt.getContext("2d"));
    const b = e, k = b.currentSrc || b.getAttribute("src") || "<unknown-src>", L = b.crossOrigin, H = () => {
      b.removeEventListener("load", H);
      try {
        Tt.width = b.naturalWidth, Tt.height = b.naturalHeight, Io.drawImage(b, 0, 0), w.rr_dataURL = Tt.toDataURL(
          l.type,
          l.quality
        );
      } catch (P) {
        if (b.crossOrigin !== "anonymous") {
          b.crossOrigin = "anonymous", b.complete && b.naturalWidth !== 0 ? H() : b.addEventListener("load", H);
          return;
        } else
          console.warn(
            `Cannot inline img src=${k}! Error: ${P}`
          );
      }
      b.crossOrigin === "anonymous" && (L ? w.crossOrigin = L : b.removeAttribute("crossorigin"));
    };
    b.complete && b.naturalWidth !== 0 ? H() : b.addEventListener("load", H);
  }
  if ((A === "audio" || A === "video") && (w.rr_mediaState = e.paused ? "paused" : "played", w.rr_mediaCurrentTime = e.currentTime), h || (e.scrollLeft && (w.rr_scrollLeft = e.scrollLeft), e.scrollTop && (w.rr_scrollTop = e.scrollTop)), D) {
    const { width: b, height: k } = e.getBoundingClientRect();
    w = {
      class: w.class,
      rr_width: `${b}px`,
      rr_height: `${k}px`
    };
  }
  A === "iframe" && !f(w.src) && (!D && !Fc(e) && (w.rr_src = w.src), delete w.src);
  let T;
  try {
    customElements.get(A) && (T = !0);
  } catch {
  }
  return {
    type: ae.Element,
    tagName: A,
    attributes: w,
    childNodes: [],
    isSVG: Ig(e) || void 0,
    needBlock: D,
    rootId: m,
    isCustom: T
  };
}
function J(e) {
  return e == null ? "" : e.toLowerCase();
}
function Ng(e, t) {
  if (t.comment && e.type === ae.Comment)
    return !0;
  if (e.type === ae.Element) {
    if (t.script && // script tag
    (e.tagName === "script" || // (module)preload link
    e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") || // prefetch link
    e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && Dc(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (J(e.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || J(e.attributes.name) === "application-name" || J(e.attributes.rel) === "icon" || J(e.attributes.rel) === "apple-touch-icon" || J(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && J(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (J(e.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      J(e.attributes.name).match(/^(og|twitter):/) || J(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (J(e.attributes.name) === "robots" || J(e.attributes.name) === "googlebot" || J(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (J(e.attributes.name) === "author" || J(e.attributes.name) === "generator" || J(e.attributes.name) === "framework" || J(e.attributes.name) === "publisher" || J(e.attributes.name) === "progid" || J(e.attributes.property).match(/^article:/) || J(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (J(e.attributes.name) === "google-site-verification" || J(e.attributes.name) === "yandex-verification" || J(e.attributes.name) === "csrf-token" || J(e.attributes.name) === "p:domain_verify" || J(e.attributes.name) === "verify-v1" || J(e.attributes.name) === "verification" || J(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Ct(e, t) {
  const {
    doc: n,
    mirror: r,
    blockClass: s,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: c,
    maskTextClass: a,
    unmaskTextClass: u,
    maskTextSelector: l,
    unmaskTextSelector: d,
    skipChild: p = !1,
    inlineStylesheet: f = !0,
    maskInputOptions: h = {},
    maskAttributeFn: m,
    maskTextFn: g,
    maskInputFn: E,
    slimDOMOptions: R,
    dataURLOptions: j = {},
    inlineImages: D = !1,
    recordCanvas: A = !1,
    onSerialize: w,
    onIframeLoad: y,
    iframeLoadTimeout: T = 5e3,
    onBlockedImageLoad: b,
    onStylesheetLoad: k,
    stylesheetLoadTimeout: L = 5e3,
    keepIframeSrcFn: H = () => !1,
    newlyAddedElement: P = !1
  } = t;
  let { preserveWhiteSpace: Z = !0 } = t;
  const te = xg(e, {
    doc: n,
    mirror: r,
    blockClass: s,
    blockSelector: i,
    maskAllText: c,
    unblockSelector: o,
    maskTextClass: a,
    unmaskTextClass: u,
    maskTextSelector: l,
    unmaskTextSelector: d,
    inlineStylesheet: f,
    maskInputOptions: h,
    maskAttributeFn: m,
    maskTextFn: g,
    maskInputFn: E,
    dataURLOptions: j,
    inlineImages: D,
    recordCanvas: A,
    keepIframeSrcFn: H,
    newlyAddedElement: P
  });
  if (!te)
    return console.warn(e, "not serialized"), null;
  let X;
  r.hasNode(e) ? X = r.getId(e) : Ng(te, R) || !Z && te.type === ae.Text && !te.isStyle && !te.textContent.replace(/^\s+|\s+$/gm, "").length ? X = ln : X = ri();
  const S = Object.assign(te, { id: X });
  if (r.add(e, S), X === ln)
    return null;
  w && w(e);
  let q = !p;
  if (S.type === ae.Element) {
    q = q && !S.needBlock;
    const I = e.shadowRoot;
    I && nn(I) && (S.isShadowHost = !0);
  }
  if ((S.type === ae.Document || S.type === ae.Element) && q) {
    R.headWhitespace && S.type === ae.Element && S.tagName === "head" && (Z = !1);
    const I = {
      doc: n,
      mirror: r,
      blockClass: s,
      blockSelector: i,
      maskAllText: c,
      unblockSelector: o,
      maskTextClass: a,
      unmaskTextClass: u,
      maskTextSelector: l,
      unmaskTextSelector: d,
      skipChild: p,
      inlineStylesheet: f,
      maskInputOptions: h,
      maskAttributeFn: m,
      maskTextFn: g,
      maskInputFn: E,
      slimDOMOptions: R,
      dataURLOptions: j,
      inlineImages: D,
      recordCanvas: A,
      preserveWhiteSpace: Z,
      onSerialize: w,
      onIframeLoad: y,
      iframeLoadTimeout: T,
      onBlockedImageLoad: b,
      onStylesheetLoad: k,
      stylesheetLoadTimeout: L,
      keepIframeSrcFn: H
    }, V = e.childNodes ? Array.from(e.childNodes) : [];
    for (const re of V) {
      const ee = Ct(re, I);
      ee && S.childNodes.push(ee);
    }
    if (sg(e) && e.shadowRoot)
      for (const re of Array.from(e.shadowRoot.childNodes)) {
        const ee = Ct(re, I);
        ee && (nn(e.shadowRoot) && (ee.isShadow = !0), S.childNodes.push(ee));
      }
  }
  if (e.parentNode && tn(e.parentNode) && nn(e.parentNode) && (S.isShadow = !0), S.type === ae.Element && S.tagName === "iframe" && !S.needBlock && Rg(
    e,
    () => {
      const I = Fc(e);
      if (I && y) {
        const V = Ct(I, {
          doc: I,
          mirror: r,
          blockClass: s,
          blockSelector: i,
          unblockSelector: o,
          maskAllText: c,
          maskTextClass: a,
          unmaskTextClass: u,
          maskTextSelector: l,
          unmaskTextSelector: d,
          skipChild: !1,
          inlineStylesheet: f,
          maskInputOptions: h,
          maskAttributeFn: m,
          maskTextFn: g,
          maskInputFn: E,
          slimDOMOptions: R,
          dataURLOptions: j,
          inlineImages: D,
          recordCanvas: A,
          preserveWhiteSpace: Z,
          onSerialize: w,
          onIframeLoad: y,
          iframeLoadTimeout: T,
          onStylesheetLoad: k,
          stylesheetLoadTimeout: L,
          keepIframeSrcFn: H
        });
        V && y(
          e,
          V
        );
      }
    },
    T
  ), S.type === ae.Element && S.tagName === "img" && !e.complete && S.needBlock) {
    const I = e, V = () => {
      if (I.isConnected && !I.complete && b)
        try {
          const re = I.getBoundingClientRect();
          re.width > 0 && re.height > 0 && b(I, S, re);
        } catch {
        }
      I.removeEventListener("load", V);
    };
    I.isConnected && I.addEventListener("load", V);
  }
  return S.type === ae.Element && S.tagName === "link" && typeof S.attributes.rel == "string" && (S.attributes.rel === "stylesheet" || S.attributes.rel === "preload" && typeof S.attributes.href == "string" && Dc(S.attributes.href) === "css") && Cg(
    e,
    () => {
      if (k) {
        const I = Ct(e, {
          doc: n,
          mirror: r,
          blockClass: s,
          blockSelector: i,
          unblockSelector: o,
          maskAllText: c,
          maskTextClass: a,
          unmaskTextClass: u,
          maskTextSelector: l,
          unmaskTextSelector: d,
          skipChild: !1,
          inlineStylesheet: f,
          maskInputOptions: h,
          maskAttributeFn: m,
          maskTextFn: g,
          maskInputFn: E,
          slimDOMOptions: R,
          dataURLOptions: j,
          inlineImages: D,
          recordCanvas: A,
          preserveWhiteSpace: Z,
          onSerialize: w,
          onIframeLoad: y,
          iframeLoadTimeout: T,
          onStylesheetLoad: k,
          stylesheetLoadTimeout: L,
          keepIframeSrcFn: H
        });
        I && k(
          e,
          I
        );
      }
    },
    L
  ), S.type === ae.Element && delete S.needBlock, S;
}
function Dg(e, t) {
  const {
    mirror: n = new Nc(),
    blockClass: r = "rr-block",
    blockSelector: s = null,
    unblockSelector: i = null,
    maskAllText: o = !1,
    maskTextClass: c = "rr-mask",
    unmaskTextClass: a = null,
    maskTextSelector: u = null,
    unmaskTextSelector: l = null,
    inlineStylesheet: d = !0,
    inlineImages: p = !1,
    recordCanvas: f = !1,
    maskAllInputs: h = !1,
    maskAttributeFn: m,
    maskTextFn: g,
    maskInputFn: E,
    slimDOM: R = !1,
    dataURLOptions: j,
    preserveWhiteSpace: D,
    onSerialize: A,
    onIframeLoad: w,
    iframeLoadTimeout: y,
    onBlockedImageLoad: T,
    onStylesheetLoad: b,
    stylesheetLoadTimeout: k,
    keepIframeSrcFn: L = () => !1
  } = t || {};
  return Ct(e, {
    doc: e,
    mirror: n,
    blockClass: r,
    blockSelector: s,
    unblockSelector: i,
    maskAllText: o,
    maskTextClass: c,
    unmaskTextClass: a,
    maskTextSelector: u,
    unmaskTextSelector: l,
    skipChild: !1,
    inlineStylesheet: d,
    maskInputOptions: h === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0
    } : h === !1 ? {} : h,
    maskAttributeFn: m,
    maskTextFn: g,
    maskInputFn: E,
    slimDOMOptions: R === !0 || R === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: R === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : R === !1 ? {} : R,
    dataURLOptions: j,
    inlineImages: p,
    recordCanvas: f,
    preserveWhiteSpace: D,
    onSerialize: A,
    onIframeLoad: w,
    iframeLoadTimeout: y,
    onBlockedImageLoad: T,
    onStylesheetLoad: b,
    stylesheetLoadTimeout: k,
    keepIframeSrcFn: L,
    newlyAddedElement: !1
  });
}
function he(e, t, n = document) {
  const r = { capture: !0, passive: !0 };
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t, r);
}
const It = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let ko = {
  map: {},
  getId() {
    return console.error(It), -1;
  },
  getNode() {
    return console.error(It), null;
  },
  removeNodeFromMap() {
    console.error(It);
  },
  has() {
    return console.error(It), !1;
  },
  reset() {
    console.error(It);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (ko = new Proxy(ko, {
  get(e, t, n) {
    return t === "map" && console.error(It), Reflect.get(e, t, n);
  }
}));
function fn(e, t, n = {}) {
  let r = null, s = 0;
  return function(...i) {
    const o = Date.now();
    !s && n.leading === !1 && (s = o);
    const c = t - (o - s), a = this;
    c <= 0 || c > t ? (r && (Hg(r), r = null), s = o, e.apply(a, i)) : !r && n.trailing !== !1 && (r = Ir(() => {
      s = n.leading === !1 ? 0 : Date.now(), r = null, e.apply(a, i);
    }, c));
  };
}
function Uc(e, t, n, r, s = window) {
  const i = s.Object.getOwnPropertyDescriptor(e, t);
  return s.Object.defineProperty(
    e,
    t,
    r ? n : {
      set(o) {
        Ir(() => {
          n.set.call(this, o);
        }, 0), i && i.set && i.set.call(this, o);
      }
    }
  ), () => Uc(e, t, i || {}, !0);
}
function si(e, t, n) {
  try {
    if (!(t in e))
      return () => {
      };
    const r = e[t], s = n(r);
    return typeof s == "function" && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
      __rrweb_original__: {
        enumerable: !1,
        value: r
      }
    })), e[t] = s, () => {
      e[t] = r;
    };
  } catch {
    return () => {
    };
  }
}
let ur = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (ur = () => (/* @__PURE__ */ new Date()).getTime());
function Hc(e) {
  const t = e.document;
  return {
    left: t.scrollingElement ? t.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : t?.documentElement.scrollLeft || t?.body?.parentElement?.scrollLeft || t?.body?.scrollLeft || 0,
    top: t.scrollingElement ? t.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : t?.documentElement.scrollTop || t?.body?.parentElement?.scrollTop || t?.body?.scrollTop || 0
  };
}
function Wc() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function jc() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function zc(e) {
  if (!e)
    return null;
  try {
    return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
  } catch {
    return null;
  }
}
function Se(e, t, n, r, s) {
  if (!e)
    return !1;
  const i = zc(e);
  if (!i)
    return !1;
  const o = Rt(t, n);
  if (!s) {
    const u = r && i.matches(r);
    return o(i) && !u;
  }
  const c = lt(i, o);
  let a = -1;
  return c < 0 ? !1 : (r && (a = lt(
    i,
    Rt(null, r)
  )), c > -1 && a < 0 ? !0 : c < a);
}
function Lg(e, t) {
  return t.getId(e) !== -1;
}
function Wr(e, t) {
  return t.getId(e) === ln;
}
function qc(e, t) {
  if (tn(e))
    return !1;
  const n = t.getId(e);
  return t.has(n) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? qc(e.parentNode, t) : !0 : !0;
}
function gs(e) {
  return !!e.changedTouches;
}
function Pg(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let n = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === n)
        return !0;
    while (n = n && n.parentNode);
    return !1;
  });
}
function Vc(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function Gc(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function _s(e) {
  return !!e?.shadowRoot;
}
class Fg {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    return this.styleIDMap.get(t) ?? -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(t, n) {
    if (this.has(t)) return this.getId(t);
    let r;
    return n === void 0 ? r = this.id++ : r = n, this.styleIDMap.set(t, r), this.idStyleMap.set(r, t), r;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function Yc(e) {
  let t = null;
  return e.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (t = e.getRootNode().host), t;
}
function $g(e) {
  let t = e, n;
  for (; n = Yc(t); )
    t = n;
  return t;
}
function Bg(e) {
  const t = e.ownerDocument;
  if (!t) return !1;
  const n = $g(e);
  return t.contains(n);
}
function Kc(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || Bg(e) : !1;
}
const Ro = {};
function ii(e) {
  const t = Ro[e];
  if (t)
    return t;
  const n = window.document;
  let r = window[e];
  if (n && typeof n.createElement == "function")
    try {
      const s = n.createElement("iframe");
      s.hidden = !0, n.head.appendChild(s);
      const i = s.contentWindow;
      i && i[e] && (r = // eslint-disable-next-line @typescript-eslint/unbound-method
      i[e]), n.head.removeChild(s);
    } catch {
    }
  return Ro[e] = r.bind(
    window
  );
}
function Ug(...e) {
  return ii("requestAnimationFrame")(...e);
}
function Ir(...e) {
  return ii("setTimeout")(...e);
}
function Hg(...e) {
  return ii("clearTimeout")(...e);
}
var N = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(N || {}), M = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(M || {}), pe = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(pe || {}), Pe = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(Pe || {}), wt = /* @__PURE__ */ ((e) => (e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e))(wt || {});
function oi(e) {
  try {
    return e.contentDocument;
  } catch {
  }
}
function Wg(e) {
  try {
    return e.contentWindow;
  } catch {
  }
}
function Co(e) {
  return "__ln" in e;
}
class jg {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let n = this.head;
    for (let r = 0; r < t; r++)
      n = n?.next || null;
    return n;
  }
  addNode(t) {
    const n = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = n, t.previousSibling && Co(t.previousSibling)) {
      const r = t.previousSibling.__ln.next;
      n.next = r, n.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = n, r && (r.previous = n);
    } else if (t.nextSibling && Co(t.nextSibling) && t.nextSibling.__ln.previous) {
      const r = t.nextSibling.__ln.previous;
      n.previous = r, n.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = n, r && (r.next = n);
    } else
      this.head && (this.head.previous = n), n.next = this.head, this.head = n;
    n.next === null && (this.tail = n), this.length++;
  }
  removeNode(t) {
    const n = t.__ln;
    this.head && (n.previous ? (n.previous.next = n.next, n.next ? n.next.previous = n.previous : this.tail = n.previous) : (this.head = n.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const xo = (e, t) => `${e}@${t}`;
class zg {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], n = /* @__PURE__ */ new Set(), r = new jg(), s = (a) => {
        let u = a, l = ln;
        for (; l === ln; )
          u = u && u.nextSibling, l = u && this.mirror.getId(u);
        return l;
      }, i = (a) => {
        if (!a.parentNode || !Kc(a))
          return;
        const u = tn(a.parentNode) ? this.mirror.getId(Yc(a)) : this.mirror.getId(a.parentNode), l = s(a);
        if (u === -1 || l === -1)
          return r.addNode(a);
        const d = Ct(a, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (p) => {
            Vc(p, this.mirror) && !Se(
              p,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) && this.iframeManager.addIframe(p), Gc(p, this.mirror) && this.stylesheetManager.trackLinkElement(
              p
            ), _s(a) && this.shadowDomManager.addShadowRoot(a.shadowRoot, this.doc);
          },
          onIframeLoad: (p, f) => {
            Se(
              p,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) || (this.iframeManager.attachIframe(p, f), p.contentWindow && this.canvasManager.addWindow(p.contentWindow), this.shadowDomManager.observeAttachShadow(p));
          },
          onStylesheetLoad: (p, f) => {
            this.stylesheetManager.attachLinkElement(p, f);
          },
          onBlockedImageLoad: (p, f, { width: h, height: m }) => {
            this.mutationCb({
              adds: [],
              removes: [],
              texts: [],
              attributes: [
                {
                  id: f.id,
                  attributes: {
                    style: {
                      width: `${h}px`,
                      height: `${m}px`
                    }
                  }
                }
              ]
            });
          }
        });
        d && (t.push({
          parentId: u,
          nextId: l,
          node: d
        }), n.add(d.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const a of this.movedSet)
        Mo(this.removes, a, this.mirror) && !this.movedSet.has(a.parentNode) || i(a);
      for (const a of this.addedSet)
        !Ao(this.droppedSet, a) && !Mo(this.removes, a, this.mirror) || Ao(this.movedSet, a) ? i(a) : this.droppedSet.add(a);
      let o = null;
      for (; r.length; ) {
        let a = null;
        if (o) {
          const u = this.mirror.getId(o.value.parentNode), l = s(o.value);
          u !== -1 && l !== -1 && (a = o);
        }
        if (!a) {
          let u = r.tail;
          for (; u; ) {
            const l = u;
            if (u = u.previous, l) {
              const d = this.mirror.getId(l.value.parentNode);
              if (s(l.value) === -1) continue;
              if (d !== -1) {
                a = l;
                break;
              } else {
                const f = l.value;
                if (f.parentNode && f.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const h = f.parentNode.host;
                  if (this.mirror.getId(h) !== -1) {
                    a = l;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!a) {
          for (; r.head; )
            r.removeNode(r.head.value);
          break;
        }
        o = a.previous, r.removeNode(a.value), i(a.value);
      }
      const c = {
        texts: this.texts.map((a) => ({
          id: this.mirror.getId(a.node),
          value: a.value
        })).filter((a) => !n.has(a.id)).filter((a) => this.mirror.has(a.id)),
        attributes: this.attributes.map((a) => {
          const { attributes: u } = a;
          if (typeof u.style == "string") {
            const l = JSON.stringify(a.styleDiff), d = JSON.stringify(a._unchangedStyles);
            l.length < u.style.length && (l + d).split("var(").length === u.style.split("var(").length && (u.style = a.styleDiff);
          }
          return {
            id: this.mirror.getId(a.node),
            attributes: u
          };
        }).filter((a) => !n.has(a.id)).filter((a) => this.mirror.has(a.id)),
        removes: this.removes,
        adds: t
      };
      !c.texts.length && !c.attributes.length && !c.removes.length && !c.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(c));
    }, this.processMutation = (t) => {
      if (!Wr(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const n = t.target.textContent;
            !Se(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) && n !== t.oldValue && this.texts.push({
              value: $t(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                this.unmaskTextClass,
                this.unmaskTextSelector,
                this.maskAllText
              ) && n ? this.maskTextFn ? this.maskTextFn(n, zc(t.target)) : n.replace(/[\S]/g, "*") : n,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const n = t.target;
            let r = t.attributeName, s = t.target.getAttribute(r);
            if (r === "value") {
              const o = ni(n), c = n.tagName;
              s = ar(n, c, o);
              const a = vr({
                maskInputOptions: this.maskInputOptions,
                tagName: c,
                type: o
              }), u = $t(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                this.unmaskTextClass,
                this.unmaskTextSelector,
                a
              );
              s = dn({
                isMasked: u,
                element: n,
                value: s,
                maskInputFn: this.maskInputFn
              });
            }
            if (Se(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) || s === t.oldValue)
              return;
            let i = this.attributeMap.get(t.target);
            if (n.tagName === "IFRAME" && r === "src" && !this.keepIframeSrcFn(s))
              if (!oi(
                n
              ))
                r = "rr_src";
              else
                return;
            if (i || (i = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(i), this.attributeMap.set(t.target, i)), r === "type" && n.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && n.setAttribute("data-rr-is-password", "true"), !Bc(n.tagName, r) && (i.attributes[r] = $c(
              this.doc,
              Ft(n.tagName),
              Ft(r),
              s,
              n,
              this.maskAttributeFn
            ), r === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const o = this.unattachedDoc.createElement("span");
              t.oldValue && o.setAttribute("style", t.oldValue);
              for (const c of Array.from(n.style)) {
                const a = n.style.getPropertyValue(c), u = n.style.getPropertyPriority(c);
                a !== o.style.getPropertyValue(c) || u !== o.style.getPropertyPriority(c) ? u === "" ? i.styleDiff[c] = a : i.styleDiff[c] = [a, u] : i._unchangedStyles[c] = [a, u];
              }
              for (const c of Array.from(o.style))
                n.style.getPropertyValue(c) === "" && (i.styleDiff[c] = !1);
            }
            break;
          }
          case "childList": {
            if (Se(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !0
            ))
              return;
            t.addedNodes.forEach((n) => this.genAdds(n, t.target)), t.removedNodes.forEach((n) => {
              const r = this.mirror.getId(n), s = tn(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              Se(
                t.target,
                this.blockClass,
                this.blockSelector,
                this.unblockSelector,
                !1
              ) || Wr(n, this.mirror) || !Lg(n, this.mirror) || (this.addedSet.has(n) ? (ys(this.addedSet, n), this.droppedSet.add(n)) : this.addedSet.has(t.target) && r === -1 || qc(t.target, this.mirror) || (this.movedSet.has(n) && this.movedMap[xo(r, s)] ? ys(this.movedSet, n) : this.removes.push({
                parentId: s,
                id: r,
                isShadow: tn(t.target) && nn(t.target) ? !0 : void 0
              })), this.mapRemoves.push(n));
            });
            break;
          }
        }
    }, this.genAdds = (t, n) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (Wr(t, this.mirror))
            return;
          this.movedSet.add(t);
          let r = null;
          n && this.mirror.hasNode(n) && (r = this.mirror.getId(n)), r && r !== -1 && (this.movedMap[xo(this.mirror.getId(t), r)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        Se(
          t,
          this.blockClass,
          this.blockSelector,
          this.unblockSelector,
          !1
        ) || (t.childNodes && t.childNodes.forEach((r) => this.genAdds(r)), _s(t) && t.shadowRoot.childNodes.forEach((r) => {
          this.processedNodeManager.add(r, this), this.genAdds(r, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((n) => {
      this[n] = t[n];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function ys(e, t) {
  e.delete(t), t.childNodes?.forEach((n) => ys(e, n));
}
function Mo(e, t, n) {
  return e.length === 0 ? !1 : qg(e, t, n);
}
function qg(e, t, n) {
  let r = t.parentNode;
  for (; r; ) {
    const s = n.getId(r);
    if (e.some((i) => i.id === s))
      return !0;
    r = r.parentNode;
  }
  return !1;
}
function Ao(e, t) {
  return e.size === 0 ? !1 : Xc(e, t);
}
function Xc(e, t) {
  const { parentNode: n } = t;
  return n ? e.has(n) ? !0 : Xc(e, n) : !1;
}
let rn;
function Vg(e) {
  rn = e;
}
function Gg() {
  rn = void 0;
}
const W = (e) => rn ? (...n) => {
  try {
    return e(...n);
  } catch (r) {
    if (rn && rn(r) === !0)
      return () => {
      };
    throw r;
  }
} : e, xt = [];
function wn(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function Jc(e, t) {
  const n = new zg();
  xt.push(n), n.init(e);
  let r = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */
  window.__rrMutationObserver;
  const s = window?.Zone?.__symbol__?.("MutationObserver");
  s && window[s] && (r = window[s]);
  const i = new r(
    W((o) => {
      e.onMutation && e.onMutation(o) === !1 || n.processMutations.bind(n)(o);
    })
  );
  return i.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), i;
}
function Yg({
  mousemoveCb: e,
  sampling: t,
  doc: n,
  mirror: r
}) {
  if (t.mousemove === !1)
    return () => {
    };
  const s = typeof t.mousemove == "number" ? t.mousemove : 50, i = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let o = [], c;
  const a = fn(
    W(
      (d) => {
        const p = Date.now() - c;
        e(
          o.map((f) => (f.timeOffset -= p, f)),
          d
        ), o = [], c = null;
      }
    ),
    i
  ), u = W(
    fn(
      W((d) => {
        const p = wn(d), { clientX: f, clientY: h } = gs(d) ? d.changedTouches[0] : d;
        c || (c = ur()), o.push({
          x: f,
          y: h,
          id: r.getId(p),
          timeOffset: ur() - c
        }), a(
          typeof DragEvent < "u" && d instanceof DragEvent ? M.Drag : d instanceof MouseEvent ? M.MouseMove : M.TouchMove
        );
      }),
      s,
      {
        trailing: !1
      }
    )
  ), l = [
    he("mousemove", u, n),
    he("touchmove", u, n),
    he("drag", u, n)
  ];
  return W(() => {
    l.forEach((d) => d());
  });
}
function Kg({
  mouseInteractionCb: e,
  doc: t,
  mirror: n,
  blockClass: r,
  blockSelector: s,
  unblockSelector: i,
  sampling: o
}) {
  if (o.mouseInteraction === !1)
    return () => {
    };
  const c = o.mouseInteraction === !0 || o.mouseInteraction === void 0 ? {} : o.mouseInteraction, a = [];
  let u = null;
  const l = (d) => (p) => {
    const f = wn(p);
    if (Se(f, r, s, i, !0))
      return;
    let h = null, m = d;
    if ("pointerType" in p) {
      switch (p.pointerType) {
        case "mouse":
          h = Pe.Mouse;
          break;
        case "touch":
          h = Pe.Touch;
          break;
        case "pen":
          h = Pe.Pen;
          break;
      }
      h === Pe.Touch ? pe[d] === pe.MouseDown ? m = "TouchStart" : pe[d] === pe.MouseUp && (m = "TouchEnd") : Pe.Pen;
    } else gs(p) && (h = Pe.Touch);
    h !== null ? (u = h, (m.startsWith("Touch") && h === Pe.Touch || m.startsWith("Mouse") && h === Pe.Mouse) && (h = null)) : pe[d] === pe.Click && (h = u, u = null);
    const g = gs(p) ? p.changedTouches[0] : p;
    if (!g)
      return;
    const E = n.getId(f), { clientX: R, clientY: j } = g;
    W(e)({
      type: pe[m],
      id: E,
      x: R,
      y: j,
      ...h !== null && { pointerType: h }
    });
  };
  return Object.keys(pe).filter(
    (d) => Number.isNaN(Number(d)) && !d.endsWith("_Departed") && c[d] !== !1
  ).forEach((d) => {
    let p = Ft(d);
    const f = l(d);
    if (window.PointerEvent)
      switch (pe[d]) {
        case pe.MouseDown:
        case pe.MouseUp:
          p = p.replace(
            "mouse",
            "pointer"
          );
          break;
        case pe.TouchStart:
        case pe.TouchEnd:
          return;
      }
    a.push(he(p, f, t));
  }), W(() => {
    a.forEach((d) => d());
  });
}
function Qc({
  scrollCb: e,
  doc: t,
  mirror: n,
  blockClass: r,
  blockSelector: s,
  unblockSelector: i,
  sampling: o
}) {
  const c = W(
    fn(
      W((a) => {
        const u = wn(a);
        if (!u || Se(
          u,
          r,
          s,
          i,
          !0
        ))
          return;
        const l = n.getId(u);
        if (u === t && t.defaultView) {
          const d = Hc(t.defaultView);
          e({
            id: l,
            x: d.left,
            y: d.top
          });
        } else
          e({
            id: l,
            x: u.scrollLeft,
            y: u.scrollTop
          });
      }),
      o.scroll || 100
    )
  );
  return he("scroll", c, t);
}
function Xg({ viewportResizeCb: e }, { win: t }) {
  let n = -1, r = -1;
  const s = W(
    fn(
      W(() => {
        const i = Wc(), o = jc();
        (n !== i || r !== o) && (e({
          width: Number(o),
          height: Number(i)
        }), n = i, r = o);
      }),
      200
    )
  );
  return he("resize", s, t);
}
const Jg = ["INPUT", "TEXTAREA", "SELECT"], Oo = /* @__PURE__ */ new WeakMap();
function Qg({
  inputCb: e,
  doc: t,
  mirror: n,
  blockClass: r,
  blockSelector: s,
  unblockSelector: i,
  ignoreClass: o,
  ignoreSelector: c,
  maskInputOptions: a,
  maskInputFn: u,
  sampling: l,
  userTriggeredOnInput: d,
  maskTextClass: p,
  unmaskTextClass: f,
  maskTextSelector: h,
  unmaskTextSelector: m
}) {
  function g(y) {
    let T = wn(y);
    const b = y.isTrusted, k = T && hs(T.tagName);
    if (k === "OPTION" && (T = T.parentElement), !T || !k || Jg.indexOf(k) < 0 || Se(
      T,
      r,
      s,
      i,
      !0
    ))
      return;
    const L = T;
    if (L.classList.contains(o) || c && L.matches(c))
      return;
    const H = ni(T);
    let P = ar(L, k, H), Z = !1;
    const te = vr({
      maskInputOptions: a,
      tagName: k,
      type: H
    }), X = $t(
      T,
      p,
      h,
      f,
      m,
      te
    );
    (H === "radio" || H === "checkbox") && (Z = T.checked), P = dn({
      isMasked: X,
      element: T,
      value: P,
      maskInputFn: u
    }), E(
      T,
      d ? { text: P, isChecked: Z, userTriggered: b } : { text: P, isChecked: Z }
    );
    const S = T.name;
    H === "radio" && S && Z && t.querySelectorAll(`input[type="radio"][name="${S}"]`).forEach((q) => {
      if (q !== T) {
        const I = dn({
          // share mask behavior of `target`
          isMasked: X,
          element: q,
          value: ar(q, k, H),
          maskInputFn: u
        });
        E(
          q,
          d ? { text: I, isChecked: !Z, userTriggered: !1 } : { text: I, isChecked: !Z }
        );
      }
    });
  }
  function E(y, T) {
    const b = Oo.get(y);
    if (!b || b.text !== T.text || b.isChecked !== T.isChecked) {
      Oo.set(y, T);
      const k = n.getId(y);
      W(e)({
        ...T,
        id: k
      });
    }
  }
  const j = (l.input === "last" ? ["change"] : ["input", "change"]).map(
    (y) => he(y, W(g), t)
  ), D = t.defaultView;
  if (!D)
    return () => {
      j.forEach((y) => y());
    };
  const A = D.Object.getOwnPropertyDescriptor(
    D.HTMLInputElement.prototype,
    "value"
  ), w = [
    [D.HTMLInputElement.prototype, "value"],
    [D.HTMLInputElement.prototype, "checked"],
    [D.HTMLSelectElement.prototype, "value"],
    [D.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [D.HTMLSelectElement.prototype, "selectedIndex"],
    [D.HTMLOptionElement.prototype, "selected"]
  ];
  return A && A.set && j.push(
    ...w.map(
      (y) => Uc(
        y[0],
        y[1],
        {
          set() {
            W(g)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        D
      )
    )
  ), W(() => {
    j.forEach((y) => y());
  });
}
function dr(e) {
  const t = [];
  function n(r, s) {
    if (Pn("CSSGroupingRule") && r.parentRule instanceof CSSGroupingRule || Pn("CSSMediaRule") && r.parentRule instanceof CSSMediaRule || Pn("CSSSupportsRule") && r.parentRule instanceof CSSSupportsRule || Pn("CSSConditionRule") && r.parentRule instanceof CSSConditionRule) {
      const o = Array.from(
        r.parentRule.cssRules
      ).indexOf(r);
      s.unshift(o);
    } else if (r.parentStyleSheet) {
      const o = Array.from(r.parentStyleSheet.cssRules).indexOf(r);
      s.unshift(o);
    }
    return s;
  }
  return n(e, t);
}
function Ye(e, t, n) {
  let r, s;
  return e ? (e.ownerNode ? r = t.getId(e.ownerNode) : s = n.getId(e), {
    styleId: s,
    id: r
  }) : {};
}
function Zg({ styleSheetRuleCb: e, mirror: t, stylesheetManager: n }, { win: r }) {
  if (!r.CSSStyleSheet || !r.CSSStyleSheet.prototype)
    return () => {
    };
  const s = r.CSSStyleSheet.prototype.insertRule;
  r.CSSStyleSheet.prototype.insertRule = new Proxy(s, {
    apply: W(
      (l, d, p) => {
        const [f, h] = p, { id: m, styleId: g } = Ye(
          d,
          t,
          n.styleMirror
        );
        return (m && m !== -1 || g && g !== -1) && e({
          id: m,
          styleId: g,
          adds: [{ rule: f, index: h }]
        }), l.apply(d, p);
      }
    )
  });
  const i = r.CSSStyleSheet.prototype.deleteRule;
  r.CSSStyleSheet.prototype.deleteRule = new Proxy(i, {
    apply: W(
      (l, d, p) => {
        const [f] = p, { id: h, styleId: m } = Ye(
          d,
          t,
          n.styleMirror
        );
        return (h && h !== -1 || m && m !== -1) && e({
          id: h,
          styleId: m,
          removes: [{ index: f }]
        }), l.apply(d, p);
      }
    )
  });
  let o;
  r.CSSStyleSheet.prototype.replace && (o = r.CSSStyleSheet.prototype.replace, r.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: W(
      (l, d, p) => {
        const [f] = p, { id: h, styleId: m } = Ye(
          d,
          t,
          n.styleMirror
        );
        return (h && h !== -1 || m && m !== -1) && e({
          id: h,
          styleId: m,
          replace: f
        }), l.apply(d, p);
      }
    )
  }));
  let c;
  r.CSSStyleSheet.prototype.replaceSync && (c = r.CSSStyleSheet.prototype.replaceSync, r.CSSStyleSheet.prototype.replaceSync = new Proxy(c, {
    apply: W(
      (l, d, p) => {
        const [f] = p, { id: h, styleId: m } = Ye(
          d,
          t,
          n.styleMirror
        );
        return (h && h !== -1 || m && m !== -1) && e({
          id: h,
          styleId: m,
          replaceSync: f
        }), l.apply(d, p);
      }
    )
  }));
  const a = {};
  Fn("CSSGroupingRule") ? a.CSSGroupingRule = r.CSSGroupingRule : (Fn("CSSMediaRule") && (a.CSSMediaRule = r.CSSMediaRule), Fn("CSSConditionRule") && (a.CSSConditionRule = r.CSSConditionRule), Fn("CSSSupportsRule") && (a.CSSSupportsRule = r.CSSSupportsRule));
  const u = {};
  return Object.entries(a).forEach(([l, d]) => {
    u[l] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: d.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: d.prototype.deleteRule
    }, d.prototype.insertRule = new Proxy(
      u[l].insertRule,
      {
        apply: W(
          (p, f, h) => {
            const [m, g] = h, { id: E, styleId: R } = Ye(
              f.parentStyleSheet,
              t,
              n.styleMirror
            );
            return (E && E !== -1 || R && R !== -1) && e({
              id: E,
              styleId: R,
              adds: [
                {
                  rule: m,
                  index: [
                    ...dr(f),
                    g || 0
                    // defaults to 0
                  ]
                }
              ]
            }), p.apply(f, h);
          }
        )
      }
    ), d.prototype.deleteRule = new Proxy(
      u[l].deleteRule,
      {
        apply: W(
          (p, f, h) => {
            const [m] = h, { id: g, styleId: E } = Ye(
              f.parentStyleSheet,
              t,
              n.styleMirror
            );
            return (g && g !== -1 || E && E !== -1) && e({
              id: g,
              styleId: E,
              removes: [
                { index: [...dr(f), m] }
              ]
            }), p.apply(f, h);
          }
        )
      }
    );
  }), W(() => {
    r.CSSStyleSheet.prototype.insertRule = s, r.CSSStyleSheet.prototype.deleteRule = i, o && (r.CSSStyleSheet.prototype.replace = o), c && (r.CSSStyleSheet.prototype.replaceSync = c), Object.entries(a).forEach(([l, d]) => {
      d.prototype.insertRule = u[l].insertRule, d.prototype.deleteRule = u[l].deleteRule;
    });
  });
}
function Zc({
  mirror: e,
  stylesheetManager: t
}, n) {
  let r = null;
  n.nodeName === "#document" ? r = e.getId(n) : r = e.getId(n.host);
  const s = n.nodeName === "#document" ? n.defaultView?.Document : n.ownerDocument?.defaultView?.ShadowRoot, i = s?.prototype ? Object.getOwnPropertyDescriptor(
    s?.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return r === null || r === -1 || !s || !i ? () => {
  } : (Object.defineProperty(n, "adoptedStyleSheets", {
    configurable: i.configurable,
    enumerable: i.enumerable,
    get() {
      return i.get?.call(this);
    },
    set(o) {
      const c = i.set?.call(this, o);
      if (r !== null && r !== -1)
        try {
          t.adoptStyleSheets(o, r);
        } catch {
        }
      return c;
    }
  }), W(() => {
    Object.defineProperty(n, "adoptedStyleSheets", {
      configurable: i.configurable,
      enumerable: i.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: i.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: i.set
    });
  }));
}
function e_({
  styleDeclarationCb: e,
  mirror: t,
  ignoreCSSAttributes: n,
  stylesheetManager: r
}, { win: s }) {
  const i = s.CSSStyleDeclaration.prototype.setProperty;
  s.CSSStyleDeclaration.prototype.setProperty = new Proxy(i, {
    apply: W(
      (c, a, u) => {
        const [l, d, p] = u;
        if (n.has(l))
          return i.apply(a, [l, d, p]);
        const { id: f, styleId: h } = Ye(
          a.parentRule?.parentStyleSheet,
          t,
          r.styleMirror
        );
        return (f && f !== -1 || h && h !== -1) && e({
          id: f,
          styleId: h,
          set: {
            property: l,
            value: d,
            priority: p
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: dr(a.parentRule)
        }), c.apply(a, u);
      }
    )
  });
  const o = s.CSSStyleDeclaration.prototype.removeProperty;
  return s.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: W(
      (c, a, u) => {
        const [l] = u;
        if (n.has(l))
          return o.apply(a, [l]);
        const { id: d, styleId: p } = Ye(
          a.parentRule?.parentStyleSheet,
          t,
          r.styleMirror
        );
        return (d && d !== -1 || p && p !== -1) && e({
          id: d,
          styleId: p,
          remove: {
            property: l
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: dr(a.parentRule)
        }), c.apply(a, u);
      }
    )
  }), W(() => {
    s.CSSStyleDeclaration.prototype.setProperty = i, s.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function t_({
  mediaInteractionCb: e,
  blockClass: t,
  blockSelector: n,
  unblockSelector: r,
  mirror: s,
  sampling: i,
  doc: o
}) {
  const c = W(
    (u) => fn(
      W((l) => {
        const d = wn(l);
        if (!d || Se(
          d,
          t,
          n,
          r,
          !0
        ))
          return;
        const { currentTime: p, volume: f, muted: h, playbackRate: m } = d;
        e({
          type: u,
          id: s.getId(d),
          currentTime: p,
          volume: f,
          muted: h,
          playbackRate: m
        });
      }),
      i.media || 500
    )
  ), a = [
    he("play", c(wt.Play), o),
    he("pause", c(wt.Pause), o),
    he("seeked", c(wt.Seeked), o),
    he("volumechange", c(wt.VolumeChange), o),
    he("ratechange", c(wt.RateChange), o)
  ];
  return W(() => {
    a.forEach((u) => u());
  });
}
function n_({ fontCb: e, doc: t }) {
  const n = t.defaultView;
  if (!n)
    return () => {
    };
  const r = [], s = /* @__PURE__ */ new WeakMap(), i = n.FontFace;
  n.FontFace = function(a, u, l) {
    const d = new i(a, u, l);
    return s.set(d, {
      family: a,
      buffer: typeof u != "string",
      descriptors: l,
      fontSource: typeof u == "string" ? u : JSON.stringify(Array.from(new Uint8Array(u)))
    }), d;
  };
  const o = si(
    t.fonts,
    "add",
    function(c) {
      return function(a) {
        return Ir(
          W(() => {
            const u = s.get(a);
            u && (e(u), s.delete(a));
          }),
          0
        ), c.apply(this, [a]);
      };
    }
  );
  return r.push(() => {
    n.FontFace = i;
  }), r.push(o), W(() => {
    r.forEach((c) => c());
  });
}
function r_(e) {
  const {
    doc: t,
    mirror: n,
    blockClass: r,
    blockSelector: s,
    unblockSelector: i,
    selectionCb: o
  } = e;
  let c = !0;
  const a = W(() => {
    const u = t.getSelection();
    if (!u || c && u?.isCollapsed) return;
    c = u.isCollapsed || !1;
    const l = [], d = u.rangeCount || 0;
    for (let p = 0; p < d; p++) {
      const f = u.getRangeAt(p), { startContainer: h, startOffset: m, endContainer: g, endOffset: E } = f;
      Se(
        h,
        r,
        s,
        i,
        !0
      ) || Se(
        g,
        r,
        s,
        i,
        !0
      ) || l.push({
        start: n.getId(h),
        startOffset: m,
        end: n.getId(g),
        endOffset: E
      });
    }
    o({ ranges: l });
  });
  return a(), he("selectionchange", a);
}
function s_({
  doc: e,
  customElementCb: t
}) {
  const n = e.defaultView;
  return !n || !n.customElements ? () => {
  } : si(
    n.customElements,
    "define",
    function(s) {
      return function(i, o, c) {
        try {
          t({
            define: {
              name: i
            }
          });
        } catch {
        }
        return s.apply(this, [i, o, c]);
      };
    }
  );
}
function i_(e, t = {}) {
  const n = e.doc.defaultView;
  if (!n)
    return () => {
    };
  let r;
  e.recordDOM && (r = Jc(e, e.doc));
  const s = Yg(e), i = Kg(e), o = Qc(e), c = Xg(e, {
    win: n
  }), a = Qg(e), u = t_(e);
  let l = () => {
  }, d = () => {
  }, p = () => {
  }, f = () => {
  };
  e.recordDOM && (l = Zg(e, { win: n }), d = Zc(e, e.doc), p = e_(e, {
    win: n
  }), e.collectFonts && (f = n_(e)));
  const h = r_(e), m = s_(e), g = [];
  for (const E of e.plugins)
    g.push(
      E.observer(E.callback, n, E.options)
    );
  return W(() => {
    xt.forEach((E) => E.reset()), r?.disconnect(), s(), i(), o(), c(), a(), u(), l(), d(), p(), f(), h(), m(), g.forEach((E) => E());
  });
}
function Pn(e) {
  return typeof window[e] < "u";
}
function Fn(e) {
  return !!(typeof window[e] < "u" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class Ss {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, n, r, s) {
    const i = r || this.getIdToRemoteIdMap(t), o = s || this.getRemoteIdToIdMap(t);
    let c = i.get(n);
    return c || (c = this.generateIdFn(), i.set(n, c), o.set(c, n)), c;
  }
  getIds(t, n) {
    const r = this.getIdToRemoteIdMap(t), s = this.getRemoteIdToIdMap(t);
    return n.map(
      (i) => this.getId(t, i, r, s)
    );
  }
  getRemoteId(t, n, r) {
    const s = r || this.getRemoteIdToIdMap(t);
    if (typeof n != "number") return n;
    const i = s.get(n);
    return i || -1;
  }
  getRemoteIds(t, n) {
    const r = this.getRemoteIdToIdMap(t);
    return n.map((s) => this.getRemoteId(t, s, r));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let n = this.iframeIdToRemoteIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, n)), n;
  }
  getRemoteIdToIdMap(t) {
    let n = this.iframeRemoteIdToIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, n)), n;
  }
}
class o_ {
  constructor() {
    this.crossOriginIframeMirror = new Ss(ri), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class a_ {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new Ss(ri), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Ss(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, n) {
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: n
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && t.contentWindow?.addEventListener(
      "message",
      this.handleMessage.bind(this)
    ), this.loadListener?.(t);
    const r = oi(t);
    r && r.adoptedStyleSheets && r.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      r.adoptedStyleSheets,
      this.mirror.getId(r)
    );
  }
  handleMessage(t) {
    const n = t;
    if (n.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    n.origin !== n.data.origin || !t.source) return;
    const s = this.crossOriginIframeMap.get(t.source);
    if (!s) return;
    const i = this.transformCrossOriginEvent(
      s,
      n.data.event
    );
    i && this.wrappedEmit(
      i,
      n.data.isCheckout
    );
  }
  transformCrossOriginEvent(t, n) {
    switch (n.type) {
      case N.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(n.data.node, t);
        const r = n.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, r), this.patchRootIdOnNode(n.data.node, r), {
          timestamp: n.timestamp,
          type: N.IncrementalSnapshot,
          data: {
            source: M.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: n.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case N.Meta:
      case N.Load:
      case N.DomContentLoaded:
        return !1;
      case N.Plugin:
        return n;
      case N.Custom:
        return this.replaceIds(
          n.data.payload,
          t,
          ["id", "parentId", "previousId", "nextId"]
        ), n;
      case N.IncrementalSnapshot:
        switch (n.data.source) {
          case M.Mutation:
            return n.data.adds.forEach((r) => {
              this.replaceIds(r, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(r.node, t);
              const s = this.crossOriginIframeRootIdMap.get(t);
              s && this.patchRootIdOnNode(r.node, s);
            }), n.data.removes.forEach((r) => {
              this.replaceIds(r, t, ["parentId", "id"]);
            }), n.data.attributes.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n.data.texts.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case M.Drag:
          case M.TouchMove:
          case M.MouseMove:
            return n.data.positions.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case M.ViewportResize:
            return !1;
          case M.MediaInteraction:
          case M.MouseInteraction:
          case M.Scroll:
          case M.CanvasMutation:
          case M.Input:
            return this.replaceIds(n.data, t, ["id"]), n;
          case M.StyleSheetRule:
          case M.StyleDeclaration:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleId"]), n;
          case M.Font:
            return n;
          case M.Selection:
            return n.data.ranges.forEach((r) => {
              this.replaceIds(r, t, ["start", "end"]);
            }), n;
          case M.AdoptedStyleSheet:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleIds"]), n.data.styles?.forEach((r) => {
              this.replaceStyleIds(r, t, ["styleId"]);
            }), n;
        }
    }
    return !1;
  }
  replace(t, n, r, s) {
    for (const i of s)
      !Array.isArray(n[i]) && typeof n[i] != "number" || (Array.isArray(n[i]) ? n[i] = t.getIds(
        r,
        n[i]
      ) : n[i] = t.getId(r, n[i]));
    return n;
  }
  replaceIds(t, n, r) {
    return this.replace(this.crossOriginIframeMirror, t, n, r);
  }
  replaceStyleIds(t, n, r) {
    return this.replace(this.crossOriginIframeStyleMirror, t, n, r);
  }
  replaceIdOnNode(t, n) {
    this.replaceIds(t, n, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((r) => {
      this.replaceIdOnNode(r, n);
    });
  }
  patchRootIdOnNode(t, n) {
    t.type !== ae.Document && !t.rootId && (t.rootId = n), "childNodes" in t && t.childNodes.forEach((r) => {
      this.patchRootIdOnNode(r, n);
    });
  }
}
class c_ {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class u_ {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, n) {
    if (!nn(t) || this.shadowDoms.has(t)) return;
    this.shadowDoms.add(t), this.bypassOptions.canvasManager.addShadowRoot(t);
    const r = Jc(
      {
        ...this.bypassOptions,
        doc: n,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      },
      t
    );
    this.restoreHandlers.push(() => r.disconnect()), this.restoreHandlers.push(
      Qc({
        ...this.bypassOptions,
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: t,
        mirror: this.mirror
      })
    ), Ir(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        t.adoptedStyleSheets,
        this.mirror.getId(t.host)
      ), this.restoreHandlers.push(
        Zc(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          t
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(t) {
    const n = oi(t), r = Wg(t);
    !n || !r || this.patchAttachShadow(
      r.Element,
      n
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(t, n) {
    const r = this;
    this.restoreHandlers.push(
      si(
        t.prototype,
        "attachShadow",
        function(s) {
          return function(i) {
            const o = s.call(this, i);
            return this.shadowRoot && Kc(this) && r.addShadowRoot(this.shadowRoot, n), o;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.bypassOptions.canvasManager.resetShadowRoots();
  }
}
var No = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", d_ = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var $n = 0; $n < No.length; $n++)
  d_[No.charCodeAt($n)] = $n;
class Do {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
  addWindow() {
  }
  addShadowRoot() {
  }
  resetShadowRoots() {
  }
}
class l_ {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new Fg(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, n) {
    "_cssText" in n.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: n.id,
          attributes: n.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, n) {
    if (t.length === 0) return;
    const r = {
      id: n,
      styleIds: []
    }, s = [];
    for (const i of t) {
      let o;
      this.styleMirror.has(i) ? o = this.styleMirror.getId(i) : (o = this.styleMirror.add(i), s.push({
        styleId: o,
        rules: Array.from(i.rules || CSSRule, (c, a) => ({
          rule: Oc(c),
          index: a
        }))
      })), r.styleIds.push(o);
    }
    s.length > 0 && (r.styles = s), this.adoptedStyleSheetCb(r);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(t) {
  }
}
class f_ {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
  }
  inOtherBuffer(t, n) {
    const r = this.nodeMap.get(t);
    return r && Array.from(r).some((s) => s !== n);
  }
  add(t, n) {
    this.active || (this.active = !0, Ug(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(n));
  }
  destroy() {
  }
}
let se, lr;
try {
  if (Array.from([1], (e) => e * 2)[0] !== 2) {
    const e = document.createElement("iframe");
    document.body.appendChild(e), Array.from = e.contentWindow?.Array.from || Array.from, document.body.removeChild(e);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
const xe = lg();
function Ue(e = {}) {
  const {
    emit: t,
    checkoutEveryNms: n,
    checkoutEveryNth: r,
    blockClass: s = "rr-block",
    blockSelector: i = null,
    unblockSelector: o = null,
    ignoreClass: c = "rr-ignore",
    ignoreSelector: a = null,
    maskAllText: u = !1,
    maskTextClass: l = "rr-mask",
    unmaskTextClass: d = null,
    maskTextSelector: p = null,
    unmaskTextSelector: f = null,
    inlineStylesheet: h = !0,
    maskAllInputs: m,
    maskInputOptions: g,
    slimDOMOptions: E,
    maskAttributeFn: R,
    maskInputFn: j,
    maskTextFn: D,
    maxCanvasSize: A = null,
    packFn: w,
    sampling: y = {},
    dataURLOptions: T = {},
    mousemoveWait: b,
    recordDOM: k = !0,
    recordCanvas: L = !1,
    recordCrossOriginIframes: H = !1,
    recordAfter: P = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load",
    userTriggeredOnInput: Z = !1,
    collectFonts: te = !1,
    inlineImages: X = !1,
    plugins: S,
    keepIframeSrcFn: q = () => !1,
    ignoreCSSAttributes: I = /* @__PURE__ */ new Set([]),
    errorHandler: V,
    onMutation: re,
    getCanvasManager: ee
  } = e;
  Vg(V);
  const ve = H ? window.parent === window : !0;
  let fe = !1;
  if (!ve)
    try {
      window.parent.document && (fe = !1);
    } catch {
      fe = !0;
    }
  if (ve && !t)
    throw new Error("emit function is required");
  if (!ve && !fe)
    return () => {
    };
  b !== void 0 && y.mousemove === void 0 && (y.mousemove = b), xe.reset();
  const bt = m === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    radio: !0,
    checkbox: !0
  } : g !== void 0 ? g : {}, Le = E === !0 || E === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: E === "all",
    headMetaDescKeywords: E === "all"
  } : E || {};
  Pg();
  let vt, Kt = 0;
  const gi = (Y) => {
    for (const Ce of S || [])
      Ce.eventProcessor && (Y = Ce.eventProcessor(Y));
    return w && // Disable packing events which will be emitted to parent frames.
    !fe && (Y = w(Y)), Y;
  };
  se = (Y, Ce) => {
    const F = Y;
    if (F.timestamp = ur(), xt[0]?.isFrozen() && F.type !== N.FullSnapshot && !(F.type === N.IncrementalSnapshot && F.data.source === M.Mutation) && xt.forEach((ue) => ue.unfreeze()), ve)
      t?.(gi(F), Ce);
    else if (fe) {
      const ue = {
        type: "rrweb",
        event: gi(F),
        origin: window.location.origin,
        isCheckout: Ce
      };
      window.parent.postMessage(ue, "*");
    }
    if (F.type === N.FullSnapshot)
      vt = F, Kt = 0;
    else if (F.type === N.IncrementalSnapshot) {
      if (F.data.source === M.Mutation && F.data.isAttachIframe)
        return;
      Kt++;
      const ue = r && Kt >= r, K = n && vt && F.timestamp - vt.timestamp > n;
      (ue || K) && xr(!0);
    }
  };
  const Xt = (Y) => {
    se({
      type: N.IncrementalSnapshot,
      data: {
        source: M.Mutation,
        ...Y
      }
    });
  }, _i = (Y) => se({
    type: N.IncrementalSnapshot,
    data: {
      source: M.Scroll,
      ...Y
    }
  }), Ru = (Y) => se({
    type: N.IncrementalSnapshot,
    data: {
      source: M.CanvasMutation,
      ...Y
    }
  }), Cu = (Y) => se({
    type: N.IncrementalSnapshot,
    data: {
      source: M.AdoptedStyleSheet,
      ...Y
    }
  }), ot = new l_({
    mutationCb: Xt,
    adoptedStyleSheetCb: Cu
  }), at = typeof __RRWEB_EXCLUDE_IFRAME__ == "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new o_() : new a_({
    mirror: xe,
    mutationCb: Xt,
    stylesheetManager: ot,
    recordCrossOriginIframes: H,
    wrappedEmit: se
  });
  for (const Y of S || [])
    Y.getMirror && Y.getMirror({
      nodeMirror: xe,
      crossOriginIframeMirror: at.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: at.crossOriginIframeStyleMirror
    });
  const Rr = new f_(), Cr = h_(
    ee,
    {
      mirror: xe,
      win: window,
      mutationCb: (Y) => se({
        type: N.IncrementalSnapshot,
        data: {
          source: M.CanvasMutation,
          ...Y
        }
      }),
      recordCanvas: L,
      blockClass: s,
      blockSelector: i,
      unblockSelector: o,
      maxCanvasSize: A,
      sampling: y.canvas,
      dataURLOptions: T,
      errorHandler: V
    }
  ), Rn = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ == "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new c_() : new u_({
    mutationCb: Xt,
    scrollCb: _i,
    bypassOptions: {
      onMutation: re,
      blockClass: s,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: u,
      maskTextClass: l,
      unmaskTextClass: d,
      maskTextSelector: p,
      unmaskTextSelector: f,
      inlineStylesheet: h,
      maskInputOptions: bt,
      dataURLOptions: T,
      maskAttributeFn: R,
      maskTextFn: D,
      maskInputFn: j,
      recordCanvas: L,
      inlineImages: X,
      sampling: y,
      slimDOMOptions: Le,
      iframeManager: at,
      stylesheetManager: ot,
      canvasManager: Cr,
      keepIframeSrcFn: q,
      processedNodeManager: Rr
    },
    mirror: xe
  }), xr = (Y = !1) => {
    if (!k)
      return;
    se(
      {
        type: N.Meta,
        data: {
          href: window.location.href,
          width: jc(),
          height: Wc()
        }
      },
      Y
    ), ot.reset(), Rn.init(), xt.forEach((F) => F.lock());
    const Ce = Dg(document, {
      mirror: xe,
      blockClass: s,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: u,
      maskTextClass: l,
      unmaskTextClass: d,
      maskTextSelector: p,
      unmaskTextSelector: f,
      inlineStylesheet: h,
      maskAllInputs: bt,
      maskAttributeFn: R,
      maskInputFn: j,
      maskTextFn: D,
      slimDOM: Le,
      dataURLOptions: T,
      recordCanvas: L,
      inlineImages: X,
      onSerialize: (F) => {
        Vc(F, xe) && at.addIframe(F), Gc(F, xe) && ot.trackLinkElement(F), _s(F) && Rn.addShadowRoot(F.shadowRoot, document);
      },
      onIframeLoad: (F, ue) => {
        at.attachIframe(F, ue), F.contentWindow && Cr.addWindow(F.contentWindow), Rn.observeAttachShadow(F);
      },
      onStylesheetLoad: (F, ue) => {
        ot.attachLinkElement(F, ue);
      },
      onBlockedImageLoad: (F, ue, { width: K, height: Jt }) => {
        Xt({
          adds: [],
          removes: [],
          texts: [],
          attributes: [
            {
              id: ue.id,
              attributes: {
                style: {
                  width: `${K}px`,
                  height: `${Jt}px`
                }
              }
            }
          ]
        });
      },
      keepIframeSrcFn: q
    });
    if (!Ce)
      return console.warn("Failed to snapshot the document");
    se({
      type: N.FullSnapshot,
      data: {
        node: Ce,
        initialOffset: Hc(window)
      }
    }), xt.forEach((F) => F.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && ot.adoptStyleSheets(
      document.adoptedStyleSheets,
      xe.getId(document)
    );
  };
  lr = xr;
  try {
    const Y = [], Ce = (ue) => W(i_)(
      {
        onMutation: re,
        mutationCb: Xt,
        mousemoveCb: (K, Jt) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: Jt,
            positions: K
          }
        }),
        mouseInteractionCb: (K) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: M.MouseInteraction,
            ...K
          }
        }),
        scrollCb: _i,
        viewportResizeCb: (K) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: M.ViewportResize,
            ...K
          }
        }),
        inputCb: (K) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: M.Input,
            ...K
          }
        }),
        mediaInteractionCb: (K) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: M.MediaInteraction,
            ...K
          }
        }),
        styleSheetRuleCb: (K) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: M.StyleSheetRule,
            ...K
          }
        }),
        styleDeclarationCb: (K) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: M.StyleDeclaration,
            ...K
          }
        }),
        canvasMutationCb: Ru,
        fontCb: (K) => se({
          type: N.IncrementalSnapshot,
          data: {
            source: M.Font,
            ...K
          }
        }),
        selectionCb: (K) => {
          se({
            type: N.IncrementalSnapshot,
            data: {
              source: M.Selection,
              ...K
            }
          });
        },
        customElementCb: (K) => {
          se({
            type: N.IncrementalSnapshot,
            data: {
              source: M.CustomElement,
              ...K
            }
          });
        },
        blockClass: s,
        ignoreClass: c,
        ignoreSelector: a,
        maskAllText: u,
        maskTextClass: l,
        unmaskTextClass: d,
        maskTextSelector: p,
        unmaskTextSelector: f,
        maskInputOptions: bt,
        inlineStylesheet: h,
        sampling: y,
        recordDOM: k,
        recordCanvas: L,
        inlineImages: X,
        userTriggeredOnInput: Z,
        collectFonts: te,
        doc: ue,
        maskAttributeFn: R,
        maskInputFn: j,
        maskTextFn: D,
        keepIframeSrcFn: q,
        blockSelector: i,
        unblockSelector: o,
        slimDOMOptions: Le,
        dataURLOptions: T,
        mirror: xe,
        iframeManager: at,
        stylesheetManager: ot,
        shadowDomManager: Rn,
        processedNodeManager: Rr,
        canvasManager: Cr,
        ignoreCSSAttributes: I,
        plugins: S?.filter((K) => K.observer)?.map((K) => ({
          observer: K.observer,
          options: K.options,
          callback: (Jt) => se({
            type: N.Plugin,
            data: {
              plugin: K.name,
              payload: Jt
            }
          })
        })) || []
      },
      {}
    );
    at.addLoadListener((ue) => {
      try {
        Y.push(Ce(ue.contentDocument));
      } catch (K) {
        console.warn(K);
      }
    });
    const F = () => {
      xr(), Y.push(Ce(document));
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? F() : (Y.push(
      he("DOMContentLoaded", () => {
        se({
          type: N.DomContentLoaded,
          data: {}
        }), P === "DOMContentLoaded" && F();
      })
    ), Y.push(
      he(
        "load",
        () => {
          se({
            type: N.Load,
            data: {}
          }), P === "load" && F();
        },
        window
      )
    )), () => {
      Y.forEach((ue) => ue()), Rr.destroy(), lr = void 0, Gg();
    };
  } catch (Y) {
    console.warn(Y);
  }
}
function p_(e) {
  if (!lr)
    throw new Error("please take full snapshot after start recording");
  lr(e);
}
Ue.mirror = xe;
Ue.takeFullSnapshot = p_;
function h_(e, t) {
  try {
    return e ? e(t) : new Do();
  } catch {
    return console.warn("Unable to initialize CanvasManager"), new Do();
  }
}
var Lo;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(Lo || (Lo = {}));
const m_ = 3, g_ = 5;
function ai(e) {
  return e > 9999999999 ? e : e * 1e3;
}
function jr(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function kn(e, t) {
  t.category !== "sentry.transaction" && (["ui.click", "ui.input"].includes(t.category) ? e.triggerUserActivity() : e.checkAndHandleExpiredSession(), e.addUpdate(() => (e.throttledAddEvent({
    type: N.Custom,
    // TODO: We were converting from ms to seconds for breadcrumbs, spans,
    // but maybe we should just keep them as milliseconds
    timestamp: (t.timestamp || 0) * 1e3,
    data: {
      tag: "breadcrumb",
      // normalize to max. 10 depth and 1_000 properties per object
      payload: Me(t, 10, 1e3)
    }
  }), t.category === "console")));
}
const __ = "button,a";
function eu(e) {
  return e.closest(__) || e;
}
function tu(e) {
  const t = nu(e);
  return !t || !(t instanceof Element) ? t : eu(t);
}
function nu(e) {
  return y_(e) ? e.target : e;
}
function y_(e) {
  return typeof e == "object" && !!e && "target" in e;
}
let Ke;
function S_(e) {
  return Ke || (Ke = [], E_()), Ke.push(e), () => {
    const t = Ke ? Ke.indexOf(e) : -1;
    t > -1 && Ke.splice(t, 1);
  };
}
function E_() {
  ge(Q, "open", function(e) {
    return function(...t) {
      if (Ke)
        try {
          Ke.forEach((n) => n());
        } catch {
        }
      return e.apply(Q, t);
    };
  });
}
const b_ = /* @__PURE__ */ new Set([
  M.Mutation,
  M.StyleSheetRule,
  M.StyleDeclaration,
  M.AdoptedStyleSheet,
  M.CanvasMutation,
  M.Selection,
  M.MediaInteraction
]);
function v_(e, t, n) {
  e.handleClick(t, n);
}
class T_ {
  // protected for testing
  constructor(t, n, r = kn) {
    this._lastMutation = 0, this._lastScroll = 0, this._clicks = [], this._timeout = n.timeout / 1e3, this._threshold = n.threshold / 1e3, this._scrollTimeout = n.scrollTimeout / 1e3, this._replay = t, this._ignoreSelector = n.ignoreSelector, this._addBreadcrumbEvent = r;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const t = S_(() => {
      this._lastMutation = Po();
    });
    this._teardown = () => {
      t(), this._clicks = [], this._lastMutation = 0, this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    this._teardown && this._teardown(), this._checkClickTimeout && clearTimeout(this._checkClickTimeout);
  }
  /** @inheritDoc */
  handleClick(t, n) {
    if (w_(n, this._ignoreSelector) || !k_(t))
      return;
    const r = {
      timestamp: jr(t.timestamp),
      clickBreadcrumb: t,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node: n
    };
    this._clicks.some((s) => s.node === r.node && Math.abs(s.timestamp - r.timestamp) < 1) || (this._clicks.push(r), this._clicks.length === 1 && this._scheduleCheckClicks());
  }
  /** @inheritDoc */
  registerMutation(t = Date.now()) {
    this._lastMutation = jr(t);
  }
  /** @inheritDoc */
  registerScroll(t = Date.now()) {
    this._lastScroll = jr(t);
  }
  /** @inheritDoc */
  registerClick(t) {
    const n = eu(t);
    this._handleMultiClick(n);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(t) {
    this._getClicks(t).forEach((n) => {
      n.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(t) {
    return this._clicks.filter((n) => n.node === t);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const t = [], n = Po();
    this._clicks.forEach((r) => {
      !r.mutationAfter && this._lastMutation && (r.mutationAfter = r.timestamp <= this._lastMutation ? this._lastMutation - r.timestamp : void 0), !r.scrollAfter && this._lastScroll && (r.scrollAfter = r.timestamp <= this._lastScroll ? this._lastScroll - r.timestamp : void 0), r.timestamp + this._timeout <= n && t.push(r);
    });
    for (const r of t) {
      const s = this._clicks.indexOf(r);
      s > -1 && (this._generateBreadcrumbs(r), this._clicks.splice(s, 1));
    }
    this._clicks.length && this._scheduleCheckClicks();
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(t) {
    const n = this._replay, r = t.scrollAfter && t.scrollAfter <= this._scrollTimeout, s = t.mutationAfter && t.mutationAfter <= this._threshold, i = !r && !s, { clickCount: o, clickBreadcrumb: c } = t;
    if (i) {
      const a = Math.min(t.mutationAfter || this._timeout, this._timeout) * 1e3, u = a < this._timeout * 1e3 ? "mutation" : "timeout", l = {
        type: "default",
        message: c.message,
        timestamp: c.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...c.data,
          url: Q.location.href,
          route: n.getCurrentRoute(),
          timeAfterClickMs: a,
          endReason: u,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: o || 1
        }
      };
      this._addBreadcrumbEvent(n, l);
      return;
    }
    if (o > 1) {
      const a = {
        type: "default",
        message: c.message,
        timestamp: c.timestamp,
        category: "ui.multiClick",
        data: {
          ...c.data,
          url: Q.location.href,
          route: n.getCurrentRoute(),
          clickCount: o,
          metric: !0
        }
      };
      this._addBreadcrumbEvent(n, a);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    this._checkClickTimeout && clearTimeout(this._checkClickTimeout), this._checkClickTimeout = In(() => this._checkClicks(), 1e3);
  }
}
const I_ = ["A", "BUTTON", "INPUT"];
function w_(e, t) {
  return !!(!I_.includes(e.tagName) || e.tagName === "INPUT" && !["submit", "button"].includes(e.getAttribute("type") || "") || e.tagName === "A" && (e.hasAttribute("download") || e.hasAttribute("target") && e.getAttribute("target") !== "_self") || t && e.matches(t));
}
function k_(e) {
  return !!(e.data && typeof e.data.nodeId == "number" && e.timestamp);
}
function Po() {
  return Date.now() / 1e3;
}
function R_(e, t) {
  try {
    if (!C_(t))
      return;
    const { source: n } = t.data;
    if (b_.has(n) && e.registerMutation(t.timestamp), n === M.Scroll && e.registerScroll(t.timestamp), x_(t)) {
      const { type: r, id: s } = t.data, i = Ue.mirror.getNode(s);
      i instanceof HTMLElement && r === pe.Click && e.registerClick(i);
    }
  } catch {
  }
}
function C_(e) {
  return e.type === m_;
}
function x_(e) {
  return e.data.source === M.MouseInteraction;
}
function Oe(e) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...e
  };
}
var ci = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(ci || {});
const M_ = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function A_(e) {
  const t = {};
  !e["data-sentry-component"] && e["data-sentry-element"] && (e["data-sentry-component"] = e["data-sentry-element"]);
  for (const n in e)
    if (M_.has(n)) {
      let r = n;
      (n === "data-testid" || n === "data-test-id") && (r = "testId"), t[r] = e[n];
    }
  return t;
}
const O_ = (e) => (t) => {
  if (!e.isEnabled())
    return;
  const n = N_(t);
  if (!n)
    return;
  const r = t.name === "click", s = r ? t.event : void 0;
  r && e.clickDetector && s?.target && !s.altKey && !s.metaKey && !s.ctrlKey && !s.shiftKey && v_(
    e.clickDetector,
    n,
    tu(t.event)
  ), kn(e, n);
};
function ru(e, t) {
  const n = Ue.mirror.getId(e), r = n && Ue.mirror.getNode(n), s = r && Ue.mirror.getMeta(r), i = s && L_(s) ? s : null;
  return {
    message: t,
    data: i ? {
      nodeId: n,
      node: {
        id: n,
        tagName: i.tagName,
        textContent: Array.from(i.childNodes).map((o) => o.type === ci.Text && o.textContent).filter(Boolean).map((o) => o.trim()).join(""),
        attributes: A_(i.attributes)
      }
    } : {}
  };
}
function N_(e) {
  const { target: t, message: n } = D_(e);
  return Oe({
    category: `ui.${e.name}`,
    ...ru(t, n)
  });
}
function D_(e) {
  const t = e.name === "click";
  let n, r = null;
  try {
    r = t ? tu(e.event) : nu(e.event), n = ke(r, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    n = "<unknown>";
  }
  return { target: r, message: n };
}
function L_(e) {
  return e.type === ci.Element;
}
function P_(e, t) {
  if (!e.isEnabled())
    return;
  e.updateUserActivity();
  const n = F_(t);
  n && kn(e, n);
}
function F_(e) {
  const { metaKey: t, shiftKey: n, ctrlKey: r, altKey: s, key: i, target: o } = e;
  if (!o || $_(o) || !i)
    return null;
  const c = t || r || s, a = i.length === 1;
  if (!c && a)
    return null;
  const u = ke(o, { maxStringLength: 200 }) || "<unknown>", l = ru(o, u);
  return Oe({
    category: "ui.keyDown",
    message: u,
    data: {
      ...l.data,
      metaKey: t,
      shiftKey: n,
      ctrlKey: r,
      altKey: s,
      key: i
    }
  });
}
function $_(e) {
  return e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable;
}
const B_ = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: z_,
  paint: W_,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: j_
};
function zr(e, t) {
  return ({ metric: n }) => void t.replayPerformanceEntries.push(e(n));
}
function U_(e) {
  return e.map(H_).filter(Boolean);
}
function H_(e) {
  const t = B_[e.entryType];
  return t ? t(e) : null;
}
function Bt(e) {
  return ((ye() || Q.performance.timeOrigin) + e) / 1e3;
}
function W_(e) {
  const { duration: t, entryType: n, name: r, startTime: s } = e, i = Bt(s);
  return {
    type: n,
    name: r,
    start: i,
    end: i + t,
    data: void 0
  };
}
function j_(e) {
  const {
    entryType: t,
    name: n,
    decodedBodySize: r,
    duration: s,
    domComplete: i,
    encodedBodySize: o,
    domContentLoadedEventStart: c,
    domContentLoadedEventEnd: a,
    domInteractive: u,
    loadEventStart: l,
    loadEventEnd: d,
    redirectCount: p,
    startTime: f,
    transferSize: h,
    type: m
  } = e;
  return s === 0 ? null : {
    type: `${t}.${m}`,
    start: Bt(f),
    end: Bt(i),
    name: n,
    data: {
      size: h,
      decodedBodySize: r,
      encodedBodySize: o,
      duration: s,
      domInteractive: u,
      domContentLoadedEventStart: c,
      domContentLoadedEventEnd: a,
      loadEventStart: l,
      loadEventEnd: d,
      domComplete: i,
      redirectCount: p
    }
  };
}
function z_(e) {
  const {
    entryType: t,
    initiatorType: n,
    name: r,
    responseEnd: s,
    startTime: i,
    decodedBodySize: o,
    encodedBodySize: c,
    responseStatus: a,
    transferSize: u
  } = e;
  return ["fetch", "xmlhttprequest"].includes(n) ? null : {
    type: `${t}.${n}`,
    start: Bt(i),
    end: Bt(s),
    name: r,
    data: {
      size: u,
      statusCode: a,
      decodedBodySize: o,
      encodedBodySize: c
    }
  };
}
function q_(e) {
  const t = e.entries[e.entries.length - 1], n = t?.element ? [t.element] : void 0;
  return ui(e, "largest-contentful-paint", n);
}
function V_(e) {
  return e.sources !== void 0;
}
function G_(e) {
  const t = [], n = [];
  for (const r of e.entries)
    if (V_(r)) {
      const s = [];
      for (const i of r.sources)
        if (i.node) {
          n.push(i.node);
          const o = Ue.mirror.getId(i.node);
          o && s.push(o);
        }
      t.push({ value: r.value, nodeIds: s.length ? s : void 0 });
    }
  return ui(e, "cumulative-layout-shift", n, t);
}
function Y_(e) {
  const t = e.entries[e.entries.length - 1], n = t?.target ? [t.target] : void 0;
  return ui(e, "interaction-to-next-paint", n);
}
function ui(e, t, n, r) {
  const s = e.value, i = e.rating, o = Bt(s);
  return {
    type: "web-vital",
    name: t,
    start: o,
    end: o,
    data: {
      value: s,
      size: s,
      rating: i,
      nodeIds: n ? n.map((c) => Ue.mirror.getId(c)) : void 0,
      attributions: r
    }
  };
}
function K_(e) {
  function t(s) {
    e.performanceEntries.includes(s) || e.performanceEntries.push(s);
  }
  function n({ entries: s }) {
    s.forEach(t);
  }
  const r = [];
  return ["navigation", "paint", "resource"].forEach((s) => {
    r.push(yt(s, n));
  }), r.push(
    Js(zr(q_, e)),
    Xs(zr(G_, e)),
    _c(zr(Y_, e))
  ), () => {
    r.forEach((s) => s());
  };
}
const C = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, X_ = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function J_() {
  const e = new Blob([X_]);
  return URL.createObjectURL(e);
}
const Fo = ["log", "warn", "error"], Yn = "[Replay] ";
function qr(e, t = "info") {
  et(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level: t,
      message: `${Yn}${e}`
    },
    { level: t }
  );
}
function Q_() {
  let e = !1, t = !1;
  const n = {
    exception: () => {
    },
    infoTick: () => {
    },
    setConfig: (r) => {
      e = !!r.captureExceptions, t = !!r.traceInternals;
    }
  };
  return C ? (Fo.forEach((r) => {
    n[r] = (...s) => {
      _[r](Yn, ...s), t && qr(s.join(""), tc(r));
    };
  }), n.exception = (r, ...s) => {
    s.length && n.error && n.error(...s), _.error(Yn, r), e ? yn(r, {
      mechanism: {
        handled: !0,
        type: "auto.function.replay.debug"
      }
    }) : t && qr(r, "error");
  }, n.infoTick = (...r) => {
    _.log(Yn, ...r), t && setTimeout(() => qr(r[0]), 0);
  }) : Fo.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const x = Q_();
class di extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${ti}.`);
  }
}
class su {
  /** All the events that are buffered to be sent. */
  /** @inheritdoc */
  /** @inheritdoc */
  constructor() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(t) {
    const n = JSON.stringify(t).length;
    if (this._totalSize += n, this._totalSize > ti)
      throw new di();
    this.events.push(t);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((t) => {
      const n = this.events;
      this.clear(), t(JSON.stringify(n));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    const t = this.events.map((n) => n.timestamp).sort()[0];
    return t ? ai(t) : null;
  }
}
class Z_ {
  constructor(t) {
    this._worker = t, this._id = 0;
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._ensureReadyPromise ? this._ensureReadyPromise : (this._ensureReadyPromise = new Promise((t, n) => {
      this._worker.addEventListener(
        "message",
        ({ data: r }) => {
          r.success ? t() : n();
        },
        { once: !0 }
      ), this._worker.addEventListener(
        "error",
        (r) => {
          n(r);
        },
        { once: !0 }
      );
    }), this._ensureReadyPromise);
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    C && x.log("Destroying compression worker"), this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(t, n) {
    const r = this._getAndIncrementId();
    return new Promise((s, i) => {
      const o = ({ data: c }) => {
        const a = c;
        if (a.method === t && a.id === r) {
          if (this._worker.removeEventListener("message", o), !a.success) {
            C && x.error("Error in compression worker: ", a.response), i(new Error("Error in compression worker"));
            return;
          }
          s(a.response);
        }
      };
      this._worker.addEventListener("message", o), this._worker.postMessage({ id: r, method: t, arg: n });
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class ey {
  /** @inheritdoc */
  /** @inheritdoc */
  constructor(t) {
    this._worker = new Z_(t), this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */
  addEvent(t) {
    const n = ai(t.timestamp);
    (!this._earliestTimestamp || n < this._earliestTimestamp) && (this._earliestTimestamp = n);
    const r = JSON.stringify(t);
    return this._totalSize += r.length, this._totalSize > ti ? Promise.reject(new di()) : this._sendEventToWorker(r);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this._worker.postMessage("clear").then(null, (t) => {
      C && x.exception(t, 'Sending "clear" message to worker failed', t);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(t) {
    return this._worker.postMessage("addEvent", t);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const t = await this._worker.postMessage("finish");
    return this._earliestTimestamp = null, this._totalSize = 0, t;
  }
}
class ty {
  constructor(t) {
    this._fallback = new su(), this._compression = new ey(t), this._used = this._fallback, this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get waitForCheckout() {
    return this._used.waitForCheckout;
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(t) {
    this._used.hasCheckout = t;
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  set waitForCheckout(t) {
    this._used.waitForCheckout = t;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy(), this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(t) {
    return this._used.addEvent(t);
  }
  /** @inheritDoc */
  async finish() {
    return await this.ensureWorkerIsLoaded(), this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (t) {
      C && x.exception(t, "Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events: t, hasCheckout: n, waitForCheckout: r } = this._fallback, s = [];
    for (const i of t)
      s.push(this._compression.addEvent(i));
    this._compression.hasCheckout = n, this._compression.waitForCheckout = r, this._used = this._compression;
    try {
      await Promise.all(s), this._fallback.clear();
    } catch (i) {
      C && x.exception(i, "Failed to add events when switching buffers.");
    }
  }
}
function ny({
  useCompression: e,
  workerUrl: t
}) {
  if (e && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const n = ry(t);
    if (n)
      return n;
  }
  return C && x.log("Using simple buffer"), new su();
}
function ry(e) {
  try {
    const t = e || sy();
    if (!t)
      return;
    C && x.log(`Using compression worker${e ? ` from ${e}` : ""}`);
    const n = new Worker(t);
    return new ty(n);
  } catch (t) {
    C && x.exception(t, "Failed to create compression worker");
  }
}
function sy() {
  return typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ > "u" || !__SENTRY_EXCLUDE_REPLAY_WORKER__ ? J_() : "";
}
function li() {
  try {
    return "sessionStorage" in Q && !!Q.sessionStorage;
  } catch {
    return !1;
  }
}
function iy(e) {
  oy(), e.session = void 0;
}
function oy() {
  if (li())
    try {
      Q.sessionStorage.removeItem(Zs);
    } catch {
    }
}
function iu(e) {
  return e === void 0 ? !1 : Math.random() < e;
}
function fi(e) {
  if (li())
    try {
      Q.sessionStorage.setItem(Zs, JSON.stringify(e));
    } catch {
    }
}
function ou(e) {
  const t = Date.now(), n = e.id || Ee(), r = e.started || t, s = e.lastActivity || t, i = e.segmentId || 0, o = e.sampled, c = e.previousSessionId;
  return {
    id: n,
    started: r,
    lastActivity: s,
    segmentId: i,
    sampled: o,
    previousSessionId: c
  };
}
function ay(e, t) {
  return iu(e) ? "session" : t ? "buffer" : !1;
}
function $o({ sessionSampleRate: e, allowBuffering: t, stickySession: n = !1 }, { previousSessionId: r } = {}) {
  const s = ay(e, t), i = ou({
    sampled: s,
    previousSessionId: r
  });
  return n && fi(i), i;
}
function cy() {
  if (!li())
    return null;
  try {
    const e = Q.sessionStorage.getItem(Zs);
    if (!e)
      return null;
    const t = JSON.parse(e);
    return C && x.infoTick("Loading existing session"), ou(t);
  } catch {
    return null;
  }
}
function Es(e, t, n = +/* @__PURE__ */ new Date()) {
  return e === null || t === void 0 || t < 0 ? !0 : t === 0 ? !1 : e + t <= n;
}
function au(e, {
  maxReplayDuration: t,
  sessionIdleExpire: n,
  targetTime: r = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    Es(e.started, t, r) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    Es(e.lastActivity, n, r)
  );
}
function cu(e, { sessionIdleExpire: t, maxReplayDuration: n }) {
  return !(!au(e, { sessionIdleExpire: t, maxReplayDuration: n }) || e.sampled === "buffer" && e.segmentId === 0);
}
function Vr({
  sessionIdleExpire: e,
  maxReplayDuration: t,
  previousSessionId: n
}, r) {
  const s = r.stickySession && cy();
  return s ? cu(s, { sessionIdleExpire: e, maxReplayDuration: t }) ? (C && x.infoTick("Session in sessionStorage is expired, creating new one..."), $o(r, { previousSessionId: s.id })) : s : (C && x.infoTick("Creating new session"), $o(r, { previousSessionId: n }));
}
function uy(e) {
  return e.type === N.Custom;
}
function pi(e, t, n) {
  return du(e, t) ? (uu(e, t, n), !0) : !1;
}
function dy(e, t, n) {
  return du(e, t) ? uu(e, t, n) : Promise.resolve(null);
}
async function uu(e, t, n) {
  const { eventBuffer: r } = e;
  if (!r || r.waitForCheckout && !n)
    return null;
  const s = e.recordingMode === "buffer";
  try {
    n && s && r.clear(), n && (r.hasCheckout = !0, r.waitForCheckout = !1);
    const i = e.getOptions(), o = ly(t, i.beforeAddRecordingEvent);
    return o ? await r.addEvent(o) : void 0;
  } catch (i) {
    const o = i && i instanceof di, c = o ? "addEventSizeExceeded" : "addEvent";
    if (o && s)
      return r.clear(), r.waitForCheckout = !0, null;
    e.handleException(i), await e.stop({ reason: c });
    const a = U();
    a && a.recordDroppedEvent("internal_sdk_error", "replay");
  }
}
function du(e, t) {
  if (!e.eventBuffer || e.isPaused() || !e.isEnabled())
    return !1;
  const n = ai(t.timestamp);
  return n + e.timeouts.sessionIdlePause < Date.now() ? !1 : n > e.getContext().initialTimestamp + e.getOptions().maxReplayDuration ? (C && x.infoTick(`Skipping event with timestamp ${n} because it is after maxReplayDuration`), !1) : !0;
}
function ly(e, t) {
  try {
    if (typeof t == "function" && uy(e))
      return t(e);
  } catch (n) {
    return C && x.exception(n, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event..."), null;
  }
  return e;
}
function hi(e) {
  return !e.type;
}
function bs(e) {
  return e.type === "transaction";
}
function fy(e) {
  return e.type === "replay_event";
}
function Bo(e) {
  return e.type === "feedback";
}
function py(e) {
  return (t, n) => {
    if (!e.isEnabled() || !hi(t) && !bs(t))
      return;
    const r = n.statusCode;
    if (!(!r || r < 200 || r >= 300)) {
      if (bs(t)) {
        hy(e, t);
        return;
      }
      my(e, t);
    }
  };
}
function hy(e, t) {
  const n = e.getContext();
  t.contexts?.trace?.trace_id && n.traceIds.size < 100 && n.traceIds.add(t.contexts.trace.trace_id);
}
function my(e, t) {
  const n = e.getContext();
  if (t.event_id && n.errorIds.size < 100 && n.errorIds.add(t.event_id), e.recordingMode !== "buffer" || !t.tags || !t.tags.replayId)
    return;
  const { beforeErrorSampling: r } = e.getOptions();
  typeof r == "function" && !r(t) || In(async () => {
    try {
      await e.sendBufferedReplayOrFlush();
    } catch (s) {
      e.handleException(s);
    }
  });
}
function gy(e) {
  return (t) => {
    !e.isEnabled() || !hi(t) || _y(e, t);
  };
}
function _y(e, t) {
  const n = t.exception?.values?.[0]?.value;
  if (typeof n == "string" && // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  // With newer React versions, the messages changed to a different website https://react.dev/errors/418
  (n.match(
    /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/
  ) || // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  n.match(/(does not match server-rendered HTML|Hydration failed because)/i))) {
    const r = Oe({
      category: "replay.hydrate-error",
      data: {
        url: jt()
      }
    });
    kn(e, r);
  }
}
function yy(e) {
  const t = U();
  t && t.on("beforeAddBreadcrumb", (n) => Sy(e, n));
}
function Sy(e, t) {
  if (!e.isEnabled() || !lu(t))
    return;
  const n = Ey(t);
  n && kn(e, n);
}
function Ey(e) {
  return !lu(e) || [
    // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
    "fetch",
    "xhr",
    // These two are breadcrumbs for emitted sentry events, we don't care about them
    "sentry.event",
    "sentry.transaction"
  ].includes(e.category) || // We capture UI breadcrumbs separately
  e.category.startsWith("ui.") ? null : e.category === "console" ? by(e) : Oe(e);
}
function by(e) {
  const t = e.data?.arguments;
  if (!Array.isArray(t) || t.length === 0)
    return Oe(e);
  let n = !1;
  const r = t.map((s) => {
    if (!s)
      return s;
    if (typeof s == "string")
      return s.length > Ln ? (n = !0, `${s.slice(0, Ln)}…`) : s;
    if (typeof s == "object")
      try {
        const i = Me(s, 7);
        return JSON.stringify(i).length > Ln ? (n = !0, `${JSON.stringify(i, null, 2).slice(0, Ln)}…`) : i;
      } catch {
      }
    return s;
  });
  return Oe({
    ...e,
    data: {
      ...e.data,
      arguments: r,
      ...n ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function lu(e) {
  return !!e.category;
}
function vy(e, t) {
  return e.type || !e.exception?.values?.length ? !1 : !!t.originalException?.__rrweb__;
}
function fu() {
  const e = G().getPropagationContext().dsc;
  e && delete e.replay_id;
  const t = le();
  if (t) {
    const n = qe(t);
    delete n.replay_id;
  }
}
function Ty(e, t) {
  e.triggerUserActivity(), e.addUpdate(() => t.timestamp ? (e.throttledAddEvent({
    type: N.Custom,
    timestamp: t.timestamp * 1e3,
    data: {
      tag: "breadcrumb",
      payload: {
        timestamp: t.timestamp,
        type: "default",
        category: "sentry.feedback",
        data: {
          feedbackId: t.event_id
        }
      }
    }
  }), !1) : !0);
}
function Iy(e, t) {
  return e.recordingMode !== "buffer" || t.message === ei || !t.exception || t.type ? !1 : iu(e.getOptions().errorSampleRate);
}
function wy(e) {
  return Object.assign(
    (t, n) => !e.isEnabled() || e.isPaused() ? t : fy(t) ? (delete t.breadcrumbs, t) : !hi(t) && !bs(t) && !Bo(t) ? t : e.checkAndHandleExpiredSession() ? Bo(t) ? (e.flush(), t.contexts.feedback.replay_id = e.getSessionId(), Ty(e, t), t) : vy(t, n) && !e.getOptions()._experiments.captureExceptions ? (C && x.log("Ignoring error from rrweb internals", t), null) : ((Iy(e, t) || e.recordingMode === "session") && (t.tags = { ...t.tags, replayId: e.getSessionId() }), t) : (fu(), t),
    { id: "Replay" }
  );
}
function wr(e, t) {
  return t.map(({ type: n, start: r, end: s, name: i, data: o }) => {
    const c = e.throttledAddEvent({
      type: N.Custom,
      timestamp: r,
      data: {
        tag: "performanceSpan",
        payload: {
          op: n,
          description: i,
          startTimestamp: r,
          endTimestamp: s,
          data: o
        }
      }
    });
    return typeof c == "string" ? Promise.resolve(null) : c;
  });
}
function ky(e) {
  const { from: t, to: n } = e, r = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: r,
    end: r,
    name: n,
    data: {
      previous: t
    }
  };
}
function Ry(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = ky(t);
    n !== null && (e.getContext().urls.push(n.name), e.triggerUserActivity(), e.addUpdate(() => (wr(e, [n]), !1)));
  };
}
function Cy(e, t) {
  return C && e.getOptions()._experiments.traceInternals ? !1 : Ef(t, U());
}
function pu(e, t) {
  e.isEnabled() && t !== null && (Cy(e, t.name) || e.addUpdate(() => (wr(e, [t]), !0)));
}
function kr(e) {
  if (!e)
    return;
  const t = new TextEncoder();
  try {
    if (typeof e == "string")
      return t.encode(e).length;
    if (e instanceof URLSearchParams)
      return t.encode(e.toString()).length;
    if (e instanceof FormData) {
      const n = kc(e);
      return t.encode(n).length;
    }
    if (e instanceof Blob)
      return e.size;
    if (e instanceof ArrayBuffer)
      return e.byteLength;
  } catch {
  }
}
function hu(e) {
  if (!e)
    return;
  const t = parseInt(e, 10);
  return isNaN(t) ? void 0 : t;
}
function fr(e, t) {
  if (!e)
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [t]
      }
    };
  const n = { ...e._meta }, r = n.warnings || [];
  return n.warnings = [...r, t], e._meta = n, e;
}
function mu(e, t) {
  if (!t)
    return null;
  const { startTimestamp: n, endTimestamp: r, url: s, method: i, statusCode: o, request: c, response: a } = t;
  return {
    type: e,
    start: n / 1e3,
    end: r / 1e3,
    name: s,
    data: {
      method: i,
      statusCode: o,
      request: c,
      response: a
    }
  };
}
function pn(e) {
  return {
    headers: {},
    size: e,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function Xe(e, t, n) {
  if (!t && Object.keys(e).length === 0)
    return;
  if (!t)
    return {
      headers: e
    };
  if (!n)
    return {
      headers: e,
      size: t
    };
  const r = {
    headers: e,
    size: t
  }, { body: s, warnings: i } = xy(n);
  return r.body = s, i?.length && (r._meta = {
    warnings: i
  }), r;
}
function vs(e, t) {
  return Object.entries(e).reduce((n, [r, s]) => {
    const i = r.toLowerCase();
    return t.includes(i) && e[r] && (n[i] = s), n;
  }, {});
}
function xy(e) {
  if (!e || typeof e != "string")
    return {
      body: e
    };
  const t = e.length > So, n = My(e);
  if (t) {
    const r = e.slice(0, So);
    return n ? {
      body: r,
      warnings: ["MAYBE_JSON_TRUNCATED"]
    } : {
      body: `${r}…`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (n)
    try {
      return {
        body: JSON.parse(e)
      };
    } catch {
    }
  return {
    body: e
  };
}
function My(e) {
  const t = e[0], n = e[e.length - 1];
  return t === "[" && n === "]" || t === "{" && n === "}";
}
function pr(e, t) {
  const n = Ay(e);
  return $e(n, t);
}
function Ay(e, t = Q.document.baseURI) {
  if (e.startsWith("http://") || e.startsWith("https://") || e.startsWith(Q.location.origin))
    return e;
  const n = new URL(e, t);
  if (n.origin !== new URL(t).origin)
    return e;
  const r = n.href;
  return !e.endsWith("/") && r.endsWith("/") ? r.slice(0, -1) : r;
}
async function Oy(e, t, n) {
  try {
    const r = await Dy(e, t, n), s = mu("resource.fetch", r);
    pu(n.replay, s);
  } catch (r) {
    C && x.exception(r, "Failed to capture fetch breadcrumb");
  }
}
function Ny(e, t) {
  const { input: n, response: r } = t, s = n ? Cc(n) : void 0, i = kr(s), o = r ? hu(r.headers.get("content-length")) : void 0;
  i !== void 0 && (e.data.request_body_size = i), o !== void 0 && (e.data.response_body_size = o);
}
async function Dy(e, t, n) {
  const r = Date.now(), { startTimestamp: s = r, endTimestamp: i = r } = t, {
    url: o,
    method: c,
    status_code: a = 0,
    request_body_size: u,
    response_body_size: l
  } = e.data, d = pr(o, n.networkDetailAllowUrls) && !pr(o, n.networkDetailDenyUrls), p = d ? Ly(n, t.input, u) : pn(u), f = await Py(d, n, t.response, l);
  return {
    startTimestamp: s,
    endTimestamp: i,
    url: o,
    method: c,
    statusCode: a,
    request: p,
    response: f
  };
}
function Ly({ networkCaptureBodies: e, networkRequestHeaders: t }, n, r) {
  const s = n ? By(n, t) : {};
  if (!e)
    return Xe(s, r, void 0);
  const i = Cc(n), [o, c] = Rc(i, x), a = Xe(s, r, o);
  return c ? fr(a, c) : a;
}
async function Py(e, {
  networkCaptureBodies: t,
  networkResponseHeaders: n
}, r, s) {
  if (!e && s !== void 0)
    return pn(s);
  const i = r ? gu(r.headers, n) : {};
  if (!r || !t && s !== void 0)
    return Xe(i, s, void 0);
  const [o, c] = await $y(r), a = Fy(o, {
    networkCaptureBodies: t,
    responseBodySize: s,
    captureDetails: e,
    headers: i
  });
  return c ? fr(a, c) : a;
}
function Fy(e, {
  networkCaptureBodies: t,
  responseBodySize: n,
  captureDetails: r,
  headers: s
}) {
  try {
    const i = e?.length && n === void 0 ? kr(e) : n;
    return r ? t ? Xe(s, i, e) : Xe(s, i, void 0) : pn(i);
  } catch (i) {
    return C && x.exception(i, "Failed to serialize response body"), Xe(s, n, void 0);
  }
}
async function $y(e) {
  const t = Uy(e);
  if (!t)
    return [void 0, "BODY_PARSE_ERROR"];
  try {
    return [await Hy(t)];
  } catch (n) {
    return n instanceof Error && n.message.indexOf("Timeout") > -1 ? (C && x.warn("Parsing text body from response timed out"), [void 0, "BODY_PARSE_TIMEOUT"]) : (C && x.exception(n, "Failed to get text body from response"), [void 0, "BODY_PARSE_ERROR"]);
  }
}
function gu(e, t) {
  const n = {};
  return t.forEach((r) => {
    e.get(r) && (n[r] = e.get(r));
  }), n;
}
function By(e, t) {
  return e.length === 1 && typeof e[0] != "string" ? Uo(e[0], t) : e.length === 2 ? Uo(e[1], t) : {};
}
function Uo(e, t) {
  if (!e)
    return {};
  const n = e.headers;
  return n ? n instanceof Headers ? gu(n, t) : Array.isArray(n) ? {} : vs(n, t) : {};
}
function Uy(e) {
  try {
    return e.clone();
  } catch (t) {
    C && x.exception(t, "Failed to clone response body");
  }
}
function Hy(e) {
  return new Promise((t, n) => {
    const r = In(() => n(new Error("Timeout while trying to read response body")), 500);
    Wy(e).then(
      (s) => t(s),
      (s) => n(s)
    ).finally(() => clearTimeout(r));
  });
}
async function Wy(e) {
  return await e.text();
}
async function jy(e, t, n) {
  try {
    const r = qy(e, t, n), s = mu("resource.xhr", r);
    pu(n.replay, s);
  } catch (r) {
    C && x.exception(r, "Failed to capture xhr breadcrumb");
  }
}
function zy(e, t) {
  const { xhr: n, input: r } = t;
  if (!n)
    return;
  const s = kr(r), i = n.getResponseHeader("content-length") ? hu(n.getResponseHeader("content-length")) : Ky(n.response, n.responseType);
  s !== void 0 && (e.data.request_body_size = s), i !== void 0 && (e.data.response_body_size = i);
}
function qy(e, t, n) {
  const r = Date.now(), { startTimestamp: s = r, endTimestamp: i = r, input: o, xhr: c } = t, {
    url: a,
    method: u,
    status_code: l = 0,
    request_body_size: d,
    response_body_size: p
  } = e.data;
  if (!a)
    return null;
  if (!c || !pr(a, n.networkDetailAllowUrls) || pr(a, n.networkDetailDenyUrls)) {
    const w = pn(d), y = pn(p);
    return {
      startTimestamp: s,
      endTimestamp: i,
      url: a,
      method: u,
      statusCode: l,
      request: w,
      response: y
    };
  }
  const f = c[dt], h = f ? vs(f.request_headers, n.networkRequestHeaders) : {}, m = vs(Vy(c), n.networkResponseHeaders), [g, E] = n.networkCaptureBodies ? Rc(o, x) : [void 0], [R, j] = n.networkCaptureBodies ? Gy(c) : [void 0], D = Xe(h, d, g), A = Xe(m, p, R);
  return {
    startTimestamp: s,
    endTimestamp: i,
    url: a,
    method: u,
    statusCode: l,
    request: E ? fr(D, E) : D,
    response: j ? fr(A, j) : A
  };
}
function Vy(e) {
  const t = e.getAllResponseHeaders();
  return t ? t.split(`\r
`).reduce((n, r) => {
    const [s, i] = r.split(": ");
    return i && (n[s.toLowerCase()] = i), n;
  }, {}) : {};
}
function Gy(e) {
  const t = [];
  try {
    return [e.responseText];
  } catch (n) {
    t.push(n);
  }
  try {
    return Yy(e.response, e.responseType);
  } catch (n) {
    t.push(n);
  }
  return C && x.warn("Failed to get xhr response body", ...t), [void 0];
}
function Yy(e, t) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof Document)
      return [e.body.outerHTML];
    if (t === "json" && e && typeof e == "object")
      return [JSON.stringify(e)];
    if (!e)
      return [void 0];
  } catch (n) {
    return C && x.exception(n, "Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return C && x.log("Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function Ky(e, t) {
  try {
    const n = t === "json" && e && typeof e == "object" ? JSON.stringify(e) : e;
    return kr(n);
  } catch {
    return;
  }
}
function Xy(e) {
  const t = U();
  try {
    const {
      networkDetailAllowUrls: n,
      networkDetailDenyUrls: r,
      networkCaptureBodies: s,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    } = e.getOptions(), c = {
      replay: e,
      networkDetailAllowUrls: n,
      networkDetailDenyUrls: r,
      networkCaptureBodies: s,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    };
    t && t.on("beforeAddBreadcrumb", (a, u) => Jy(c, a, u));
  } catch {
  }
}
function Jy(e, t, n) {
  if (t.data)
    try {
      Qy(t) && eS(n) && (zy(t, n), jy(t, n, e)), Zy(t) && tS(n) && (Ny(t, n), Oy(t, n, e));
    } catch (r) {
      C && x.exception(r, "Error when enriching network breadcrumb");
    }
}
function Qy(e) {
  return e.category === "xhr";
}
function Zy(e) {
  return e.category === "fetch";
}
function eS(e) {
  return e?.xhr;
}
function tS(e) {
  return e?.response;
}
function nS(e) {
  const t = U();
  Tc(O_(e)), br(Ry(e)), yy(e), Xy(e);
  const n = wy(e);
  $l(n), t && (t.on("beforeSendEvent", gy(e)), t.on("afterSendEvent", py(e)), t.on("createDsc", (r) => {
    const s = e.getSessionId();
    s && e.isEnabled() && e.recordingMode === "session" && e.checkAndHandleExpiredSession() && (r.replay_id = s);
  }), t.on("spanStart", (r) => {
    e.lastActiveSpan = r;
  }), t.on("spanEnd", (r) => {
    e.lastActiveSpan = r;
  }), t.on("beforeSendFeedback", async (r, s) => {
    const i = e.getSessionId();
    s?.includeReplay && e.isEnabled() && i && r.contexts?.feedback && (r.contexts.feedback.source === "api" && await e.sendBufferedReplayOrFlush(), r.contexts.feedback.replay_id = i);
  }), t.on("openFeedbackWidget", async () => {
    await e.sendBufferedReplayOrFlush();
  }));
}
async function rS(e) {
  try {
    return Promise.all(
      wr(e, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        sS(Q.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function sS(e) {
  const { jsHeapSizeLimit: t, totalJSHeapSize: n, usedJSHeapSize: r } = e, s = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: s,
    end: s,
    data: {
      memory: {
        jsHeapSizeLimit: t,
        totalJSHeapSize: n,
        usedJSHeapSize: r
      }
    }
  };
}
function iS(e, t, n) {
  return kf(e, t, {
    ...n,
    // @ts-expect-error - Not quite sure why these types do not match, but this is fine
    setTimeoutImpl: In
  });
}
const Bn = B.navigator;
function oS() {
  return /iPhone|iPad|iPod/i.test(Bn?.userAgent ?? "") || /Macintosh/i.test(Bn?.userAgent ?? "") && Bn?.maxTouchPoints && Bn?.maxTouchPoints > 1 ? {
    sampling: {
      mousemove: !1
    }
  } : {};
}
function aS(e) {
  let t = !1;
  return (n, r) => {
    if (!e.checkAndHandleExpiredSession()) {
      C && x.warn("Received replay event after session expired.");
      return;
    }
    const s = r || !t;
    t = !0, e.clickDetector && R_(e.clickDetector, n), e.addUpdate(() => {
      if (e.recordingMode === "buffer" && s && e.setInitialState(), !pi(e, n, s))
        return !0;
      if (!s)
        return !1;
      const i = e.session;
      if (uS(e, s), e.recordingMode === "buffer" && i && e.eventBuffer) {
        const o = e.eventBuffer.getEarliestTimestamp();
        o && (C && x.log(`Updating session start time to earliest event in buffer to ${new Date(o)}`), i.started = o, e.getOptions().stickySession && fi(i));
      }
      return i?.previousSessionId || e.recordingMode === "session" && e.flush(), !0;
    });
  };
}
function cS(e) {
  const t = e.getOptions();
  return {
    type: N.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: e.isRecordingCanvas(),
        sessionSampleRate: t.sessionSampleRate,
        errorSampleRate: t.errorSampleRate,
        useCompressionOption: t.useCompression,
        blockAllMedia: t.blockAllMedia,
        maskAllText: t.maskAllText,
        maskAllInputs: t.maskAllInputs,
        useCompression: e.eventBuffer ? e.eventBuffer.type === "worker" : !1,
        networkDetailHasUrls: t.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: t.networkCaptureBodies,
        networkRequestHasHeaders: t.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: t.networkResponseHeaders.length > 0
      }
    }
  };
}
function uS(e, t) {
  !t || !e.session || e.session.segmentId !== 0 || pi(e, cS(e), !1);
}
function dS(e) {
  if (!e)
    return null;
  try {
    return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
  } catch {
    return null;
  }
}
function lS(e, t, n, r) {
  return it(
    Ma(e, Ps(e), r, n),
    [
      [{ type: "replay_event" }, e],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof t == "string" ? new TextEncoder().encode(t).length : t.length
        },
        t
      ]
    ]
  );
}
function fS({
  recordingData: e,
  headers: t
}) {
  let n;
  const r = `${JSON.stringify(t)}
`;
  if (typeof e == "string")
    n = `${r}${e}`;
  else {
    const i = new TextEncoder().encode(r);
    n = new Uint8Array(i.length + e.length), n.set(i), n.set(e, i.length);
  }
  return n;
}
async function pS({
  client: e,
  scope: t,
  replayId: n,
  event: r
}) {
  const s = typeof e._integrations == "object" && e._integrations !== null && !Array.isArray(e._integrations) ? Object.keys(e._integrations) : void 0, i = { event_id: n, integrations: s };
  e.emit("preprocessEvent", r, i);
  const o = await Pa(
    e.getOptions(),
    r,
    i,
    t,
    e,
    De()
  );
  if (!o)
    return null;
  e.emit("postprocessEvent", o, i), o.platform = o.platform || "javascript";
  const c = e.getSdkMetadata(), { name: a, version: u, settings: l } = c?.sdk || {};
  return o.sdk = {
    ...o.sdk,
    name: a || "sentry.javascript.unknown",
    version: u || "0.0.0",
    settings: l
  }, o;
}
async function hS({
  recordingData: e,
  replayId: t,
  segmentId: n,
  eventContext: r,
  timestamp: s,
  session: i
}) {
  const o = fS({
    recordingData: e,
    headers: {
      segment_id: n
    }
  }), { urls: c, errorIds: a, traceIds: u, initialTimestamp: l } = r, d = U(), p = G(), f = d?.getTransport(), h = d?.getDsn();
  if (!d || !f || !h || !i.sampled)
    return Promise.resolve({});
  const m = {
    type: zm,
    replay_start_timestamp: l / 1e3,
    timestamp: s / 1e3,
    error_ids: a,
    trace_ids: u,
    urls: c,
    replay_id: t,
    segment_id: n,
    replay_type: i.sampled
  }, g = await pS({ scope: p, client: d, replayId: t, event: m });
  if (!g)
    return d.recordDroppedEvent("event_processor", "replay"), C && x.log("An event processor returned `null`, will not send event."), Promise.resolve({});
  delete g.sdkProcessingMetadata;
  const E = lS(g, o, h, d.getOptions().tunnel);
  let R;
  try {
    R = await f.send(E);
  } catch (D) {
    const A = new Error(ei);
    try {
      A.cause = D;
    } catch {
    }
    throw A;
  }
  if (typeof R.statusCode == "number" && (R.statusCode < 200 || R.statusCode >= 300))
    throw new _u(R.statusCode);
  const j = Qa({}, R);
  if (Ja(j, "replay"))
    throw new mi(j);
  return R;
}
class _u extends Error {
  constructor(t) {
    super(`Transport returned status code ${t}`);
  }
}
class mi extends Error {
  constructor(t) {
    super("Rate limit hit"), this.rateLimits = t;
  }
}
async function yu(e, t = {
  count: 0,
  interval: Xm
}) {
  const { recordingData: n, onError: r } = e;
  if (n.length)
    try {
      return await hS(e), !0;
    } catch (s) {
      if (s instanceof _u || s instanceof mi)
        throw s;
      if (Pl("Replays", {
        _retryCount: t.count
      }), r && r(s), t.count >= Jm) {
        const i = new Error(`${ei} - max retries exceeded`);
        try {
          i.cause = s;
        } catch {
        }
        throw i;
      }
      return t.interval *= ++t.count, new Promise((i, o) => {
        In(async () => {
          try {
            await yu(e, t), i(!0);
          } catch (c) {
            o(c);
          }
        }, t.interval);
      });
    }
}
const Su = "__THROTTLED", mS = "__SKIPPED";
function gS(e, t, n) {
  const r = /* @__PURE__ */ new Map(), s = (c) => {
    const a = c - n;
    r.forEach((u, l) => {
      l < a && r.delete(l);
    });
  }, i = () => [...r.values()].reduce((c, a) => c + a, 0);
  let o = !1;
  return (...c) => {
    const a = Math.floor(Date.now() / 1e3);
    if (s(a), i() >= t) {
      const l = o;
      return o = !0, l ? mS : Su;
    }
    o = !1;
    const u = r.get(a) || 0;
    return r.set(a, u + 1), e(...c);
  };
}
class _S {
  /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
  /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */
  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
  /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
  /**
   * Is the integration currently active?
   */
  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
  /**
   * Function to stop recording
   */
  /**
   * Internal use for canvas recording options
   */
  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  /**
   * Handle when page is blurred
   */
  /**
   * Handle when page is focused
   */
  /** Ensure page remains active when a key is pressed. */
  constructor({
    options: t,
    recordingOptions: n
  }) {
    this.eventBuffer = null, this.performanceEntries = [], this.replayPerformanceEntries = [], this.recordingMode = "session", this.timeouts = {
      sessionIdlePause: qm,
      sessionIdleExpire: Vm
    }, this._lastActivity = Date.now(), this._isEnabled = !1, this._isPaused = !1, this._requiresManualStart = !1, this._hasInitializedCoreListeners = !1, this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    }, this._recordingOptions = n, this._options = t, this._debouncedFlush = iS(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    }), this._throttledAddEvent = gS(
      (o, c) => dy(this, o, c),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout: r, slowClickIgnoreSelectors: s } = this.getOptions(), i = r ? {
      threshold: Math.min(Qm, r),
      timeout: r,
      scrollTimeout: Zm,
      ignoreSelector: s ? s.join(",") : ""
    } : void 0;
    if (i && (this.clickDetector = new T_(this, i)), C) {
      const o = t._experiments;
      x.setConfig({
        captureExceptions: !!o.captureExceptions,
        traceInternals: !!o.traceInternals
      });
    }
    this._handleVisibilityChange = () => {
      Q.document.visibilityState === "visible" ? this._doChangeToForegroundTasks() : this._doChangeToBackgroundTasks();
    }, this._handleWindowBlur = () => {
      const o = Oe({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(o);
    }, this._handleWindowFocus = () => {
      const o = Oe({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(o);
    }, this._handleKeyboardEvent = (o) => {
      P_(this, o);
    };
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return !!this._canvas;
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /** A wrapper to conditionally capture exceptions. */
  handleException(t) {
    C && x.exception(t), this._options.onError && this._options.onError(t);
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(t) {
    const { errorSampleRate: n, sessionSampleRate: r } = this._options, s = n <= 0 && r <= 0;
    if (this._requiresManualStart = s, !s) {
      if (this._initializeSessionForSampling(t), !this.session) {
        C && x.exception(new Error("Unable to initialize and create session"));
        return;
      }
      this.session.sampled !== !1 && (this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session", C && x.infoTick(`Starting replay in ${this.recordingMode} mode`), this._initializeRecording());
    }
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session") {
      C && x.log("Recording is already in progress");
      return;
    }
    if (this._isEnabled && this.recordingMode === "buffer") {
      C && x.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    C && x.infoTick("Starting replay in session mode"), this._updateUserActivity();
    const t = Vr(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: !1
      }
    );
    this.session = t, this.recordingMode = "session", this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled) {
      C && x.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    C && x.infoTick("Starting replay in buffer mode");
    const t = Vr(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: !0
      }
    );
    this.session = t, this.recordingMode = "buffer", this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const t = this._canvas;
      this._stopRecording = Ue({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" ? { checkoutEveryNms: Km } : (
          // Otherwise, use experimental option w/ min checkout time of 6 minutes
          // This is to improve playback seeking as there could potentially be
          // less mutations to process in the worse cases.
          //
          // checkout by "N" events is probably ideal, but means we have less
          // control about the number of checkouts we make (which generally
          // increases replay size)
          this._options._experiments.continuousCheckout && {
            // Minimum checkout time is 6 minutes
            checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
          }
        ),
        emit: aS(this),
        ...oS(),
        onMutation: this._onMutationHandler.bind(this),
        ...t ? {
          recordCanvas: t.recordCanvas,
          getCanvasManager: t.getCanvasManager,
          sampling: t.sampling,
          dataURLOptions: t.dataURLOptions
        } : {}
      });
    } catch (t) {
      this.handleException(t);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      return this._stopRecording && (this._stopRecording(), this._stopRecording = void 0), !0;
    } catch (t) {
      return this.handleException(t), !1;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({ forceFlush: t = !1, reason: n } = {}) {
    if (this._isEnabled) {
      this._isEnabled = !1, this.recordingMode = "buffer";
      try {
        C && x.log(`Stopping Replay${n ? ` triggered by ${n}` : ""}`), fu(), this._removeListeners(), this.stopRecording(), this._debouncedFlush.cancel(), t && await this._flush({ force: !0 }), this.eventBuffer?.destroy(), this.eventBuffer = null, iy(this);
      } catch (r) {
        this.handleException(r);
      }
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    this._isPaused || (this._isPaused = !0, this.stopRecording(), C && x.log("Pausing replay"));
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    !this._isPaused || !this._checkSession() || (this._isPaused = !1, this.startRecording(), C && x.log("Resuming replay"));
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording: t = !0 } = {}) {
    if (this.recordingMode === "session")
      return this.flushImmediate();
    const n = Date.now();
    C && x.log("Converting buffer to session"), await this.flushImmediate();
    const r = this.stopRecording();
    !t || !r || this.recordingMode !== "session" && (this.recordingMode = "session", this.session && (this._updateUserActivity(n), this._updateSessionActivity(n), this._maybeSaveSession()), this.startRecording());
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(t) {
    const n = t();
    this.recordingMode === "buffer" || !this._isEnabled || n !== !0 && this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    if (this._updateUserActivity(), !this._stopRecording) {
      if (!this._checkSession())
        return;
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession(), this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity(), this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    return this.recordingMode === "buffer" ? Promise.resolve() : this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */
  flushImmediate() {
    return this._debouncedFlush(), this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */
  getSessionId(t) {
    if (!(t && this.session?.sampled === !1))
      return this.session?.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && Es(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
      this.pause();
      return;
    }
    return !!this._checkSession();
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const t = `${Q.location.pathname}${Q.location.hash}${Q.location.search}`, n = `${Q.location.origin}${t}`;
    this.performanceEntries = [], this.replayPerformanceEntries = [], this._clearContext(), this._context.initialUrl = n, this._context.initialTimestamp = Date.now(), this._context.urls.push(n);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(t, n) {
    const r = this._throttledAddEvent(t, n);
    if (r === Su) {
      const s = Oe({
        category: "replay.throttled"
      });
      this.addUpdate(() => !pi(this, {
        type: g_,
        timestamp: s.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: s,
          metric: !0
        }
      }));
    }
    return r;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const t = this.lastActiveSpan || le(), n = t && de(t), s = (n && $(n).data || {})[_e];
    if (!(!n || !s || !["route", "custom"].includes(s)))
      return $(n).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState(), this._updateSessionActivity(), this.eventBuffer = ny({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    }), this._removeListeners(), this._addListeners(), this._isEnabled = !0, this._isPaused = !1, this.startRecording();
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(t) {
    const n = this._options.errorSampleRate > 0, r = Vr(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        previousSessionId: t
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: n
      }
    );
    this.session = r;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session)
      return !1;
    const t = this.session;
    return cu(t, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }) ? (this._refreshSession(t), !1) : !0;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(t) {
    this._isEnabled && (await this.stop({ reason: "refresh session" }), this.initializeSampling(t.id));
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      Q.document.addEventListener("visibilitychange", this._handleVisibilityChange), Q.addEventListener("blur", this._handleWindowBlur), Q.addEventListener("focus", this._handleWindowFocus), Q.addEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.addListeners(), this._hasInitializedCoreListeners || (nS(this), this._hasInitializedCoreListeners = !0);
    } catch (t) {
      this.handleException(t);
    }
    this._performanceCleanupCallback = K_(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      Q.document.removeEventListener("visibilitychange", this._handleVisibilityChange), Q.removeEventListener("blur", this._handleWindowBlur), Q.removeEventListener("focus", this._handleWindowFocus), Q.removeEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.removeListeners(), this._performanceCleanupCallback && this._performanceCleanupCallback();
    } catch (t) {
      this.handleException(t);
    }
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(t) {
    !this.session || au(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }) || (t && this._createCustomBreadcrumb(t), this.conditionalFlush());
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(t) {
    if (!this.session)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      C && x.log("Document has become active, but session has expired");
      return;
    }
    t && this._createCustomBreadcrumb(t);
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(t = Date.now()) {
    this._lastActivity = t;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(t = Date.now()) {
    this.session && (this.session.lastActivity = t, this._maybeSaveSession());
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(t) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: N.Custom,
        timestamp: t.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: t
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    let t = U_(this.performanceEntries).concat(this.replayPerformanceEntries);
    if (this.performanceEntries = [], this.replayPerformanceEntries = [], this._requiresManualStart) {
      const n = this._context.initialTimestamp / 1e3;
      t = t.filter((r) => r.start >= n);
    }
    return Promise.all(wr(this, t));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear(), this._context.traceIds.clear(), this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session: t, eventBuffer: n } = this;
    if (!t || !n || this._requiresManualStart || t.segmentId)
      return;
    const r = n.getEarliestTimestamp();
    r && r < this._context.initialTimestamp && (this._context.initialTimestamp = r);
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const t = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    return this._clearContext(), t;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const t = this.getSessionId();
    if (!this.session || !this.eventBuffer || !t) {
      C && x.error("No session or eventBuffer found to flush.");
      return;
    }
    if (await this._addPerformanceEntries(), !!this.eventBuffer?.hasEvents && (await rS(this), !!this.eventBuffer && t === this.getSessionId()))
      try {
        this._updateInitialTimestampFromEventBuffer();
        const n = Date.now();
        if (n - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
          throw new Error("Session is too long, not sending replay");
        const r = this._popEventContext(), s = this.session.segmentId++;
        this._maybeSaveSession();
        const i = await this.eventBuffer.finish();
        await yu({
          replayId: t,
          recordingData: i,
          segmentId: s,
          eventContext: r,
          session: this.session,
          timestamp: n,
          onError: (o) => this.handleException(o)
        });
      } catch (n) {
        this.handleException(n), this.stop({ reason: "sendReplay" });
        const r = U();
        if (r) {
          const s = n instanceof mi ? "ratelimit_backoff" : "send_error";
          r.recordDroppedEvent(s, "replay");
        }
      }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  async _flush({
    force: t = !1
  } = {}) {
    if (!this._isEnabled && !t)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      C && x.error("Attempting to finish replay event after session expired.");
      return;
    }
    if (!this.session)
      return;
    const n = this.session.started, s = Date.now() - n;
    this._debouncedFlush.cancel();
    const i = s < this._options.minReplayDuration, o = s > this._options.maxReplayDuration + 5e3;
    if (i || o) {
      C && x.log(
        `Session duration (${Math.floor(s / 1e3)}s) is too ${i ? "short" : "long"}, not sending replay.`
      ), i && this._debouncedFlush();
      return;
    }
    const c = this.eventBuffer;
    c && this.session.segmentId === 0 && !c.hasCheckout && C && x.log("Flushing initial segment without checkout.");
    const a = !!this._flushLock;
    this._flushLock || (this._flushLock = this._runFlush());
    try {
      await this._flushLock;
    } catch (u) {
      this.handleException(u);
    } finally {
      this._flushLock = void 0, a && this._debouncedFlush();
    }
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    this.session && this._options.stickySession && fi(this.session);
  }
  /** Handler for rrweb.record.onMutation */
  _onMutationHandler(t) {
    const { ignoreMutations: n } = this._options._experiments;
    if (n?.length && t.some((c) => {
      const a = dS(c.target), u = n.join(",");
      return a?.matches(u);
    }))
      return !1;
    const r = t.length, s = this._options.mutationLimit, i = this._options.mutationBreadcrumbLimit, o = s && r > s;
    if (r > i || o) {
      const c = Oe({
        category: "replay.mutations",
        data: {
          count: r,
          limit: o
        }
      });
      this._createCustomBreadcrumb(c);
    }
    return o ? (this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" }), !1) : !0;
  }
}
function Qt(e, t) {
  return [
    ...e,
    // sentry defaults
    ...t
  ].join(",");
}
function yS({ mask: e, unmask: t, block: n, unblock: r, ignore: s }) {
  const i = ["base", "iframe[srcdoc]:not([src])"], o = Qt(e, [".sentry-mask", "[data-sentry-mask]"]), c = Qt(t, []);
  return {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: o,
    unmaskTextSelector: c,
    blockSelector: Qt(n, [".sentry-block", "[data-sentry-block]", ...i]),
    unblockSelector: Qt(r, []),
    ignoreSelector: Qt(s, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'])
  };
}
function SS({
  el: e,
  key: t,
  maskAttributes: n,
  maskAllText: r,
  privacyOptions: s,
  value: i
}) {
  return !r || s.unmaskTextSelector && e.matches(s.unmaskTextSelector) ? i : n.includes(t) || // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  t === "value" && e.tagName === "INPUT" && ["submit", "button"].includes(e.getAttribute("type") || "") ? i.replace(/[\S]/g, "*") : i;
}
const Ho = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]', ES = ["content-length", "content-type", "accept"];
let Wo = !1;
const bS = (e) => new vS(e);
class vS {
  /**
   * @inheritDoc
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */
  constructor({
    flushMinDelay: t = Gm,
    flushMaxDelay: n = Ym,
    minReplayDuration: r = eg,
    maxReplayDuration: s = Eo,
    stickySession: i = !0,
    useCompression: o = !0,
    workerUrl: c,
    _experiments: a = {},
    maskAllText: u = !0,
    maskAllInputs: l = !0,
    blockAllMedia: d = !0,
    mutationBreadcrumbLimit: p = 750,
    mutationLimit: f = 1e4,
    slowClickTimeout: h = 7e3,
    slowClickIgnoreSelectors: m = [],
    networkDetailAllowUrls: g = [],
    networkDetailDenyUrls: E = [],
    networkCaptureBodies: R = !0,
    networkRequestHeaders: j = [],
    networkResponseHeaders: D = [],
    mask: A = [],
    maskAttributes: w = ["title", "placeholder", "aria-label"],
    unmask: y = [],
    block: T = [],
    unblock: b = [],
    ignore: k = [],
    maskFn: L,
    beforeAddRecordingEvent: H,
    beforeErrorSampling: P,
    onError: Z
  } = {}) {
    this.name = "Replay";
    const te = yS({
      mask: A,
      unmask: y,
      block: T,
      unblock: b,
      ignore: k
    });
    if (this._recordingOptions = {
      maskAllInputs: l,
      maskAllText: u,
      maskInputOptions: { password: !0 },
      maskTextFn: L,
      maskInputFn: L,
      maskAttributeFn: (X, S, q) => SS({
        maskAttributes: w,
        maskAllText: u,
        privacyOptions: te,
        key: X,
        value: S,
        el: q
      }),
      ...te,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: !0,
      // Disable inline images as it will increase segment/replay size
      inlineImages: !1,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: !0,
      errorHandler: (X) => {
        try {
          X.__rrweb__ = !0;
        } catch {
        }
      },
      // experimental support for recording iframes from different origins
      recordCrossOriginIframes: !!a.recordCrossOriginIframes
    }, this._initialOptions = {
      flushMinDelay: t,
      flushMaxDelay: n,
      minReplayDuration: Math.min(r, tg),
      maxReplayDuration: Math.min(s, Eo),
      stickySession: i,
      useCompression: o,
      workerUrl: c,
      blockAllMedia: d,
      maskAllInputs: l,
      maskAllText: u,
      mutationBreadcrumbLimit: p,
      mutationLimit: f,
      slowClickTimeout: h,
      slowClickIgnoreSelectors: m,
      networkDetailAllowUrls: g,
      networkDetailDenyUrls: E,
      networkCaptureBodies: R,
      networkRequestHeaders: jo(j),
      networkResponseHeaders: jo(D),
      beforeAddRecordingEvent: H,
      beforeErrorSampling: P,
      onError: Z,
      _experiments: a
    }, this._initialOptions.blockAllMedia && (this._recordingOptions.blockSelector = this._recordingOptions.blockSelector ? `${this._recordingOptions.blockSelector},${Ho}` : Ho), this._isInitialized && fo())
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    this._isInitialized = !0;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return Wo;
  }
  /** Update _isInitialized */
  set _isInitialized(t) {
    Wo = t;
  }
  /**
   * Setup and initialize replay container
   */
  afterAllSetup(t) {
    !fo() || this._replay || (this._setup(t), this._initialize(t));
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    this._replay && this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    this._replay && this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    return this._replay ? this._replay.stop({ forceFlush: this._replay.recordingMode === "session" }) : Promise.resolve();
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(t) {
    return this._replay ? this._replay.isEnabled() ? this._replay.sendBufferedReplayOrFlush(t) : (this._replay.start(), Promise.resolve()) : Promise.resolve();
  }
  /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */
  getReplayId(t) {
    if (this._replay?.isEnabled())
      return this._replay.getSessionId(t);
  }
  /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */
  getRecordingMode() {
    if (this._replay?.isEnabled())
      return this._replay.recordingMode;
  }
  /**
   * Initializes replay.
   */
  _initialize(t) {
    this._replay && (this._maybeLoadFromReplayCanvasIntegration(t), this._replay.initializeSampling());
  }
  /** Setup the integration. */
  _setup(t) {
    const n = TS(this._initialOptions, t);
    this._replay = new _S({
      options: n,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration(t) {
    try {
      const n = t.getIntegrationByName("ReplayCanvas");
      if (!n)
        return;
      this._replay._canvas = n.getOptions();
    } catch {
    }
  }
}
function TS(e, t) {
  const n = t.getOptions(), r = {
    sessionSampleRate: 0,
    errorSampleRate: 0,
    ...e
  }, s = _t(n.replaysSessionSampleRate), i = _t(n.replaysOnErrorSampleRate);
  return s == null && i == null && Ve(() => {
    console.warn(
      "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
    );
  }), s != null && (r.sessionSampleRate = s), i != null && (r.errorSampleRate = i), r;
}
function jo(e) {
  return [...ES, ...e.map((t) => t.toLowerCase())];
}
const zo = /* @__PURE__ */ new WeakMap(), Gr = /* @__PURE__ */ new Map(), Eu = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  trackFetchStreamPerformance: !1
};
function IS(e, t) {
  const {
    traceFetch: n,
    traceXHR: r,
    trackFetchStreamPerformance: s,
    shouldCreateSpanForRequest: i,
    enableHTTPTimings: o,
    tracePropagationTargets: c,
    onRequestSpanStart: a
  } = {
    ...Eu,
    ...t
  }, u = typeof i == "function" ? i : (f) => !0, l = (f) => kS(f, c), d = {}, p = e.getOptions().propagateTraceparent;
  n && (e.addEventProcessor((f) => (f.type === "transaction" && f.spans && f.spans.forEach((h) => {
    if (h.op === "http.client") {
      const m = Gr.get(h.span_id);
      m && (h.timestamp = m / 1e3, Gr.delete(h.span_id));
    }
  }), f)), s && op((f) => {
    if (f.response) {
      const h = zo.get(f.response);
      h && f.endTimestamp && Gr.set(h, f.endTimestamp);
    }
  }), ic((f) => {
    const h = Jf(f, u, l, d, {
      propagateTraceparent: p
    });
    if (f.response && f.fetchData.__span && zo.set(f.response, f.fetchData.__span), h) {
      const m = bu(f.fetchData.url), g = m ? mt(m).host : void 0;
      h.setAttributes({
        "http.url": m,
        "server.address": g
      }), o && qo(h), a?.(h, { headers: f.headers });
    }
  })), r && wc((f) => {
    const h = RS(
      f,
      u,
      l,
      d,
      p
    );
    if (h) {
      o && qo(h);
      let m;
      try {
        m = new Headers(f.xhr.__sentry_xhr_v3__?.request_headers);
      } catch {
      }
      a?.(h, { headers: m });
    }
  });
}
function wS(e) {
  return e.entryType === "resource" && "initiatorType" in e && typeof e.nextHopProtocol == "string" && (e.initiatorType === "fetch" || e.initiatorType === "xmlhttprequest");
}
function qo(e) {
  const { url: t } = $(e).data;
  if (!t || typeof t != "string")
    return;
  const n = yt("resource", ({ entries: r }) => {
    r.forEach((s) => {
      wS(s) && s.name.endsWith(t) && (e.setAttributes(vc(s)), setTimeout(n));
    });
  });
}
function kS(e, t) {
  const n = jt();
  if (n) {
    let r, s;
    try {
      r = new URL(e, n), s = new URL(n).origin;
    } catch {
      return !1;
    }
    const i = r.origin === s;
    return t ? $e(r.toString(), t) || i && $e(r.pathname, t) : i;
  } else {
    const r = !!e.match(/^\/(?!\/)/);
    return t ? $e(e, t) : r;
  }
}
function RS(e, t, n, r, s) {
  const i = e.xhr, o = i?.[dt];
  if (!i || i.__sentry_own_request__ || !o)
    return;
  const { url: c, method: a } = o, u = we() && t(c);
  if (e.endTimestamp && u) {
    const g = i.__sentry_xhr_span_id__;
    if (!g) return;
    const E = r[g];
    E && o.status_code !== void 0 && (ha(E, o.status_code), E.end(), delete r[g]);
    return;
  }
  const l = bu(c), d = mt(l || c), p = Sf(c), f = !!le(), h = u && f ? Ze({
    name: `${a} ${p}`,
    attributes: {
      url: c,
      type: "xhr",
      "http.method": a,
      "http.url": l,
      "server.address": d?.host,
      [ne]: "auto.http.browser",
      [ze]: "http.client",
      ...d?.search && { "http.query": d?.search },
      ...d?.hash && { "http.fragment": d?.hash }
    }
  }) : new Qe();
  i.__sentry_xhr_span_id__ = h.spanContext().spanId, r[i.__sentry_xhr_span_id__] = h, n(c) && CS(
    i,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    we() && f ? h : void 0,
    s
  );
  const m = U();
  return m && m.emit("beforeOutgoingRequestSpan", h, e), h;
}
function CS(e, t, n) {
  const { "sentry-trace": r, baggage: s, traceparent: i } = ec({ span: t, propagateTraceparent: n });
  r && xS(e, r, s, i);
}
function xS(e, t, n, r) {
  const s = e.__sentry_xhr_v3__?.request_headers;
  if (!(s?.["sentry-trace"] || !e.setRequestHeader))
    try {
      if (e.setRequestHeader("sentry-trace", t), r && !s?.traceparent && e.setRequestHeader("traceparent", r), n) {
        const i = s?.baggage;
        (!i || !MS(i)) && e.setRequestHeader("baggage", n);
      }
    } catch {
    }
}
function MS(e) {
  return e.split(",").some((t) => t.trim().startsWith("sentry-"));
}
function bu(e) {
  try {
    return new URL(e, z.location.origin).href;
  } catch {
    return;
  }
}
function AS() {
  z.document ? z.document.addEventListener("visibilitychange", () => {
    const e = le();
    if (!e)
      return;
    const t = de(e);
    if (z.document.hidden && t) {
      const n = "cancelled", { op: r, status: s } = $(t);
      Re && _.log(`[Tracing] Transaction: ${n} -> since tab moved to the background, op: ${r}`), s || t.setStatus({ code: ce, message: n }), t.setAttribute("sentry.cancellation_reason", "document.hidden"), t.end();
    }
  }) : Re && _.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const OS = 3600, vu = "sentry_previous_trace", NS = "sentry.previous_trace";
function DS(e, {
  linkPreviousTrace: t,
  consistentTraceSampling: n
}) {
  const r = t === "session-storage";
  let s = r ? FS() : void 0;
  e.on("spanStart", (o) => {
    if (de(o) !== o)
      return;
    const c = G().getPropagationContext();
    s = LS(s, o, c), r && PS(s);
  });
  let i = !0;
  n && e.on("beforeSampling", (o) => {
    if (!s)
      return;
    const c = G(), a = c.getPropagationContext();
    if (i && a.parentSpanId) {
      i = !1;
      return;
    }
    c.setPropagationContext({
      ...a,
      dsc: {
        ...a.dsc,
        sample_rate: String(s.sampleRate),
        sampled: String(Ts(s.spanContext))
      },
      sampleRand: s.sampleRand
    }), o.parentSampled = Ts(s.spanContext), o.parentSampleRate = s.sampleRate, o.spanAttributes = {
      ...o.spanAttributes,
      [fa]: s.sampleRate
    };
  });
}
function LS(e, t, n) {
  const r = $(t);
  function s() {
    try {
      return Number(n.dsc?.sample_rate) ?? Number(r.data?.[As]);
    } catch {
      return 0;
    }
  }
  const i = {
    spanContext: t.spanContext(),
    startTimestamp: r.start_timestamp,
    sampleRate: s(),
    sampleRand: n.sampleRand
  };
  if (!e)
    return i;
  const o = e.spanContext;
  return o.traceId === r.trace_id ? e : (Date.now() / 1e3 - e.startTimestamp <= OS && (Re && _.log(
    `Adding previous_trace ${o} link to span ${{
      op: r.op,
      ...t.spanContext()
    }}`
  ), t.addLink({
    context: o,
    attributes: {
      [ud]: "previous_trace"
    }
  }), t.setAttribute(
    NS,
    `${o.traceId}-${o.spanId}-${Ts(o) ? 1 : 0}`
  )), i);
}
function PS(e) {
  try {
    z.sessionStorage.setItem(vu, JSON.stringify(e));
  } catch (t) {
    Re && _.warn("Could not store previous trace in sessionStorage", t);
  }
}
function FS() {
  try {
    const e = z.sessionStorage?.getItem(vu);
    return JSON.parse(e);
  } catch {
    return;
  }
}
function Ts(e) {
  return e.traceFlags === 1;
}
const $S = "BrowserTracing", BS = {
  ...zn,
  instrumentNavigation: !0,
  instrumentPageLoad: !0,
  markBackgroundSpan: !0,
  enableLongTask: !0,
  enableLongAnimationFrame: !0,
  enableInp: !0,
  enableElementTiming: !0,
  ignoreResourceSpans: [],
  ignorePerformanceApiSpans: [],
  detectRedirects: !0,
  linkPreviousTrace: "in-memory",
  consistentTraceSampling: !1,
  enableReportPageLoaded: !1,
  _experiments: {},
  ...Eu
}, Vo = (e = {}) => {
  const t = {
    name: void 0,
    source: void 0
  }, n = z.document, {
    enableInp: r,
    enableElementTiming: s,
    enableLongTask: i,
    enableLongAnimationFrame: o,
    _experiments: { enableInteractions: c, enableStandaloneClsSpans: a, enableStandaloneLcpSpans: u },
    beforeStartSpan: l,
    idleTimeout: d,
    finalTimeout: p,
    childSpanTimeout: f,
    markBackgroundSpan: h,
    traceFetch: m,
    traceXHR: g,
    trackFetchStreamPerformance: E,
    shouldCreateSpanForRequest: R,
    enableHTTPTimings: j,
    ignoreResourceSpans: D,
    ignorePerformanceApiSpans: A,
    instrumentPageLoad: w,
    instrumentNavigation: y,
    detectRedirects: T,
    linkPreviousTrace: b,
    consistentTraceSampling: k,
    enableReportPageLoaded: L,
    onRequestSpanStart: H
  } = {
    ...BS,
    ...e
  };
  let P, Z, te;
  function X(S, q, I = !0) {
    const V = q.op === "pageload", re = q.name, ee = l ? l(q) : q, ve = ee.attributes || {};
    if (re !== ee.name && (ve[_e] = "custom", ee.attributes = ve), !I) {
      const Le = Et();
      Ze({
        ...ee,
        startTime: Le
      }).end(Le);
      return;
    }
    t.name = ee.name, t.source = ve[_e];
    const fe = La(ee, {
      idleTimeout: d,
      finalTimeout: p,
      childSpanTimeout: f,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: V,
      beforeSpanEnd: (Le) => {
        P?.(), gh(Le, {
          recordClsOnPageloadSpan: !a,
          recordLcpOnPageloadSpan: !u,
          ignoreResourceSpans: D,
          ignorePerformanceApiSpans: A
        }), Yo(S, void 0);
        const vt = G(), Kt = vt.getPropagationContext();
        vt.setPropagationContext({
          ...Kt,
          traceId: fe.spanContext().traceId,
          sampled: st(fe),
          dsc: qe(Le)
        }), V && (te = void 0);
      },
      trimIdleSpanEndTimestamp: !L
    });
    V && L && (te = fe), Yo(S, fe);
    function bt() {
      n && ["interactive", "complete"].includes(n.readyState) && S.emit("idleSpanEnableAutoFinish", fe);
    }
    V && !L && n && (n.addEventListener("readystatechange", () => {
      bt();
    }), bt());
  }
  return {
    name: $S,
    setup(S) {
      if ($d(), P = uh({
        recordClsStandaloneSpans: a || !1,
        recordLcpStandaloneSpans: u || !1,
        client: S
      }), r && Hh(), s && Ch(), o && B.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame") ? lh() : i && dh(), c && fh(), T && n) {
        const I = () => {
          Z = oe();
        };
        addEventListener("click", I, { capture: !0 }), addEventListener("keydown", I, { capture: !0, passive: !0 });
      }
      function q() {
        const I = hn(S);
        I && !$(I).timestamp && (Re && _.log(`[Tracing] Finishing current active span with op: ${$(I).op}`), I.setAttribute(an, "cancelled"), I.end());
      }
      S.on("startNavigationSpan", (I, V) => {
        if (U() !== S)
          return;
        if (V?.isRedirect) {
          Re && _.warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span."), X(
            S,
            {
              op: "navigation.redirect",
              ...I
            },
            !1
          );
          return;
        }
        Z = void 0, q(), De().setPropagationContext({
          traceId: je(),
          sampleRand: Math.random(),
          propagationSpanId: we() ? void 0 : Be()
        });
        const re = G();
        re.setPropagationContext({
          traceId: je(),
          sampleRand: Math.random(),
          propagationSpanId: we() ? void 0 : Be()
        }), re.setSDKProcessingMetadata({
          normalizedRequest: void 0
        }), X(S, {
          op: "navigation",
          ...I,
          // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
          parentSpan: null,
          forceTransaction: !0
        });
      }), S.on("startPageLoadSpan", (I, V = {}) => {
        if (U() !== S)
          return;
        q();
        const re = V.sentryTrace || Go("sentry-trace"), ee = V.baggage || Go("baggage"), ve = xd(re, ee), fe = G();
        fe.setPropagationContext(ve), we() || (fe.getPropagationContext().propagationSpanId = Be()), fe.setSDKProcessingMetadata({
          normalizedRequest: Ws()
        }), X(S, {
          op: "pageload",
          ...I
        });
      }), S.on("endPageloadSpan", () => {
        L && te && (te.setAttribute(an, "reportPageLoaded"), te.end());
      });
    },
    afterAllSetup(S) {
      let q = jt();
      if (b !== "off" && DS(S, { linkPreviousTrace: b, consistentTraceSampling: k }), z.location) {
        if (w) {
          const I = ye();
          US(S, {
            name: z.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: I ? I / 1e3 : void 0,
            attributes: {
              [_e]: "url",
              [ne]: "auto.pageload.browser"
            }
          });
        }
        y && br(({ to: I, from: V }) => {
          if (V === void 0 && q?.indexOf(I) !== -1) {
            q = void 0;
            return;
          }
          q = void 0;
          const re = Hs(I), ee = hn(S), ve = ee && T && WS(ee, Z);
          Tu(
            S,
            {
              name: re?.pathname || z.location.pathname,
              attributes: {
                [_e]: "url",
                [ne]: "auto.navigation.browser"
              }
            },
            { url: I, isRedirect: ve }
          );
        });
      }
      h && AS(), c && HS(S, d, p, f, t), r && zh(), IS(S, {
        traceFetch: m,
        traceXHR: g,
        trackFetchStreamPerformance: E,
        tracePropagationTargets: S.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest: R,
        enableHTTPTimings: j,
        onRequestSpanStart: H
      });
    }
  };
};
function US(e, t, n) {
  e.emit("startPageLoadSpan", t, n), G().setTransactionName(t.name);
  const r = hn(e);
  return r && e.emit("afterStartPageLoadSpan", r), r;
}
function Tu(e, t, n) {
  const { url: r, isRedirect: s } = n || {};
  e.emit("beforeStartNavigationSpan", t, { isRedirect: s }), e.emit("startNavigationSpan", t, { isRedirect: s });
  const i = G();
  return i.setTransactionName(t.name), r && !s && i.setSDKProcessingMetadata({
    normalizedRequest: {
      ...Ws(),
      url: r
    }
  }), hn(e);
}
function Go(e) {
  return z.document?.querySelector(`meta[name=${e}]`)?.getAttribute("content") || void 0;
}
function HS(e, t, n, r, s) {
  const i = z.document;
  let o;
  const c = () => {
    const a = "ui.action.click", u = hn(e);
    if (u) {
      const l = $(u).op;
      if (["navigation", "pageload"].includes(l)) {
        Re && _.warn(`[Tracing] Did not create ${a} span because a pageload or navigation span is in progress.`);
        return;
      }
    }
    if (o && (o.setAttribute(an, "interactionInterrupted"), o.end(), o = void 0), !s.name) {
      Re && _.warn(`[Tracing] Did not create ${a} transaction because _latestRouteName is missing.`);
      return;
    }
    o = La(
      {
        name: s.name,
        op: a,
        attributes: {
          [_e]: s.source || "url"
        }
      },
      {
        idleTimeout: t,
        finalTimeout: n,
        childSpanTimeout: r
      }
    );
  };
  i && addEventListener("click", c, { capture: !0 });
}
const Iu = "_sentry_idleSpan";
function hn(e) {
  return e[Iu];
}
function Yo(e, t) {
  be(e, Iu, t);
}
const Ko = 1.5;
function WS(e, t) {
  const n = $(e), r = Et(), s = n.start_timestamp;
  return !(r - s > Ko || t && r - t <= Ko);
}
const wu = ["activate", "mount"], ku = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, jS = /(?:^|[-_])(\w)/g, zS = (e) => e.replace(jS, (t) => t.toUpperCase()).replace(/[-_]/g, ""), qS = "<Root>", Yr = "<Anonymous>", VS = (e, t) => e.repeat(t), sn = (e, t) => {
  if (!e)
    return Yr;
  if (e.$root === e)
    return qS;
  if (!e.$options)
    return Yr;
  const n = e.$options;
  let r = n.name || n._componentTag || n.__name;
  const s = n.__file;
  if (!r && s) {
    const i = s.match(/([^/\\]+)\.vue$/);
    i && (r = i[1]);
  }
  return (r ? `<${zS(r)}>` : Yr) + (s && t !== !1 ? ` at ${s}` : "");
}, GS = (e) => {
  if (e && (e._isVue || e.__isVue) && e.$parent) {
    const t = [];
    let n = 0;
    for (; e; ) {
      if (t.length > 0) {
        const s = t[t.length - 1];
        if (s.constructor === e.constructor) {
          n++, e = e.$parent;
          continue;
        } else n > 0 && (t[t.length - 1] = [s, n], n = 0);
      }
      t.push(e), e = e.$parent;
    }
    return `

found in

${t.map(
      (s, i) => `${(i === 0 ? "---> " : VS(" ", 5 + i * 2)) + (Array.isArray(s) ? `${sn(s[0])}... (${s[1]} recursive calls)` : sn(s))}`
    ).join(`
`)}`;
  }
  return `

(found in ${sn(e)})`;
}, YS = (e, t) => {
  const { errorHandler: n } = e.config;
  e.config.errorHandler = (r, s, i) => {
    const o = sn(s, !1), c = s ? GS(s) : "", a = {
      componentName: o,
      lifecycleHook: i,
      trace: c
    };
    if (t.attachProps && s && (s.$options?.propsData ? a.propsData = s.$options.propsData : s.$props && (a.propsData = s.$props)), setTimeout(() => {
      yn(r, {
        captureContext: { contexts: { vue: a } },
        mechanism: { handled: !!n, type: "auto.function.vue.error_handler" }
      });
    }), typeof n == "function" && e.config.errorHandler)
      n.call(e, r, s, i);
    else
      throw r;
  };
}, Xo = "ui.vue", KS = {
  activate: ["activated", "deactivated"],
  create: ["beforeCreate", "created"],
  // Vue 3
  unmount: ["beforeUnmount", "unmounted"],
  // Vue 2
  destroy: ["beforeDestroy", "destroyed"],
  mount: ["beforeMount", "mounted"],
  update: ["beforeUpdate", "updated"]
};
function Kr(e, t, n) {
  e.$_sentryRootComponentSpanTimer && clearTimeout(e.$_sentryRootComponentSpanTimer), e.$_sentryRootComponentSpanTimer = setTimeout(() => {
    e.$root?.$_sentryRootComponentSpan && (e.$root.$_sentryRootComponentSpan.end(t), e.$root.$_sentryRootComponentSpan = void 0);
  }, n);
}
function XS(e, t) {
  function n(s) {
    return s.replace(/^<([^\s]*)>(?: at [^\s]*)?$/, "$1");
  }
  return e.some((s) => n(t) === n(s));
}
const JS = (e = {}) => {
  const t = (e.hooks || []).concat(wu).filter((s, i, o) => o.indexOf(s) === i), n = {}, r = e.timeout || 2e3;
  for (const s of t) {
    const i = KS[s];
    if (!i) {
      ku && _.warn(`Unknown hook: ${s}`);
      continue;
    }
    for (const o of i)
      n[o] = function() {
        const c = this.$root === this;
        c && (this.$_sentryRootComponentSpan = this.$_sentryRootComponentSpan || Ze({
          name: "Application Render",
          op: `${Xo}.render`,
          attributes: {
            [ne]: "auto.ui.vue"
          },
          onlyIfParent: !0
        }), Kr(this, oe(), r));
        const a = sn(this, !1);
        if (!(c || // We always want to track the root component
        (Array.isArray(e.trackComponents) ? XS(e.trackComponents, a) : e.trackComponents))) {
          Kr(this, oe(), r);
          return;
        }
        this.$_sentryComponentSpans = this.$_sentryComponentSpans || {};
        const l = o === i[0], d = this.$root?.$_sentryRootComponentSpan || le();
        if (l) {
          if (d) {
            const p = this.$_sentryComponentSpans[s];
            p && p.end(), this.$_sentryComponentSpans[s] = Ze({
              name: `Vue ${a}`,
              op: `${Xo}.${s}`,
              attributes: {
                [ne]: "auto.ui.vue"
              },
              // UI spans should only be created if there is an active root span (transaction)
              onlyIfParent: !0
            });
          }
        } else {
          const p = this.$_sentryComponentSpans[s];
          if (!p) return;
          p.end(), Kr(this, oe(), r);
        }
      };
  }
  return n;
}, QS = B, ZS = {
  Vue: QS.Vue,
  attachProps: !0,
  attachErrorHandler: !0,
  tracingOptions: {
    hooks: wu,
    timeout: 2e3,
    trackComponents: !1
  }
}, eE = "Vue", tE = (e = {}) => ({
  name: eE,
  setup(t) {
    const n = { ...ZS, ...t.getOptions(), ...e };
    if (!n.Vue && !n.app) {
      Ve(() => {
        console.warn(
          "[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured. Update your `Sentry.init` call with an appropriate config option: `app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2)."
        );
      });
      return;
    }
    n.app ? (Array.isArray(n.app) ? n.app : [n.app]).forEach((s) => Jo(s, n)) : n.Vue && Jo(n.Vue, n);
  }
}), Jo = (e, t) => {
  ku && e._instance?.isMounted === !0 && Ve(() => {
    console.warn(
      "[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`."
    );
  }), t.attachErrorHandler && YS(e, t), we(t) && e.mixin(JS(t.tracingOptions));
};
function nE(e = {}) {
  const t = {
    defaultIntegrations: [...Ac(), tE()],
    ...e
  };
  return Za(t, "vue"), jm(t);
}
function rE(e, t, n) {
  let r = !1;
  e.onError((s) => yn(s, { mechanism: { handled: !1 } })), e.beforeEach((s, i, o) => {
    const c = r ? void 0 : sE(), a = {};
    for (const d of Object.keys(s.params))
      a[`url.path.parameter.${d}`] = s.params[d], a[`params.${d}`] = s.params[d];
    for (const d of Object.keys(s.query)) {
      const p = s.query[d];
      p && (a[`query.${d}`] = p);
    }
    let u = s.path, l = "url";
    if (s.name && t.routeLabel !== "path")
      u = s.name.toString(), l = "custom";
    else if (s.matched.length > 0) {
      const d = s.matched.length - 1;
      u = s.matched[d].path, l = "route";
    }
    G().setTransactionName(u), t.instrumentPageLoad && c && ($(c).data[_e] !== "custom" && (c.updateName(u), c.setAttribute(_e, l)), c.setAttributes({
      ...a,
      [ne]: "auto.pageload.vue"
    }), r = !0), t.instrumentNavigation && !c && n({
      name: u,
      op: "navigation",
      attributes: {
        ...a,
        [ne]: "auto.navigation.vue",
        [_e]: l
      }
    }), o && o();
  });
}
function sE() {
  const e = le(), t = e && de(e);
  return t && $(t).op === "pageload" ? t : void 0;
}
function iE(e = {}) {
  if (!e.router)
    return Vo(e);
  const t = Vo({
    ...e,
    instrumentNavigation: !1
  }), { router: n, instrumentNavigation: r = !0, instrumentPageLoad: s = !0, routeLabel: i = "name" } = e;
  return {
    ...t,
    afterAllSetup(o) {
      t.afterAllSetup(o), rE(n, { routeLabel: i, instrumentNavigation: r, instrumentPageLoad: s }, (a) => {
        Tu(o, a);
      });
    }
  };
}
let Is = {
  debug: !1
};
function oE(e) {
  Is = {
    ...Is,
    ...e
  };
}
function Je() {
  return Is.debug;
}
function uE(e) {
  Je() && console.warn("[BugReporter] reportGlobalTags", e), G().setTags(e);
}
function dE(e) {
  Je() && console.warn("[BugReporter] reportIdentify", e), G().setUser(e);
}
function aE(e, t) {
  if (!e || !t || t.length === 0)
    return !1;
  try {
    const n = e.toLowerCase();
    for (const r of t)
      try {
        if (typeof r == "string") {
          if (n === r.toLowerCase())
            return !0;
        } else if (r instanceof RegExp && r.test(e))
          return !0;
      } catch (s) {
        console.warn(
          "[BugReporter] Error checking user agent pattern:",
          r,
          s
        );
        continue;
      }
    return !1;
  } catch (n) {
    return console.warn("[BugReporter] Error in shouldIgnoreUserAgent:", n), !1;
  }
}
function cE(e, t) {
  if (!t || t.length === 0)
    return !1;
  try {
    let n = e.request?.headers?.["User-Agent"] || e.contexts?.browser?.name || e.extra?.userAgent;
    !n && typeof navigator < "u" && (n = navigator.userAgent);
    const r = typeof n == "string" ? n : void 0;
    return aE(r, t) ? (Je() && console.warn(
      "[BugReporter] Ignoring event due to user agent filter:",
      r
    ), !0) : !1;
  } catch (n) {
    return Je() && console.warn("[BugReporter] Error checking user agent filter:", n), !1;
  }
}
function lE(e) {
  oE({ debug: e.debug ?? !1 });
  const t = [];
  e.router && t.push(
    iE({
      router: e.router
    })
  ), e.enableReplay && t.push(bS()), Je() && console.warn("[BugReporter] init", e);
  const n = e.vueVersion === 2 ? "Vue" : "app";
  nE({
    [n]: e.app,
    dsn: e.dsn,
    enabled: e.enabled ?? !0,
    release: e.release,
    environment: e.environment,
    integrations: t,
    tracePropagationTargets: e.tracingTargets ?? void 0,
    // The tracesSampleRate with default to capture 10%
    // of transactions for performance monitoring.
    tracesSampleRate: e.tracesSampleRate ?? 0.1,
    // Capture Replay with defaults for 1% of all sessions,
    // plus for 10% of sessions with an error
    replaysSessionSampleRate: e.replaysSessionSampleRate ?? 0.01,
    replaysOnErrorSampleRate: e.replaysOnErrorSampleRate ?? 0.1,
    denyUrls: e.denyUrls ?? [],
    ignoreErrors: e.ignoreErrors ?? [],
    beforeSend(r) {
      try {
        return cE(r, e.ignoreUserAgents) ? (Je() && console.warn("[BugReporter] Ignored due to user agent"), null) : r;
      } catch (s) {
        return Je() && console.warn("[BugReporter] Error in beforeSend:", s), r;
      }
    }
  });
}
function fE(e, t) {
  Je() && console.warn("[BugReporter] report", e, t), yn(e, {
    tags: t?.tags,
    extra: t?.extra ?? t?.context,
    contexts: {
      // @ts-expect-error This might not always conform to Sentry's standard context format.
      state: t?.state
    }
  });
}
const pE = [
  // Random plugins and extensions
  /googleapis/i,
  /googlebot/i,
  /googlest/i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  // Analytics
  /doubleclick\.net/i,
  /hotjar\./i,
  /netstats\.space/i,
  /pagead\/js/i,
  // Chrome extensions.
  /^chrome:\/\//i,
  /chrome-extension:/i,
  /extensions\//i,
  // Facebook.
  /connect\.facebook\.net\/en_US\/all\.js/i,
  /graph\.facebook\.com/i,
  // Safari extensions.
  /safari-web-extension:/i,
  /safari-extension:/i
], hE = [
  // Random plugins and extensions.
  // http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "atomicFindClose",
  "Can't find variable: ZiteReader",
  "canvas.contentDocument",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "http://tt.epicplay.com",
  "jigsaw is not defined",
  "miscellaneous_bindings",
  "MyApp_RemoveAllHighlights",
  "originalCreateNotification",
  "top.GLOBALS",
  // Generic error code from errors outside the security sandbox.
  "Script error.",
  // Analytics code.
  "vars.hotjar.com",
  "doubleclick.net",
  // Avast.
  "_avast_",
  // Facebook.
  "fb_xd_fragment",
  // Broadcom ASG error.
  "ICAP Error",
  // Bytemobile proxy.
  // http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // Conduit Toolbar.
  // http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  // Chrome for iOS bug.
  // https://groups.google.com/a/chromium.org/forum/#!topic/chromium-discuss/7VU0_VvC7mE
  "__gCrWeb",
  // Chromium bug.
  // https://bugs.chromium.org/p/chromium/issues/detail?id=97172
  "ntp is not defined",
  // Edge on iOS.
  "instantSearchSDKJSBridgeClearHighlight",
  // Firefox bug.
  // https://bugzilla.mozilla.org/show_bug.cgi?id=783260
  // http://stackoverflow.com/a/13101119
  'Permission denied to access property "toString"',
  // Firefox internals.
  "_firefox_",
  // Firefox freeing add-on memory.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Dead_object
  "can't access dead object",
  // Nuance Dragon Web Extension.
  "plugin.setSuspendState",
  // Safari bug.
  // https://bugs.webkit.org/show_bug.cgi?id=119472
  "promiseReactionJob",
  // SafeBrowse extension.
  "jQSB",
  // Commonly ignored errors of unknown origin.
  "androidInterface",
  "eshopcomp",
  "eval at C",
  "eval at E_c",
  "frameConnector_isForegroundChanged",
  "harkedtremblings",
  "kw__injected",
  "NPObject",
  "siteroot",
  "SymBrowser_",
  "touchDownX",
  "uiWebview_",
  "variable: inf",
  "Window.dologin",
  // Issue comes from Microsoft (Outlook scans link)
  // https://github.com/getsentry/sentry-javascript/issues/3440
  "Non-Error promise rejection captured with value: Object Not Found Matching Id:",
  // Issue caused when opening in a WebView by an iOS application,
  // especially for the Instagram or Facebook platforms
  // https://github.com/getsentry/sentry-javascript/issues/3040
  "window.webkit.messageHandlers",
  // https://sentry.io/answers/load-failed-javascript/
  /Load failed\.?$/,
  /^(?:[\w: ]+(:|-)\s)?Load failed(?: \([^)]+\))?$/,
  // https://sentry.io/answers/failed-to-fetch-javascript/
  /Failed to fetch\.?$/,
  /^(?:[\w: ]+(:|-)\s)?Failed to fetch(?: \([^)]+\))?$/
];
export {
  pE as denyUrls,
  hE as ignoreErrors,
  fE as report,
  uE as reportGlobalTags,
  dE as reportIdentify,
  lE as reportInit
};
